<template>
    <div class="space-bg-stage">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 2000 2000" style="enable-background:new 0 0 2000 2000;" xml:space="preserve">
            <g>
                <circle class="st0" cx="349.2" cy="392.8" r="2.4"/>
                <circle class="st0" cx="340.8" cy="328.1" r="2.4"/>
                <circle class="st0" cx="297.9" cy="382.5" r="2.4"/>
                <circle class="st0" cx="297.9" cy="330.5" r="2.4"/>
                <circle class="st0" cx="229.9" cy="375.6" r="2.4"/>
                <circle class="st0" cx="255" cy="323.6" r="2.4"/>
                <circle class="st0" cx="287.1" cy="255.3" r="2.4"/>
                <circle class="st0" cx="278.5" cy="305.2" r="2.4"/>
                <circle class="st0" cx="223" cy="291.6" r="2.4"/>
                <circle class="st0" cx="218.3" cy="342.4" r="2.4"/>
                <circle class="st0" cx="163.5" cy="389.5" r="2.4"/>
                <circle class="st0" cx="246.1" cy="439.8" r="2.4"/>
            </g>
            <g>
                <circle class="st0" cx="349.2" cy="392.8" r="2.4"/>
                <circle class="st0" cx="340.8" cy="328.1" r="2.4"/>
                <circle class="st0" cx="297.9" cy="382.5" r="2.4"/>
                <circle class="st0" cx="297.9" cy="330.5" r="2.4"/>
                <circle class="st0" cx="229.9" cy="375.6" r="2.4"/>
                <circle class="st0" cx="255" cy="323.6" r="2.4"/>
                <circle class="st0" cx="287.1" cy="255.3" r="2.4"/>
                <circle class="st0" cx="278.5" cy="305.2" r="2.4"/>
                <circle class="st0" cx="223" cy="291.6" r="2.4"/>
                <circle class="st0" cx="218.3" cy="342.4" r="2.4"/>
                <circle class="st0" cx="163.5" cy="389.5" r="2.4"/>
                <circle class="st0" cx="246.1" cy="439.8" r="2.4"/>
            </g>
            <g>
                <circle class="st0" cx="349.2" cy="392.8" r="2.4"/>
                <circle class="st0" cx="340.8" cy="328.1" r="2.4"/>
                <circle class="st0" cx="297.9" cy="382.5" r="2.4"/>
                <circle class="st0" cx="297.9" cy="330.5" r="2.4"/>
                <circle class="st0" cx="229.9" cy="375.6" r="2.4"/>
                <circle class="st0" cx="255" cy="323.6" r="2.4"/>
                <circle class="st0" cx="287.1" cy="255.3" r="2.4"/>
                <circle class="st0" cx="278.5" cy="305.2" r="2.4"/>
                <circle class="st0" cx="223" cy="291.6" r="2.4"/>
                <circle class="st0" cx="218.3" cy="342.4" r="2.4"/>
                <circle class="st0" cx="163.5" cy="389.5" r="2.4"/>
                <circle class="st0" cx="246.1" cy="439.8" r="2.4"/>
            </g>
            <g>
                <circle class="st0" cx="349.2" cy="392.8" r="2.4"/>
                <circle class="st0" cx="340.8" cy="328.1" r="2.4"/>
                <circle class="st0" cx="297.9" cy="382.5" r="2.4"/>
                <circle class="st0" cx="297.9" cy="330.5" r="2.4"/>
                <circle class="st0" cx="229.9" cy="375.6" r="2.4"/>
                <circle class="st0" cx="255" cy="323.6" r="2.4"/>
                <circle class="st0" cx="287.1" cy="255.3" r="2.4"/>
                <circle class="st0" cx="278.5" cy="305.2" r="2.4"/>
                <circle class="st0" cx="223" cy="291.6" r="2.4"/>
                <circle class="st0" cx="218.3" cy="342.4" r="2.4"/>
                <circle class="st0" cx="163.5" cy="389.5" r="2.4"/>
                <circle class="st0" cx="246.1" cy="439.8" r="2.4"/>
            </g>
            <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="114.2387" y1="-2047.6057" x2="1600.5415" y2="-236.0331" gradientTransform="matrix(1 0 0 1 0 1968)">
                <stop  offset="0.2762" style="stop-color:#171344"/>
                <stop  offset="0.6124" style="stop-color:#612A81"/>
                <stop  offset="0.8402" style="stop-color:#171344"/>
            </linearGradient>
            <rect class="st1" width="2000" height="2000"/>
            <g class="st2">
                
                    <radialGradient id="SVGID_2_" cx="652.4672" cy="1404.0961" r="368.4312" gradientTransform="matrix(0.4338 0.901 -0.901 0.4338 2298.1936 687.3735)" gradientUnits="userSpaceOnUse">
                    <stop  offset="0.1163" style="stop-color:#00A5DA"/>
                    <stop  offset="0.213" style="stop-color:#00A1D6"/>
                    <stop  offset="0.3316" style="stop-color:#0097CC"/>
                    <stop  offset="0.4617" style="stop-color:#0088BD"/>
                    <stop  offset="0.6001" style="stop-color:#0075AA"/>
                    <stop  offset="0.745" style="stop-color:#165E95"/>
                    <stop  offset="0.893" style="stop-color:#28417F"/>
                    <stop  offset="1" style="stop-color:#2E286F"/>
                </radialGradient>
                <circle class="st3" cx="1316.1" cy="1884.3" r="368.3"/>
                
                    <radialGradient id="SVGID_3_" cx="602.254" cy="1408.0353" r="268.9567" gradientTransform="matrix(0.4338 0.901 -0.901 0.4338 2298.1936 687.3735)" gradientUnits="userSpaceOnUse">
                    <stop  offset="0.1163" style="stop-color:#00A5DA"/>
                    <stop  offset="0.213" style="stop-color:#00A1D6"/>
                    <stop  offset="0.3316" style="stop-color:#0097CC"/>
                    <stop  offset="0.4617" style="stop-color:#0088BD"/>
                    <stop  offset="0.6001" style="stop-color:#0075AA"/>
                    <stop  offset="0.745" style="stop-color:#165E95"/>
                    <stop  offset="0.893" style="stop-color:#28417F"/>
                    <stop  offset="1" style="stop-color:#2E286F"/>
                </radialGradient>
                <circle class="st4" cx="1290.8" cy="1840.8" r="268.9"/>
                
                    <radialGradient id="SVGID_4_" cx="522.1284" cy="1420.8981" r="149.2118" gradientTransform="matrix(0.4338 0.901 -0.901 0.4338 2298.1936 687.3735)" gradientUnits="userSpaceOnUse">
                    <stop  offset="0.1163" style="stop-color:#00A5DA"/>
                    <stop  offset="0.213" style="stop-color:#00A1D6"/>
                    <stop  offset="0.3316" style="stop-color:#0097CC"/>
                    <stop  offset="0.4617" style="stop-color:#0088BD"/>
                    <stop  offset="0.6001" style="stop-color:#0075AA"/>
                    <stop  offset="0.745" style="stop-color:#165E95"/>
                    <stop  offset="0.893" style="stop-color:#28417F"/>
                    <stop  offset="1" style="stop-color:#2E286F"/>
                </radialGradient>
                <circle class="st5" cx="1244.5" cy="1774.2" r="149.2"/>
            </g>
            <linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="343.9002" y1="-372.1635" x2="472.6529" y2="-518.9867" gradientTransform="matrix(1 0 0 1 0 1968)">
                <stop  offset="0.2723" style="stop-color:#2D2D73"/>
                <stop  offset="0.9418" style="stop-color:#171344"/>
            </linearGradient>
            <circle class="st6" cx="391.9" cy="1541.1" r="151.7"/>
            <radialGradient id="SVGID_6_" cx="237.4" cy="-353.2" r="75.7" gradientTransform="matrix(1 0 0 1 0 1968)" gradientUnits="userSpaceOnUse">
                <stop  offset="0.1163" style="stop-color:#F15B35"/>
                <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                <stop  offset="0.348" style="stop-color:#DF5542"/>
                <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                <stop  offset="0.6367" style="stop-color:#B1445D"/>
                <stop  offset="0.7926" style="stop-color:#923A6C"/>
                <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                <stop  offset="1" style="stop-color:#612A81"/>
            </radialGradient>
            <circle class="st7" cx="237.4" cy="1614.8" r="75.7"/>
            <g class="st8">
                
                    <radialGradient id="SVGID_7_" cx="1359.8" cy="-1420" r="353.3" gradientTransform="matrix(1 0 0 1 0 1968)" gradientUnits="userSpaceOnUse">
                    <stop  offset="0.1163" style="stop-color:#F15B35"/>
                    <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                    <stop  offset="0.348" style="stop-color:#DF5542"/>
                    <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                    <stop  offset="0.6367" style="stop-color:#B1445D"/>
                    <stop  offset="0.7926" style="stop-color:#923A6C"/>
                    <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                    <stop  offset="1" style="stop-color:#612A81"/>
                </radialGradient>
                <circle class="st9" cx="1359.8" cy="548" r="353.3"/>
                
                    <radialGradient id="SVGID_8_" cx="1359.8" cy="-1413.4" r="199.1" gradientTransform="matrix(1 0 0 1 0 1968)" gradientUnits="userSpaceOnUse">
                    <stop  offset="0.1163" style="stop-color:#F15B35"/>
                    <stop  offset="0.7973" style="stop-color:#612A81"/>
                </radialGradient>
                <circle class="st10" cx="1359.8" cy="554.6" r="199.1"/>
                
                    <radialGradient id="SVGID_9_" cx="1359.8" cy="-1413.4" r="112.2" gradientTransform="matrix(1 0 0 1 0 1968)" gradientUnits="userSpaceOnUse">
                    <stop  offset="0.1163" style="stop-color:#F15B35"/>
                    <stop  offset="0.7973" style="stop-color:#612A81"/>
                </radialGradient>
                <circle class="st11" cx="1359.8" cy="554.6" r="112.2"/>
            </g>
            <linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="283.8518" y1="-1579.8206" x2="441.1571" y2="-1759.2037" gradientTransform="matrix(1 0 0 1 0 1968)">
                <stop  offset="0.2536" style="stop-color:#555496"/>
                <stop  offset="0.9418" style="stop-color:#612A81"/>
            </linearGradient>
            <circle class="st12" cx="342.5" cy="321.3" r="185.3"/>
            <linearGradient id="SVGID_11_" gradientUnits="userSpaceOnUse" x1="1741.2473" y1="-1262.6627" x2="1826.9424" y2="-1360.3853" gradientTransform="matrix(1 0 0 1 0 1968)">
                <stop  offset="0.2536" style="stop-color:#555496"/>
                <stop  offset="0.9418" style="stop-color:#612A81"/>
            </linearGradient>
            <circle class="st13" cx="1773.2" cy="668.9" r="100.9"/>
            <linearGradient id="SVGID_12_" gradientUnits="userSpaceOnUse" x1="-656.4" y1="-2009.9" x2="-518.6" y2="-2009.9" gradientTransform="matrix(1 0 0 1 0 1968)">
                <stop  offset="0.2723" style="stop-color:#2D2D73"/>
                <stop  offset="0.9418" style="stop-color:#171344"/>
            </linearGradient>
            <rect x="-656.4" y="-110.8" class="st14" width="137.8" height="137.8"/>
            <rect x="-832.1" y="-110.8" class="st15" width="137.8" height="137.8"/>
            <circle class="st16" cx="2456" cy="-265.5" r="88.5"/>
            <linearGradient id="SVGID_13_" gradientUnits="userSpaceOnUse" x1="1233.9144" y1="-766.0307" x2="1398.7793" y2="-82.2468" gradientTransform="matrix(1 0 0 1 0 1968)">
                <stop  offset="0.2723" style="stop-color:#2D2D73"/>
                <stop  offset="0.9418" style="stop-color:#171344"/>
            </linearGradient>
            <path class="st17" d="M481.6,2107.5c24.6,8.4,48.1-14.7,62-36.6c18.5-29,33.2-60.5,43.6-93.3c7.1-22.4,12.3-45.6,23.3-66.3
                s29.1-39.3,52.1-43.7c20.1-3.9,40.4,3.3,60.7,6s44.6-1.4,54.2-19.5c4.8-9.1,4.8-19.9,4.5-30.2c-2.7-81.1-19.6-162.4-8.6-242.8
                c2-14.9,5.3-30.3,14.3-42.4s25.3-20,39.5-15.1c14.6,5,22.4,21.1,24.9,36.2s1.5,31,5.8,45.8c9.8,33.6,44.4,53.3,77.5,64.6
                c14.7,5,31.3,8.9,45.1,1.9c9.7-4.9,16.2-14.5,20.8-24.3c20.4-44,8.5-95.4-1.5-142.9c-7.5-35.9-13.7-72-18.5-108.3
                c-4.5-33.7-7.7-68.6,2.2-101.1c13.7-44.8,53.5-80.5,99.5-89.3s96.2,9.7,125.4,46.3c31.4,39.3,37.2,92.3,47.7,141.5
                c26.6,124.2,91.7,239.9,184,327.1c10.2,9.7,22.6,19.6,36.6,18.3c7.4-0.7,14.1-4.5,20.3-8.6c57.6-38.9,81.3-112.1,89.6-181.2
                c8.3-69,5.5-140.3,27.5-206.3c21.5-64.6,58.1-121.2,117.4-154.7s147.1-24.7,180.7,34.6c19.6,34.8,17.9,79.9,42.8,111.1
                c35.5,44.3,107.6,40.4,147.6,80.7c33.5,33.7,35.2,89,65.7,125.4c33.6,40,94.4,48.4,128.1,88.3c23.4,27.7,29.7,66.1,29.8,102.4
                c0.4,135.3-70.6,259.7-144.4,373.1c-16.6,25.4-33.8,51.2-57.7,69.9c-25,19.6-55.8,30.3-86.5,38.6c-135.7,36.5-278.6,30.6-418.5,43.6
                c-159,14.8-314.8,54-473.3,73.6s-324.5,18.4-471.4-44.3c-10.7-4.6-21.6-9.8-28.8-18.9c-8.8-11.2-10.4-26.4-16.7-39.2
                c-14.2-29-48.5-40.7-78.3-53C520.8,2162.2,482,2139.8,481.6,2107.5z"/>
            <linearGradient id="SVGID_14_" gradientUnits="userSpaceOnUse" x1="859.7838" y1="-1352.6135" x2="-13.1892" y2="-1352.6135" gradientTransform="matrix(1 0 0 1 0 1968)">
                <stop  offset="0.2723" style="stop-color:#2D2D73"/>
                <stop  offset="0.9418" style="stop-color:#171344"/>
            </linearGradient>
            <path class="st18" d="M32.7,354.5c60.2-30.7,129.3-47.1,196.1-36.6c109.5,17.3,204.3,103.9,315,97.9c76.8-4.1,142.9-52.2,208.9-91.7
                s146.4-72.5,217.9-44.5c40.4,15.8,71.4,49,108.9,70.9c53.3,31.1,120.2,37.9,178.7,18.1c-38.9,22.5-80.4,45.7-125.3,44.4
                c-28.8-0.8-56.2-11.8-83.7-20.3c-70.1-21.8-146.4-28.5-217-8.2c-76.2,21.9-141.7,74.4-186.6,139.7c-31.4,45.7-53.3,97.3-85,142.8
                s-76.7,86.1-131.6,93.5c-77.9,10.6-153.4-47.5-231.1-35.4c-32.2,5-61.3,21.7-88.7,39.2C30.9,814.3-43.7,877-81.7,961.6
                C-122.5,888-141,802.3-134,718.5c5.4-65.8,26.9-130.2,25.9-196.5c-0.3-17.7-7.9-38.6-1.4-55.7c4-10.6,12.9-18.5,21.1-25.9
                c11.3-10.2,23-20.1,34.9-29.6C-26.6,389.4,2,370.1,32.7,354.5z"/>
            <g>
                <circle class="st0" cx="349.2" cy="392.8" r="2.4"/>
                <circle class="st0" cx="340.8" cy="328.1" r="2.4"/>
                <circle class="st0" cx="297.9" cy="382.5" r="2.4"/>
                <circle class="st0" cx="297.9" cy="330.5" r="2.4"/>
                <circle class="st0" cx="229.9" cy="375.6" r="2.4"/>
                <circle class="st0" cx="255" cy="323.6" r="2.4"/>
                <circle class="st0" cx="287.1" cy="255.3" r="2.4"/>
                <circle class="st0" cx="278.5" cy="305.2" r="2.4"/>
                <circle class="st0" cx="223" cy="291.6" r="2.4"/>
                <circle class="st0" cx="218.3" cy="342.4" r="2.4"/>
                <circle class="st0" cx="163.5" cy="389.5" r="2.4"/>
                <circle class="st0" cx="246.1" cy="439.8" r="2.4"/>
            </g>
            <g>
                <circle class="st0" cx="349.2" cy="392.8" r="2.4"/>
                <circle class="st0" cx="340.8" cy="328.1" r="2.4"/>
                <circle class="st0" cx="297.9" cy="382.5" r="2.4"/>
                <circle class="st0" cx="297.9" cy="330.5" r="2.4"/>
                <circle class="st0" cx="229.9" cy="375.6" r="2.4"/>
                <circle class="st0" cx="255" cy="323.6" r="2.4"/>
                <circle class="st0" cx="287.1" cy="255.3" r="2.4"/>
                <circle class="st0" cx="278.5" cy="305.2" r="2.4"/>
                <circle class="st0" cx="223" cy="291.6" r="2.4"/>
                <circle class="st0" cx="218.3" cy="342.4" r="2.4"/>
                <circle class="st0" cx="163.5" cy="389.5" r="2.4"/>
                <circle class="st0" cx="246.1" cy="439.8" r="2.4"/>
            </g>
            <linearGradient id="SVGID_15_" gradientUnits="userSpaceOnUse" x1="796.5323" y1="-1302.2456" x2="1176.0142" y2="-687.8469" gradientTransform="matrix(1 0 0 1 0 1968)">
                <stop  offset="0.1163" style="stop-color:#171344"/>
                <stop  offset="0.5309" style="stop-color:#2D2D73"/>
                <stop  offset="0.7973" style="stop-color:#171344"/>
            </linearGradient>
            <path class="st19" d="M148.8,2200.9c12.1-90.3-4.3-181.9-0.4-272.9s34.6-189.6,112.5-236.8c28.4-17.2,60.9-26.2,90.2-41.7
                c164.2-87.1,167.3-332.3,307.2-454.6c25.1-22,54.7-39.5,87.2-47c43.9-10,89.8-1.2,134.6-5.1c55-4.9,108.1-29.9,146.8-69.3
                c54.1-55,90.9-142.1,167.7-150.5c70.9-7.7,129.8,60.4,200.9,65.5c54.3,3.9,104.2-29.8,142.9-68.1c38.7-38.3,71.9-83.2,118-112.2
                c61.8-38.9,143.6-43.5,209.4-11.8c36.2,17.5,67.5,44.9,105.3,58.5c92,33.1,190.7-23.7,267.2-84.5c-18.1,6.9-34.5-13.1-42.8-30.6
                c-45.1-94.5-62.2-202.2-48.7-306.1c16.4-125.4,4.7-251.8,4.7-378.3C2101,168,2037.5,280.2,1953.7,371S1747.3,526,1625,508.1
                c-37.2-5.4-73.4-18.2-111-18.4c-86.4-0.3-158.5,64.7-212.3,132.3s-102,144.4-178,185.5c-85.4,46.2-188.4,37.9-285.5,36.1
                c-97.1-1.8-204.6,8.4-271.5,78.7c-59.3,62.3-70.5,154.5-99.1,235.6c-26.7,75.8-70.9,145.4-128.1,201.8
                c-27.6,27.2-60.1,52.3-98.4,58.5c-83.2,13.3-155.2-64.8-239.3-70.6c-15.1-1.1-31.2,0.6-43.3,9.7c-15.3,11.6-20.3,32.1-24,51
                c-28.3,146.2-37.2,296.3-26.2,444.8c5.6,76.2-13.8,157.1,26.7,221.9C-24.4,2139.7,73.9,2185.7,148.8,2200.9z"/>
            <path class="st20" d="M521.9,545.7c45,87.6,131.8,152.6,228.6,171c34.5,6.6,71,7.4,104.1-4.5c33.8-12.2,61.8-36.9,84.7-64.6
                c75.4-91.1,101-220.9,65.8-333.8c-19.1-61.2-56.5-118.4-111.3-151.6c-49.8-30.1-108.6-38-165-47.4c-28.4-4.7-56.8-9.9-84.3-18.4
                c-26.2-8.1-53.7-24.8-81.9-22.6c-42.2,3.2-45.9,64.1-53.6,95.3c-14.6,59.7-25.8,120.8-27.2,182.4
                C480.2,418.3,491.2,485.8,521.9,545.7z"/>
            <path class="st20" d="M746.4,169.2c-38.3-10.9-81.6-9-115.6,11.9c-31.9,19.6-52.8,54.1-61.3,90.5s-5.8,74.7,1.6,111.3
                c13.5,66.5,44.8,132.5,100.6,171.1c55.8,38.6,139,41.6,187.6-5.7c19.9-19.4,32.6-45,43.5-70.5c20.4-47.8,36.5-99.7,29-151.2
                c-5.2-35.4-23.5-68.5-51.7-90.7c-22.3-17.6-49.9-24.6-74-39.3C787.4,185.1,767.7,175.3,746.4,169.2z"/>
            <path class="st21" d="M1024.4,719.4c-64.8-35-140.1-46.2-213.7-45.8c-42.1,0.2-84.9,4.2-124,19.8c-33.5,13.4-63.4,35.1-88.4,61.1
                c-66,68.8-96.4,167.9-89.3,262.9c7.1,95.1,49.7,185.7,111.7,258.1c34,39.8,75,75.2,123.9,93.8c105.5,40,227.9-7.8,308.5-86.8
                c63.9-62.7,106.7-148.4,116.7-237.5c5.1-44.7-2.2-86.7-8.3-130.8c-4.2-30.4-9.1-57.4-24.9-84.3
                C1109.3,783.7,1072,745.1,1024.4,719.4z"/>
            <path class="st20" d="M961.2,902.8c-33.1-44.7-73.6-93.7-129.2-96.3c-33.1-1.6-64.8,14.5-91.1,34.7
                c-70.2,53.9-113.3,142.2-110.6,230.7c1.1,34.7,9.1,69.9,28.1,98.9c29.6,45.2,84.1,71,138.2,72.5s107.2-19.4,150.8-51.3
                c69.7-50.9,96.3-142.6,57.5-221C993,946.7,977.3,924.5,961.2,902.8z"/>
            <path class="st21" d="M207.4,503.6c38.8,18.4,73.7,45.1,114.4,58.9c61.8,21,134,8.4,185-32.3c-14.3,65.5-87.9,100.9-154.8,105.2
                s-134-12.5-200.7-6.2C57.7,637.9-25.2,690.6-104,741.9c13.5-72.6,33.7-143.9,60.4-212.7c0.8-2-23.8-8.9-22.5-16.5
                c0.9-5.5,20.9-11.7,25.8-13.7c19-8,38.9-14,59.1-17.9c40.5-7.9,82.6-7.8,123,0.7C164.4,486.4,186.5,493.7,207.4,503.6z"/>
            <rect x="-832.1" y="-298.2" class="st22" width="137.8" height="137.8"/>
            <rect x="-656.4" y="-298.2" class="st22" width="137.8" height="137.8"/>
            <rect x="-499.2" y="-315.2" class="st23" width="155.8" height="155.8"/>
            <rect x="-1223.2" y="-197.7" class="st24" width="173.9" height="173.9"/>
            <path class="st21" d="M2098.7,450.3c-72.8-30.8-155.9,16.9-208.3,76.1s-91,132.5-156.1,177.3c-142,97.9-348.5,23.5-500.1,105.8
                c-59,32-104.9,85.8-166.4,112.8c-68.6,30.1-147,23.2-221,34.9c-71.7,11.3-139.2,40.2-205.8,68.8c-26.5,11.4-53.7,23.3-73.8,44
                c-45.2,46.8-39.9,120.5-43.3,185.5c-5.7,111.3-138,184.1-245.5,213.5c-43.1,11.8-88.2,15.2-131.4,26.8
                c-182.5,48.7-304,259.7-254.7,442.2c61.4-145.8,133.9-303.6,276.5-371.9c92.8-44.5,213.6-50.7,270.9-136.2
                c-74.5,161.4-315.9,191.5-386,354.9C14.1,1877.3,43,1983.9,32,2084c10.4-151,82.8-296.9,196.7-396.5
                c42.6-37.3,90.5-68.2,133.8-104.8c84.1-71.2,149.7-164.2,188.5-267.4c22.7-60.3,36.9-125,73.7-177.9
                c45.7-65.7,121.2-105.1,198.3-126.5s157.5-27,236.5-39.7c60.1-9.7,122.2-24.8,168.6-64.2c10.4-8.8,20.2-24.5,11.4-34.8
                c243.6,20.1,507.2-55.3,659.7-246.3c31.2-39.1,57.5-82.4,93.9-116.8C2029.3,474.7,2049.6,441.2,2098.7,450.3z"/>
            <linearGradient id="SVGID_16_" gradientUnits="userSpaceOnUse" x1="1716.2145" y1="-1608.2014" x2="1698.1439" y2="-2109.6594" gradientTransform="matrix(1 0 0 1 0 1968)">
                <stop  offset="0.2723" style="stop-color:#612A81"/>
                <stop  offset="0.9418" style="stop-color:#171344"/>
            </linearGradient>
            <path class="st25" d="M1396.3-200.7c22.1,65.5,39.5,132.5,52.2,200.4c7.6,40.7,13.4,83.2,1.9,122.9c-10.6,36.8-35,67.7-54.3,100.8
                c-22,37.7-37.5,79.2-45.8,122.1c-2.6,13.5-4.3,28.4,3,40.1c10.6,17.1,34.4,18.9,54.5,18.4c61.9-1.4,126.1-7,179.7-38
                c56.5-32.7,95.2-91.3,113-154.1s16.5-129.8,6.7-194.3c-7.5-49.5-20-98.6-20.3-148.7s13.3-103,50-137.1
                c36.6-34.1,99.8-41.8,136.1-7.3c16.7,15.9,26,38.5,29.6,61.3c8.4,53.1-11.1,106.5-12,160.3s29.6,117.3,83.3,118.8
                c29.5,0.8,56.9-18.7,72.2-44s20.2-55.5,21.7-85c4.5-90-21.2-181.1-71.3-255.9c-25.7-38.4-58.3-73.1-98.7-95.5
                c-30.5-17-64.7-26.5-99.1-32.7c-75-13.5-153.4-9-226.5,12.6c-72.3,21.4-140.1,60.4-190.5,116.9c-13.4,15-26.7,30.6-18,51.4
                C1373.4-244.4,1388.1-224.9,1396.3-200.7z"/>
            <path class="st20" d="M1018.7,636.6c47.5-111.8,38.7-261.6-23-394.4c-22-47.4-51.3-93.5-90-127.3c-39.6-34.5-86.4-53.9-131.9-65
                C624,13.4,477.7,63.7,397.8,179.3C354.5,242,330,325,343.2,414.7c11.9,81.4,52.8,160,90,236.5c18.8,38.5,37.2,77.3,51.6,117.1
                c13.7,37.9,20.2,82.9,45.5,116.8c37.8,50.7,99.5,16.8,136,6.6c69.6-19.6,137.7-44.3,198.3-81.6
                C930.2,769.5,986.3,713.1,1018.7,636.6z"/>
            <circle class="st0" cx="696.8" cy="1067.8" r="7.3"/>
            <circle class="st0" cx="1006.8" cy="464.7" r="7.3"/>
            <circle class="st0" cx="1430.3" cy="1504.9" r="7.3"/>
            <circle class="st0" cx="832.3" cy="1633.6" r="7.3"/>
            <circle class="st0" cx="466.4" cy="1532" r="7.3"/>
            <circle class="st0" cx="1545.5" cy="268.2" r="7.3"/>
            <g>
                <circle class="st0" cx="349.2" cy="392.8" r="2.4"/>
                <circle class="st0" cx="340.8" cy="328.1" r="2.4"/>
                <circle class="st0" cx="297.9" cy="382.5" r="2.4"/>
                <circle class="st0" cx="297.9" cy="330.5" r="2.4"/>
                <circle class="st0" cx="229.9" cy="375.6" r="2.4"/>
                <circle class="st0" cx="255" cy="323.6" r="2.4"/>
                <circle class="st0" cx="287.1" cy="255.3" r="2.4"/>
                <circle class="st0" cx="278.5" cy="305.2" r="2.4"/>
                <circle class="st0" cx="223" cy="291.6" r="2.4"/>
                <circle class="st0" cx="218.3" cy="342.4" r="2.4"/>
                <circle class="st0" cx="163.5" cy="389.5" r="2.4"/>
                <circle class="st0" cx="246.1" cy="439.8" r="2.4"/>
            </g>
            <circle class="st0" cx="805.2" cy="710.3" r="2.4"/>
            <g class="st26">
                <circle class="st0" cx="1374.7" cy="579.4" r="2.4"/>
                <circle class="st0" cx="1366.3" cy="514.8" r="2.4"/>
                <circle class="st0" cx="1323.4" cy="569.2" r="2.4"/>
                <circle class="st0" cx="1323.4" cy="517.1" r="2.4"/>
                <circle class="st0" cx="1255.4" cy="562.2" r="2.4"/>
                <circle class="st0" cx="1280.5" cy="510.3" r="2.4"/>
                <circle class="st0" cx="1312.7" cy="441.9" r="2.4"/>
                <circle class="st0" cx="1304" cy="491.8" r="2.4"/>
                <circle class="st0" cx="1248.5" cy="478.3" r="2.4"/>
                <circle class="st0" cx="1243.8" cy="529.1" r="2.4"/>
                <circle class="st0" cx="1189" cy="576.1" r="2.4"/>
                <circle class="st0" cx="1271.6" cy="626.4" r="2.4"/>
            </g>
            <g class="st26">
                <circle class="st0" cx="875.5" cy="1638.8" r="2.4"/>
                <circle class="st0" cx="867.1" cy="1574.2" r="2.4"/>
                <circle class="st0" cx="824.2" cy="1628.6" r="2.4"/>
                <circle class="st0" cx="824.2" cy="1576.5" r="2.4"/>
                <circle class="st0" cx="756.2" cy="1621.6" r="2.4"/>
                <circle class="st0" cx="781.3" cy="1569.6" r="2.4"/>
                <circle class="st0" cx="813.5" cy="1501.3" r="2.4"/>
                <circle class="st0" cx="804.8" cy="1551.2" r="2.4"/>
                <circle class="st0" cx="749.3" cy="1537.6" r="2.4"/>
                <circle class="st0" cx="744.6" cy="1588.5" r="2.4"/>
                <circle class="st0" cx="689.8" cy="1635.5" r="2.4"/>
                <circle class="st0" cx="772.4" cy="1685.8" r="2.4"/>
            </g>
            <g class="st26">
                <circle class="st0" cx="789.6" cy="895.7" r="2.4"/>
                <circle class="st0" cx="781.3" cy="831" r="2.4"/>
                <circle class="st0" cx="738.3" cy="885.4" r="2.4"/>
                <circle class="st0" cx="738.3" cy="833.4" r="2.4"/>
                <circle class="st0" cx="670.4" cy="878.4" r="2.4"/>
                <circle class="st0" cx="695.4" cy="826.5" r="2.4"/>
                <circle class="st0" cx="727.6" cy="758.2" r="2.4"/>
                <circle class="st0" cx="719" cy="808" r="2.4"/>
                <circle class="st0" cx="663.4" cy="794.5" r="2.4"/>
                <circle class="st0" cx="658.7" cy="845.3" r="2.4"/>
                <circle class="st0" cx="603.9" cy="892.4" r="2.4"/>
                <circle class="st0" cx="686.6" cy="942.6" r="2.4"/>
            </g>
            <g class="st26">
                <circle class="st0" cx="1196.2" cy="997.3" r="2.4"/>
                <circle class="st0" cx="1187.9" cy="932.7" r="2.4"/>
                <circle class="st0" cx="1144.9" cy="987.1" r="2.4"/>
                <circle class="st0" cx="1144.9" cy="935" r="2.4"/>
                <circle class="st0" cx="1077" cy="980.1" r="2.4"/>
                <circle class="st0" cx="1102" cy="928.1" r="2.4"/>
                <circle class="st0" cx="1134.2" cy="859.8" r="2.4"/>
                <circle class="st0" cx="1125.5" cy="909.7" r="2.4"/>
                <circle class="st0" cx="1070" cy="896.1" r="2.4"/>
                <circle class="st0" cx="1065.3" cy="947" r="2.4"/>
                <circle class="st0" cx="1010.5" cy="994" r="2.4"/>
                <circle class="st0" cx="1093.2" cy="1044.3" r="2.4"/>
            </g>
            <g>
                <circle class="st0" cx="349.2" cy="392.8" r="2.4"/>
                <circle class="st0" cx="340.8" cy="328.1" r="2.4"/>
                <circle class="st0" cx="297.9" cy="382.5" r="2.4"/>
                <circle class="st0" cx="297.9" cy="330.5" r="2.4"/>
                <circle class="st0" cx="229.9" cy="375.6" r="2.4"/>
                <circle class="st0" cx="255" cy="323.6" r="2.4"/>
                <circle class="st0" cx="287.1" cy="255.3" r="2.4"/>
                <circle class="st0" cx="278.5" cy="305.2" r="2.4"/>
                <circle class="st0" cx="223" cy="291.6" r="2.4"/>
                <circle class="st0" cx="218.3" cy="342.4" r="2.4"/>
                <circle class="st0" cx="163.5" cy="389.5" r="2.4"/>
                <circle class="st0" cx="246.1" cy="439.8" r="2.4"/>
            </g>
            <g class="st26">
                <circle class="st0" cx="1486.2" cy="251.9" r="2.4"/>
                <circle class="st0" cx="1477.8" cy="187.2" r="2.4"/>
                <circle class="st0" cx="1434.9" cy="241.6" r="2.4"/>
                <circle class="st0" cx="1434.9" cy="189.6" r="2.4"/>
                <circle class="st0" cx="1366.9" cy="234.7" r="2.4"/>
                <circle class="st0" cx="1391.9" cy="182.7" r="2.4"/>
                <circle class="st0" cx="1424.1" cy="114.4" r="2.4"/>
                <circle class="st0" cx="1415.5" cy="164.3" r="2.4"/>
                <circle class="st0" cx="1359.9" cy="150.7" r="2.4"/>
                <circle class="st0" cx="1355.2" cy="201.5" r="2.4"/>
                <circle class="st0" cx="1300.5" cy="248.6" r="2.4"/>
                <circle class="st0" cx="1383.1" cy="298.9" r="2.4"/>
            </g>
            <g class="st26">
                <circle class="st0" cx="426" cy="1390.3" r="2.4"/>
                <circle class="st0" cx="417.6" cy="1325.7" r="2.4"/>
                <circle class="st0" cx="374.7" cy="1380.1" r="2.4"/>
                <circle class="st0" cx="374.7" cy="1328" r="2.4"/>
                <circle class="st0" cx="306.7" cy="1373.1" r="2.4"/>
                <circle class="st0" cx="331.8" cy="1321.2" r="2.4"/>
                <circle class="st0" cx="363.9" cy="1252.8" r="2.4"/>
                <circle class="st0" cx="355.3" cy="1302.7" r="2.4"/>
                <circle class="st0" cx="299.8" cy="1289.2" r="2.4"/>
                <circle class="st0" cx="295.1" cy="1340" r="2.4"/>
                <circle class="st0" cx="240.3" cy="1387.1" r="2.4"/>
                <circle class="st0" cx="322.9" cy="1437.3" r="2.4"/>
            </g>
            <g>
                <g>
                    <circle class="st0" cx="-537" cy="1249.4" r="1.8"/>
                    <circle class="st0" cx="-537" cy="1249.4" r="1.8"/>
                    <circle class="st0" cx="-504" cy="1161.5" r="1.8"/>
                    <circle class="st0" cx="-554.9" cy="1221.1" r="1.8"/>
                    <circle class="st0" cx="-569.6" cy="1154.1" r="1.8"/>
                    <circle class="st0" cx="-507.2" cy="1169.5" r="1.8"/>
                    <circle class="st0" cx="-618.1" cy="1206.4" r="1.8"/>
                    <circle class="st0" cx="-593.9" cy="1167.7" r="1.8"/>
                    <circle class="st0" cx="-538.8" cy="1181" r="1.8"/>
                </g>
                <g>
                    <circle class="st0" cx="-562.6" cy="1113.2" r="1.8"/>
                    <circle class="st0" cx="-562.6" cy="1113.2" r="1.8"/>
                    <circle class="st0" cx="-645.1" cy="1068.5" r="1.8"/>
                    <circle class="st0" cx="-593" cy="1127" r="1.8"/>
                    <circle class="st0" cx="-661.4" cy="1132.4" r="1.8"/>
                    <circle class="st0" cx="-637.7" cy="1072.7" r="1.8"/>
                    <circle class="st0" cx="-616.2" cy="1187.7" r="1.8"/>
                    <circle class="st0" cx="-651.3" cy="1158.4" r="1.8"/>
                    <circle class="st0" cx="-630.5" cy="1105.6" r="1.8"/>
                </g>
            </g>
            <g class="st26">
                <g>
                    <circle class="st0" cx="212.7" cy="1969.1" r="1.8"/>
                    <circle class="st0" cx="212.7" cy="1969.1" r="1.8"/>
                    <circle class="st0" cx="245.6" cy="1881.3" r="1.8"/>
                    <circle class="st0" cx="194.8" cy="1940.9" r="1.8"/>
                    <circle class="st0" cx="180.1" cy="1873.9" r="1.8"/>
                    <circle class="st0" cx="242.5" cy="1889.2" r="1.8"/>
                    <circle class="st0" cx="131.6" cy="1926.2" r="1.8"/>
                    <circle class="st0" cx="155.8" cy="1887.4" r="1.8"/>
                    <circle class="st0" cx="210.9" cy="1900.8" r="1.8"/>
                </g>
                <g>
                    <circle class="st0" cx="187.1" cy="1833" r="1.8"/>
                    <circle class="st0" cx="187.1" cy="1833" r="1.8"/>
                    <circle class="st0" cx="104.6" cy="1788.3" r="1.8"/>
                    <circle class="st0" cx="156.7" cy="1846.8" r="1.8"/>
                    <circle class="st0" cx="88.3" cy="1852.2" r="1.8"/>
                    <circle class="st0" cx="112" cy="1792.5" r="1.8"/>
                    <circle class="st0" cx="133.5" cy="1907.5" r="1.8"/>
                    <circle class="st0" cx="98.4" cy="1878.2" r="1.8"/>
                    <circle class="st0" cx="119.1" cy="1825.4" r="1.8"/>
                </g>
            </g>
            <g>
                <g>
                    <circle class="st0" cx="-537" cy="1249.4" r="1.8"/>
                    <circle class="st0" cx="-537" cy="1249.4" r="1.8"/>
                    <circle class="st0" cx="-504" cy="1161.5" r="1.8"/>
                    <circle class="st0" cx="-554.9" cy="1221.1" r="1.8"/>
                    <circle class="st0" cx="-569.6" cy="1154.1" r="1.8"/>
                    <circle class="st0" cx="-507.2" cy="1169.5" r="1.8"/>
                    <circle class="st0" cx="-618.1" cy="1206.4" r="1.8"/>
                    <circle class="st0" cx="-593.9" cy="1167.7" r="1.8"/>
                    <circle class="st0" cx="-538.8" cy="1181" r="1.8"/>
                </g>
                <g>
                    <circle class="st0" cx="-562.6" cy="1113.2" r="1.8"/>
                    <circle class="st0" cx="-562.6" cy="1113.2" r="1.8"/>
                    <circle class="st0" cx="-645.1" cy="1068.5" r="1.8"/>
                    <circle class="st0" cx="-593" cy="1127" r="1.8"/>
                    <circle class="st0" cx="-661.4" cy="1132.4" r="1.8"/>
                    <circle class="st0" cx="-637.7" cy="1072.7" r="1.8"/>
                    <circle class="st0" cx="-616.2" cy="1187.7" r="1.8"/>
                    <circle class="st0" cx="-651.3" cy="1158.4" r="1.8"/>
                    <circle class="st0" cx="-630.5" cy="1105.6" r="1.8"/>
                </g>
            </g>
            <g>
                <g>
                    <circle class="st0" cx="1672.7" cy="1603.8" r="1.8"/>
                    <circle class="st0" cx="1672.7" cy="1603.8" r="1.8"/>
                    <circle class="st0" cx="1705.6" cy="1516" r="1.8"/>
                    <circle class="st0" cx="1654.8" cy="1575.6" r="1.8"/>
                    <circle class="st0" cx="1640.1" cy="1508.6" r="1.8"/>
                    <circle class="st0" cx="1702.5" cy="1523.9" r="1.8"/>
                    <circle class="st0" cx="1591.5" cy="1560.9" r="1.8"/>
                    <circle class="st0" cx="1615.7" cy="1522.1" r="1.8"/>
                    <circle class="st0" cx="1670.9" cy="1535.5" r="1.8"/>
                </g>
                <g>
                    <circle class="st0" cx="1647" cy="1467.7" r="1.8"/>
                    <circle class="st0" cx="1647" cy="1467.7" r="1.8"/>
                    <circle class="st0" cx="1564.6" cy="1423" r="1.8"/>
                    <circle class="st0" cx="1616.6" cy="1481.5" r="1.8"/>
                    <circle class="st0" cx="1548.2" cy="1486.9" r="1.8"/>
                    <circle class="st0" cx="1572" cy="1427.2" r="1.8"/>
                    <circle class="st0" cx="1593.4" cy="1542.2" r="1.8"/>
                    <circle class="st0" cx="1558.3" cy="1512.9" r="1.8"/>
                    <circle class="st0" cx="1579.1" cy="1460.1" r="1.8"/>
                </g>
            </g>
            <g>
                <circle class="st0" cx="401.8" cy="510.6" r="4.3"/>
                <circle class="st0" cx="666.1" cy="636.2" r="4.3"/>
                <circle class="st0" cx="888.1" cy="340.3" r="4.3"/>
                <circle class="st0" cx="1256" cy="873.2" r="4.3"/>
                <circle class="st0" cx="957" cy="1010.2" r="4.3"/>
                <circle class="st0" cx="572.1" cy="940.2" r="4.3"/>
                <circle class="st0" cx="590.1" cy="845.2" r="4.3"/>
                <circle class="st0" cx="566.1" cy="625.2" r="4.3"/>
                <circle class="st0" cx="593.1" cy="298.3" r="4.3"/>
                <circle class="st0" cx="940" cy="125.4" r="4.3"/>
                <circle class="st0" cx="1112" cy="136.4" r="4.3"/>
                <circle class="st0" cx="1356" cy="132.4" r="4.3"/>
                <circle class="st0" cx="1271" cy="434.3" r="4.3"/>
                <circle class="st0" cx="1263" cy="661.2" r="4.3"/>
                <circle class="st0" cx="1191" cy="774.2" r="4.3"/>
                <circle class="st0" cx="1057" cy="794.2" r="4.3"/>
                <circle class="st0" cx="888.1" cy="712.2" r="4.3"/>
                <circle class="st0" cx="447.2" cy="712.2" r="4.3"/>
                <circle class="st0" cx="471.1" cy="419.3" r="4.3"/>
                <circle class="st0" cx="550.1" cy="187.3" r="4.3"/>
                <circle class="st0" cx="765.1" cy="155.3" r="4.3"/>
                <circle class="st0" cx="988" cy="235.3" r="4.3"/>
                <circle class="st0" cx="1120" cy="404.3" r="4.3"/>
                <circle class="st0" cx="1214" cy="628.2" r="4.3"/>
                <circle class="st0" cx="1310" cy="466.3" r="4.3"/>
                <circle class="st0" cx="1297" cy="289.3" r="4.3"/>
                <circle class="st0" cx="1270" cy="166.3" r="4.3"/>
                <circle class="st0" cx="863.1" cy="145.4" r="4.3"/>
                <circle class="st0" cx="457.1" cy="80.4" r="4.3"/>
                <circle class="st0" cx="313.2" cy="192.3" r="4.3"/>
                <circle class="st0" cx="726.1" cy="673.2" r="4.3"/>
                <circle class="st0" cx="856.1" cy="585.3" r="4.3"/>
                <circle class="st0" cx="1161" cy="1136.1" r="4.3"/>
                <circle class="st0" cx="560.1" cy="1119.1" r="4.3"/>
                <circle class="st0" cx="359.2" cy="1041.2" r="4.3"/>
                <circle class="st0" cx="325.2" cy="902.2" r="4.3"/>
                <circle class="st0" cx="307.2" cy="769.2" r="4.3"/>
                <g>
                    <circle class="st0" cx="1099.5" cy="492" r="1.4"/>
                    <circle class="st0" cx="1094.5" cy="453.8" r="1.4"/>
                    <circle class="st0" cx="1069.2" cy="485.9" r="1.4"/>
                    <circle class="st0" cx="1069.2" cy="455.2" r="1.4"/>
                    <circle class="st0" cx="1029.1" cy="481.8" r="1.4"/>
                    <circle class="st0" cx="1043.9" cy="451.2" r="1.4"/>
                    <circle class="st0" cx="1062.9" cy="410.9" r="1.4"/>
                    <circle class="st0" cx="1057.8" cy="440.3" r="1.4"/>
                    <circle class="st0" cx="1025" cy="432.3" r="1.4"/>
                    <circle class="st0" cx="1022.2" cy="462.3" r="1.4"/>
                    <circle class="st0" cx="989.9" cy="490.1" r="1.4"/>
                    <circle class="st0" cx="1038.7" cy="519.7" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="899.5" cy="329.4" r="1.4"/>
                    <circle class="st0" cx="894.6" cy="291.2" r="1.4"/>
                    <circle class="st0" cx="869.3" cy="323.3" r="1.4"/>
                    <circle class="st0" cx="869.3" cy="292.6" r="1.4"/>
                    <circle class="st0" cx="829.2" cy="319.2" r="1.4"/>
                    <circle class="st0" cx="843.9" cy="288.5" r="1.4"/>
                    <circle class="st0" cx="862.9" cy="248.2" r="1.4"/>
                    <circle class="st0" cx="857.8" cy="277.7" r="1.4"/>
                    <circle class="st0" cx="825" cy="269.7" r="1.4"/>
                    <circle class="st0" cx="822.3" cy="299.7" r="1.4"/>
                    <circle class="st0" cx="789.9" cy="327.4" r="1.4"/>
                    <circle class="st0" cx="838.7" cy="357.1" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1298.1" cy="300" r="1.4"/>
                    <circle class="st0" cx="1293.2" cy="261.9" r="1.4"/>
                    <circle class="st0" cx="1267.8" cy="294" r="1.4"/>
                    <circle class="st0" cx="1267.8" cy="263.3" r="1.4"/>
                    <circle class="st0" cx="1227.7" cy="289.9" r="1.4"/>
                    <circle class="st0" cx="1242.5" cy="259.2" r="1.4"/>
                    <circle class="st0" cx="1261.5" cy="218.9" r="1.4"/>
                    <circle class="st0" cx="1256.4" cy="248.3" r="1.4"/>
                    <circle class="st0" cx="1223.6" cy="240.3" r="1.4"/>
                    <circle class="st0" cx="1220.8" cy="270.3" r="1.4"/>
                    <circle class="st0" cx="1188.5" cy="298.1" r="1.4"/>
                    <circle class="st0" cx="1237.3" cy="327.8" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1134.1" cy="249.4" r="1.4"/>
                    <circle class="st0" cx="1129.2" cy="211.2" r="1.4"/>
                    <circle class="st0" cx="1103.9" cy="243.3" r="1.4"/>
                    <circle class="st0" cx="1103.9" cy="212.6" r="1.4"/>
                    <circle class="st0" cx="1063.8" cy="239.2" r="1.4"/>
                    <circle class="st0" cx="1078.5" cy="208.6" r="1.4"/>
                    <circle class="st0" cx="1097.5" cy="168.2" r="1.4"/>
                    <circle class="st0" cx="1092.4" cy="197.7" r="1.4"/>
                    <circle class="st0" cx="1059.7" cy="189.7" r="1.4"/>
                    <circle class="st0" cx="1056.9" cy="219.7" r="1.4"/>
                    <circle class="st0" cx="1024.6" cy="247.4" r="1.4"/>
                    <circle class="st0" cx="1073.3" cy="277.1" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1276.8" cy="165.4" r="1.4"/>
                    <circle class="st0" cx="1271.8" cy="127.2" r="1.4"/>
                    <circle class="st0" cx="1246.5" cy="159.3" r="1.4"/>
                    <circle class="st0" cx="1246.5" cy="128.6" r="1.4"/>
                    <circle class="st0" cx="1206.4" cy="155.2" r="1.4"/>
                    <circle class="st0" cx="1221.2" cy="124.6" r="1.4"/>
                    <circle class="st0" cx="1240.2" cy="84.3" r="1.4"/>
                    <circle class="st0" cx="1235.1" cy="113.7" r="1.4"/>
                    <circle class="st0" cx="1202.3" cy="105.7" r="1.4"/>
                    <circle class="st0" cx="1199.5" cy="135.7" r="1.4"/>
                    <circle class="st0" cx="1167.2" cy="163.5" r="1.4"/>
                    <circle class="st0" cx="1216" cy="193.1" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1246.1" cy="514.7" r="1.4"/>
                    <circle class="st0" cx="1241.2" cy="476.5" r="1.4"/>
                    <circle class="st0" cx="1215.8" cy="508.6" r="1.4"/>
                    <circle class="st0" cx="1215.8" cy="477.9" r="1.4"/>
                    <circle class="st0" cx="1175.7" cy="504.5" r="1.4"/>
                    <circle class="st0" cx="1190.5" cy="473.8" r="1.4"/>
                    <circle class="st0" cx="1209.5" cy="433.5" r="1.4"/>
                    <circle class="st0" cx="1204.4" cy="463" r="1.4"/>
                    <circle class="st0" cx="1171.6" cy="455" r="1.4"/>
                    <circle class="st0" cx="1168.9" cy="484.9" r="1.4"/>
                    <path class="st0" d="M1136.5,511.3c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4S1135.7,511.3,1136.5,511.3z"/>
                    <circle class="st0" cx="1185.3" cy="542.4" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1363.4" cy="580" r="1.4"/>
                    <circle class="st0" cx="1358.5" cy="541.8" r="1.4"/>
                    <circle class="st0" cx="1333.2" cy="573.9" r="1.4"/>
                    <circle class="st0" cx="1333.2" cy="543.2" r="1.4"/>
                    <circle class="st0" cx="1293.1" cy="569.8" r="1.4"/>
                    <circle class="st0" cx="1307.8" cy="539.2" r="1.4"/>
                    <circle class="st0" cx="1326.8" cy="498.8" r="1.4"/>
                    <circle class="st0" cx="1321.7" cy="528.3" r="1.4"/>
                    <circle class="st0" cx="1288.9" cy="520.3" r="1.4"/>
                    <circle class="st0" cx="1286.2" cy="550.3" r="1.4"/>
                    <circle class="st0" cx="1253.8" cy="578" r="1.4"/>
                    <circle class="st0" cx="1302.6" cy="607.7" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1360.8" cy="494.7" r="1.4"/>
                    <circle class="st0" cx="1355.8" cy="456.5" r="1.4"/>
                    <circle class="st0" cx="1330.5" cy="488.6" r="1.4"/>
                    <circle class="st0" cx="1330.5" cy="457.9" r="1.4"/>
                    <circle class="st0" cx="1290.4" cy="484.5" r="1.4"/>
                    <circle class="st0" cx="1305.2" cy="453.8" r="1.4"/>
                    <circle class="st0" cx="1324.2" cy="413.5" r="1.4"/>
                    <circle class="st0" cx="1319" cy="443" r="1.4"/>
                    <circle class="st0" cx="1286.3" cy="435" r="1.4"/>
                    <circle class="st0" cx="1283.5" cy="464.9" r="1.4"/>
                    <circle class="st0" cx="1251.2" cy="492.7" r="1.4"/>
                    <circle class="st0" cx="1299.9" cy="522.4" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1096.8" cy="665.3" r="1.4"/>
                    <circle class="st0" cx="1091.9" cy="627.1" r="1.4"/>
                    <circle class="st0" cx="1066.5" cy="659.2" r="1.4"/>
                    <circle class="st0" cx="1066.5" cy="628.5" r="1.4"/>
                    <circle class="st0" cx="1026.4" cy="655.1" r="1.4"/>
                    <circle class="st0" cx="1041.2" cy="624.5" r="1.4"/>
                    <circle class="st0" cx="1060.2" cy="584.1" r="1.4"/>
                    <circle class="st0" cx="1055.1" cy="613.6" r="1.4"/>
                    <circle class="st0" cx="1022.3" cy="605.6" r="1.4"/>
                    <circle class="st0" cx="1019.6" cy="635.6" r="1.4"/>
                    <circle class="st0" cx="987.2" cy="663.4" r="1.4"/>
                    <circle class="st0" cx="1036" cy="693" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1035.5" cy="598.6" r="1.4"/>
                    <circle class="st0" cx="1030.6" cy="560.5" r="1.4"/>
                    <circle class="st0" cx="1005.2" cy="592.6" r="1.4"/>
                    <circle class="st0" cx="1005.2" cy="561.9" r="1.4"/>
                    <circle class="st0" cx="965.1" cy="588.5" r="1.4"/>
                    <circle class="st0" cx="979.9" cy="557.8" r="1.4"/>
                    <circle class="st0" cx="998.9" cy="517.5" r="1.4"/>
                    <circle class="st0" cx="993.8" cy="546.9" r="1.4"/>
                    <circle class="st0" cx="961" cy="538.9" r="1.4"/>
                    <circle class="st0" cx="958.2" cy="568.9" r="1.4"/>
                    <circle class="st0" cx="925.9" cy="596.7" r="1.4"/>
                    <circle class="st0" cx="974.7" cy="626.4" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="778.2" cy="730.6" r="1.4"/>
                    <circle class="st0" cx="773.3" cy="692.5" r="1.4"/>
                    <circle class="st0" cx="747.9" cy="724.6" r="1.4"/>
                    <circle class="st0" cx="747.9" cy="693.8" r="1.4"/>
                    <circle class="st0" cx="707.8" cy="720.5" r="1.4"/>
                    <circle class="st0" cx="722.6" cy="689.8" r="1.4"/>
                    <circle class="st0" cx="741.6" cy="649.5" r="1.4"/>
                    <circle class="st0" cx="736.5" cy="678.9" r="1.4"/>
                    <circle class="st0" cx="703.7" cy="670.9" r="1.4"/>
                    <circle class="st0" cx="701" cy="700.9" r="1.4"/>
                    <circle class="st0" cx="668.6" cy="728.7" r="1.4"/>
                    <circle class="st0" cx="717.4" cy="758.3" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="588.9" cy="949.2" r="1.4"/>
                    <circle class="st0" cx="584" cy="911.1" r="1.4"/>
                    <circle class="st0" cx="558.7" cy="943.2" r="1.4"/>
                    <circle class="st0" cx="558.7" cy="912.5" r="1.4"/>
                    <circle class="st0" cx="518.6" cy="939.1" r="1.4"/>
                    <circle class="st0" cx="533.3" cy="908.4" r="1.4"/>
                    <circle class="st0" cx="552.3" cy="868.1" r="1.4"/>
                    <circle class="st0" cx="547.2" cy="897.5" r="1.4"/>
                    <circle class="st0" cx="514.4" cy="889.5" r="1.4"/>
                    <path class="st0" d="M511.7,918.1c0.8,0,1.4,0.6,1.4,1.4s-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4S510.9,918.1,511.7,918.1z"/>
                    <circle class="st0" cx="479.3" cy="947.3" r="1.4"/>
                    <circle class="st0" cx="528.1" cy="977" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="507.6" cy="850.6" r="1.4"/>
                    <circle class="st0" cx="502.7" cy="812.4" r="1.4"/>
                    <circle class="st0" cx="477.3" cy="844.5" r="1.4"/>
                    <circle class="st0" cx="477.3" cy="813.8" r="1.4"/>
                    <circle class="st0" cx="437.2" cy="840.4" r="1.4"/>
                    <circle class="st0" cx="452" cy="809.8" r="1.4"/>
                    <circle class="st0" cx="471" cy="769.4" r="1.4"/>
                    <circle class="st0" cx="465.9" cy="798.9" r="1.4"/>
                    <circle class="st0" cx="433.1" cy="790.9" r="1.4"/>
                    <circle class="st0" cx="430.3" cy="820.9" r="1.4"/>
                    <circle class="st0" cx="398" cy="848.6" r="1.4"/>
                    <circle class="st0" cx="446.8" cy="878.3" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="972.8" cy="850.6" r="1.4"/>
                    <circle class="st0" cx="967.9" cy="812.4" r="1.4"/>
                    <circle class="st0" cx="942.6" cy="844.5" r="1.4"/>
                    <circle class="st0" cx="942.6" cy="813.8" r="1.4"/>
                    <circle class="st0" cx="902.5" cy="840.4" r="1.4"/>
                    <circle class="st0" cx="917.2" cy="809.8" r="1.4"/>
                    <circle class="st0" cx="936.2" cy="769.4" r="1.4"/>
                    <circle class="st0" cx="931.1" cy="798.9" r="1.4"/>
                    <circle class="st0" cx="898.4" cy="790.9" r="1.4"/>
                    <circle class="st0" cx="895.6" cy="820.9" r="1.4"/>
                    <circle class="st0" cx="863.3" cy="848.6" r="1.4"/>
                    <circle class="st0" cx="912" cy="878.3" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1127.5" cy="897.2" r="1.4"/>
                    <circle class="st0" cx="1122.5" cy="859.1" r="1.4"/>
                    <circle class="st0" cx="1097.2" cy="891.2" r="1.4"/>
                    <circle class="st0" cx="1097.2" cy="860.5" r="1.4"/>
                    <circle class="st0" cx="1057.1" cy="887.1" r="1.4"/>
                    <circle class="st0" cx="1071.9" cy="856.4" r="1.4"/>
                    <circle class="st0" cx="1090.9" cy="816.1" r="1.4"/>
                    <circle class="st0" cx="1085.8" cy="845.5" r="1.4"/>
                    <circle class="st0" cx="1053" cy="837.5" r="1.4"/>
                    <circle class="st0" cx="1050.2" cy="867.5" r="1.4"/>
                    <circle class="st0" cx="1017.9" cy="895.3" r="1.4"/>
                    <circle class="st0" cx="1066.7" cy="925" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1050.2" cy="978.6" r="1.4"/>
                    <circle class="st0" cx="1045.2" cy="940.4" r="1.4"/>
                    <circle class="st0" cx="1019.9" cy="972.5" r="1.4"/>
                    <circle class="st0" cx="1019.9" cy="941.8" r="1.4"/>
                    <circle class="st0" cx="979.8" cy="968.4" r="1.4"/>
                    <circle class="st0" cx="994.6" cy="937.7" r="1.4"/>
                    <circle class="st0" cx="1013.6" cy="897.4" r="1.4"/>
                    <circle class="st0" cx="1008.4" cy="926.9" r="1.4"/>
                    <circle class="st0" cx="975.7" cy="918.9" r="1.4"/>
                    <circle class="st0" cx="972.9" cy="948.8" r="1.4"/>
                    <circle class="st0" cx="940.6" cy="976.6" r="1.4"/>
                    <circle class="st0" cx="989.3" cy="1006.3" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="966.2" cy="962.6" r="1.4"/>
                    <circle class="st0" cx="961.2" cy="924.4" r="1.4"/>
                    <circle class="st0" cx="935.9" cy="956.5" r="1.4"/>
                    <circle class="st0" cx="935.9" cy="925.8" r="1.4"/>
                    <circle class="st0" cx="895.8" cy="952.4" r="1.4"/>
                    <circle class="st0" cx="910.6" cy="921.7" r="1.4"/>
                    <circle class="st0" cx="929.6" cy="881.4" r="1.4"/>
                    <circle class="st0" cx="924.5" cy="910.9" r="1.4"/>
                    <circle class="st0" cx="891.7" cy="902.9" r="1.4"/>
                    <circle class="st0" cx="888.9" cy="932.8" r="1.4"/>
                    <circle class="st0" cx="856.6" cy="960.6" r="1.4"/>
                    <circle class="st0" cx="905.4" cy="990.3" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="867.5" cy="943.9" r="1.4"/>
                    <circle class="st0" cx="862.6" cy="905.7" r="1.4"/>
                    <circle class="st0" cx="837.3" cy="937.8" r="1.4"/>
                    <circle class="st0" cx="837.3" cy="907.1" r="1.4"/>
                    <circle class="st0" cx="797.2" cy="933.7" r="1.4"/>
                    <circle class="st0" cx="811.9" cy="903.1" r="1.4"/>
                    <circle class="st0" cx="830.9" cy="862.8" r="1.4"/>
                    <circle class="st0" cx="825.8" cy="892.2" r="1.4"/>
                    <circle class="st0" cx="793" cy="884.2" r="1.4"/>
                    <circle class="st0" cx="790.3" cy="914.2" r="1.4"/>
                    <circle class="st0" cx="757.9" cy="942" r="1.4"/>
                    <circle class="st0" cx="806.7" cy="971.6" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="752.9" cy="324" r="1.4"/>
                    <circle class="st0" cx="747.9" cy="285.9" r="1.4"/>
                    <circle class="st0" cx="722.6" cy="318" r="1.4"/>
                    <circle class="st0" cx="722.6" cy="287.3" r="1.4"/>
                    <circle class="st0" cx="682.5" cy="313.9" r="1.4"/>
                    <circle class="st0" cx="697.3" cy="283.2" r="1.4"/>
                    <circle class="st0" cx="716.3" cy="242.9" r="1.4"/>
                    <circle class="st0" cx="711.2" cy="272.3" r="1.4"/>
                    <circle class="st0" cx="678.4" cy="264.3" r="1.4"/>
                    <circle class="st0" cx="675.6" cy="294.3" r="1.4"/>
                    <circle class="st0" cx="643.3" cy="322.1" r="1.4"/>
                    <circle class="st0" cx="692.1" cy="351.8" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="461" cy="237.9" r="1.4"/>
                    <circle class="st0" cx="456" cy="199.7" r="1.4"/>
                    <circle class="st0" cx="430.7" cy="231.8" r="1.4"/>
                    <circle class="st0" cx="430.7" cy="201.1" r="1.4"/>
                    <circle class="st0" cx="390.6" cy="227.7" r="1.4"/>
                    <circle class="st0" cx="405.4" cy="197.1" r="1.4"/>
                    <circle class="st0" cx="424.3" cy="156.7" r="1.4"/>
                    <circle class="st0" cx="419.2" cy="186.2" r="1.4"/>
                    <circle class="st0" cx="386.5" cy="178.2" r="1.4"/>
                    <circle class="st0" cx="383.7" cy="208.2" r="1.4"/>
                    <circle class="st0" cx="351.4" cy="235.9" r="1.4"/>
                    <circle class="st0" cx="400.1" cy="265.6" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="415.6" cy="626.6" r="1.4"/>
                    <circle class="st0" cx="410.7" cy="588.5" r="1.4"/>
                    <circle class="st0" cx="385.4" cy="620.6" r="1.4"/>
                    <circle class="st0" cx="385.4" cy="589.9" r="1.4"/>
                    <circle class="st0" cx="345.3" cy="616.5" r="1.4"/>
                    <circle class="st0" cx="360" cy="585.8" r="1.4"/>
                    <circle class="st0" cx="379" cy="545.5" r="1.4"/>
                    <circle class="st0" cx="373.9" cy="574.9" r="1.4"/>
                    <circle class="st0" cx="341.1" cy="566.9" r="1.4"/>
                    <circle class="st0" cx="338.4" cy="596.9" r="1.4"/>
                    <circle class="st0" cx="306" cy="624.7" r="1.4"/>
                    <circle class="st0" cx="354.8" cy="654.4" r="1.4"/>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="444" cy="1083.6" r="1.1"/>
                        <circle class="st0" cx="444" cy="1083.6" r="1.1"/>
                        <circle class="st0" cx="463.4" cy="1031.8" r="1.1"/>
                        <circle class="st0" cx="433.5" cy="1067" r="1.1"/>
                        <circle class="st0" cx="424.8" cy="1027.4" r="1.1"/>
                        <circle class="st0" cx="461.6" cy="1036.5" r="1.1"/>
                        <circle class="st0" cx="396.1" cy="1058.3" r="1.1"/>
                        <circle class="st0" cx="410.4" cy="1035.4" r="1.1"/>
                        <circle class="st0" cx="443" cy="1043.3" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="428.9" cy="1003.3" r="1.1"/>
                        <circle class="st0" cx="428.9" cy="1003.3" r="1.1"/>
                        <circle class="st0" cx="380.2" cy="976.9" r="1.1"/>
                        <circle class="st0" cx="410.9" cy="1011.5" r="1.1"/>
                        <circle class="st0" cx="370.6" cy="1014.6" r="1.1"/>
                        <circle class="st0" cx="384.6" cy="979.4" r="1.1"/>
                        <circle class="st0" cx="397.2" cy="1047.2" r="1.1"/>
                        <circle class="st0" cx="376.5" cy="1030" r="1.1"/>
                        <circle class="st0" cx="388.8" cy="998.8" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="1123" cy="552.7" r="1.1"/>
                        <circle class="st0" cx="1123" cy="552.7" r="1.1"/>
                        <circle class="st0" cx="1142.5" cy="500.8" r="1.1"/>
                        <circle class="st0" cx="1112.5" cy="536" r="1.1"/>
                        <circle class="st0" cx="1103.8" cy="496.5" r="1.1"/>
                        <circle class="st0" cx="1140.7" cy="505.5" r="1.1"/>
                        <circle class="st0" cx="1075.2" cy="527.3" r="1.1"/>
                        <circle class="st0" cx="1089.4" cy="504.5" r="1.1"/>
                        <path class="st0" d="M1122,511.2c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1S1121.4,511.2,1122,511.2z"/>
                    </g>
                    <g>
                        <circle class="st0" cx="1107.9" cy="472.3" r="1.1"/>
                        <circle class="st0" cx="1107.9" cy="472.3" r="1.1"/>
                        <circle class="st0" cx="1059.3" cy="446" r="1.1"/>
                        <circle class="st0" cx="1090" cy="480.5" r="1.1"/>
                        <circle class="st0" cx="1049.6" cy="483.6" r="1.1"/>
                        <circle class="st0" cx="1063.6" cy="448.4" r="1.1"/>
                        <circle class="st0" cx="1076.3" cy="516.3" r="1.1"/>
                        <circle class="st0" cx="1055.6" cy="499" r="1.1"/>
                        <circle class="st0" cx="1067.8" cy="467.8" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="1018.1" cy="899.6" r="1.1"/>
                        <circle class="st0" cx="1018.1" cy="899.6" r="1.1"/>
                        <circle class="st0" cx="1037.5" cy="847.8" r="1.1"/>
                        <circle class="st0" cx="1007.5" cy="882.9" r="1.1"/>
                        <circle class="st0" cx="998.8" cy="843.4" r="1.1"/>
                        <circle class="st0" cx="1035.7" cy="852.4" r="1.1"/>
                        <circle class="st0" cx="970.2" cy="874.3" r="1.1"/>
                        <circle class="st0" cx="984.5" cy="851.4" r="1.1"/>
                        <circle class="st0" cx="1017" cy="859.3" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="1002.9" cy="819.2" r="1.1"/>
                        <circle class="st0" cx="1002.9" cy="819.2" r="1.1"/>
                        <circle class="st0" cx="954.3" cy="792.9" r="1.1"/>
                        <circle class="st0" cx="985" cy="827.4" r="1.1"/>
                        <circle class="st0" cx="944.6" cy="830.6" r="1.1"/>
                        <circle class="st0" cx="958.6" cy="795.3" r="1.1"/>
                        <circle class="st0" cx="971.3" cy="863.2" r="1.1"/>
                        <circle class="st0" cx="950.6" cy="845.9" r="1.1"/>
                        <circle class="st0" cx="962.9" cy="814.8" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="1250" cy="1099.5" r="1.1"/>
                        <circle class="st0" cx="1250" cy="1099.5" r="1.1"/>
                        <circle class="st0" cx="1269.5" cy="1047.7" r="1.1"/>
                        <circle class="st0" cx="1239.5" cy="1082.9" r="1.1"/>
                        <circle class="st0" cx="1230.8" cy="1043.3" r="1.1"/>
                        <circle class="st0" cx="1267.6" cy="1052.4" r="1.1"/>
                        <circle class="st0" cx="1202.1" cy="1074.2" r="1.1"/>
                        <circle class="st0" cx="1216.4" cy="1051.3" r="1.1"/>
                        <circle class="st0" cx="1249" cy="1059.2" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="1234.9" cy="1019.2" r="1.1"/>
                        <circle class="st0" cx="1234.9" cy="1019.2" r="1.1"/>
                        <circle class="st0" cx="1186.2" cy="992.8" r="1.1"/>
                        <circle class="st0" cx="1216.9" cy="1027.4" r="1.1"/>
                        <circle class="st0" cx="1176.6" cy="1030.5" r="1.1"/>
                        <circle class="st0" cx="1190.6" cy="995.3" r="1.1"/>
                        <circle class="st0" cx="1203.2" cy="1063.1" r="1.1"/>
                        <circle class="st0" cx="1182.5" cy="1045.9" r="1.1"/>
                        <circle class="st0" cx="1194.8" cy="1014.7" r="1.1"/>
                    </g>
                </g>
            </g>
            <g class="st26">
                <g>
                    <circle class="st0" cx="1314.7" cy="1940" r="1.8"/>
                    <circle class="st0" cx="1314.7" cy="1940" r="1.8"/>
                    <circle class="st0" cx="1399.7" cy="1979.6" r="1.8"/>
                    <circle class="st0" cx="1344.2" cy="1924.4" r="1.8"/>
                    <circle class="st0" cx="1412.2" cy="1914.9" r="1.8"/>
                    <circle class="st0" cx="1392.1" cy="1975.9" r="1.8"/>
                    <circle class="st0" cx="1363.8" cy="1862.4" r="1.8"/>
                    <circle class="st0" cx="1400.6" cy="1889.5" r="1.8"/>
                    <circle class="st0" cx="1383" cy="1943.5" r="1.8"/>
                </g>
                <g>
                    <circle class="st0" cx="1452.5" cy="1925" r="1.8"/>
                    <circle class="st0" cx="1452.5" cy="1925" r="1.8"/>
                    <circle class="st0" cx="1503.3" cy="1846.2" r="1.8"/>
                    <circle class="st0" cx="1441" cy="1893.6" r="1.8"/>
                    <circle class="st0" cx="1440.9" cy="1825" r="1.8"/>
                    <circle class="st0" cx="1498.6" cy="1853.2" r="1.8"/>
                    <circle class="st0" cx="1382.3" cy="1865.8" r="1.8"/>
                    <circle class="st0" cx="1414.2" cy="1833" r="1.8"/>
                    <circle class="st0" cx="1465.2" cy="1857.8" r="1.8"/>
                </g>
            </g>
            <g class="st26">
                <g>
                    <circle class="st0" cx="1050.6" cy="1821.2" r="1.8"/>
                    <circle class="st0" cx="1050.6" cy="1821.2" r="1.8"/>
                    <circle class="st0" cx="1128.2" cy="1873.9" r="1.8"/>
                    <circle class="st0" cx="1082.2" cy="1810.5" r="1.8"/>
                    <circle class="st0" cx="1150.8" cy="1812" r="1.8"/>
                    <circle class="st0" cx="1121.2" cy="1869" r="1.8"/>
                    <circle class="st0" cx="1111.3" cy="1752.5" r="1.8"/>
                    <circle class="st0" cx="1143.3" cy="1785.1" r="1.8"/>
                    <circle class="st0" cx="1117.4" cy="1835.6" r="1.8"/>
                </g>
                <g>
                    <circle class="st0" cx="1188.9" cy="1828.3" r="1.8"/>
                    <circle class="st0" cx="1188.9" cy="1828.3" r="1.8"/>
                    <circle class="st0" cx="1251.7" cy="1758.7" r="1.8"/>
                    <circle class="st0" cx="1182.6" cy="1795.5" r="1.8"/>
                    <circle class="st0" cx="1193.5" cy="1727.8" r="1.8"/>
                    <circle class="st0" cx="1245.9" cy="1764.9" r="1.8"/>
                    <circle class="st0" cx="1129.1" cy="1758.7" r="1.8"/>
                    <circle class="st0" cx="1165.8" cy="1731.5" r="1.8"/>
                    <circle class="st0" cx="1212.3" cy="1764.1" r="1.8"/>
                </g>
            </g>
            <g>
                <circle class="st0" cx="1597.6" cy="1394.4" r="4.3"/>
                <circle class="st0" cx="1819.4" cy="1203.6" r="4.3"/>
                <circle class="st0" cx="1638.7" cy="880.8" r="4.3"/>
                <circle class="st0" cx="2275" cy="760.2" r="4.3"/>
                <circle class="st0" cx="2279.2" cy="1089" r="4.3"/>
                <circle class="st0" cx="2059.3" cy="1412.6" r="4.3"/>
                <circle class="st0" cx="1979.7" cy="1357.7" r="4.3"/>
                <circle class="st0" cx="1768.9" cy="1290.6" r="4.3"/>
                <circle class="st0" cx="1480.9" cy="1133.5" r="4.3"/>
                <circle class="st0" cx="1463.3" cy="746.2" r="4.3"/>
                <circle class="st0" cx="1542.9" cy="593.5" r="4.3"/>
                <circle class="st0" cx="1638.1" cy="368.8" r="4.3"/>
                <circle class="st0" cx="1879.7" cy="568.8" r="4.3"/>
                <circle class="st0" cx="2084" cy="668" r="4.3"/>
                <circle class="st0" cx="2158.2" cy="779.5" r="4.3"/>
                <circle class="st0" cx="2122.2" cy="910.1" r="4.3"/>
                <circle class="st0" cx="1978.8" cy="1031.4" r="4.3"/>
                <circle class="st0" cx="1800.3" cy="1434.6" r="4.3"/>
                <circle class="st0" cx="1542.1" cy="1294" r="4.3"/>
                <circle class="st0" cx="1362" cy="1127.9" r="4.3"/>
                <circle class="st0" cx="1419.8" cy="918.4" r="4.3"/>
                <circle class="st0" cx="1583.2" cy="746.9" r="4.3"/>
                <circle class="st0" cx="1791.2" cy="694.6" r="4.3"/>
                <circle class="st0" cx="2034" cy="699.4" r="4.3"/>
                <circle class="st0" cx="1924.8" cy="546.1" r="4.3"/>
                <circle class="st0" cx="1757.7" cy="486.3" r="4.3"/>
                <circle class="st0" cx="1634.3" cy="461.2" r="4.3"/>
                <circle class="st0" cx="1450.4" cy="824.7" r="4.3"/>
                <circle class="st0" cx="1226.6" cy="1169.5" r="4.3"/>
                <circle class="st0" cx="1270.7" cy="1346.5" r="4.3"/>
                <circle class="st0" cx="1877.6" cy="1163.7" r="4.3"/>
                <circle class="st0" cx="1849.8" cy="1009.3" r="4.3"/>
                <circle class="st0" cx="2476.9" cy="953.5" r="4.3"/>
                <circle class="st0" cx="2218.1" cy="1496" r="4.3"/>
                <circle class="st0" cx="2065.4" cy="1648.2" r="4.3"/>
                <circle class="st0" cx="1924.6" cy="1623" r="4.3"/>
                <circle class="st0" cx="1795.7" cy="1585.6" r="4.3"/>
                <g>
                    <circle class="st0" cx="1863.1" cy="748.9" r="1.4"/>
                    <circle class="st0" cx="1826.2" cy="738" r="1.4"/>
                    <circle class="st0" cx="1845.3" cy="774.2" r="1.4"/>
                    <circle class="st0" cx="1817.2" cy="761.7" r="1.4"/>
                    <circle class="st0" cx="1825.3" cy="809.2" r="1.4"/>
                    <circle class="st0" cx="1803.2" cy="783.2" r="1.4"/>
                    <circle class="st0" cx="1774" cy="749.5" r="1.4"/>
                    <circle class="st0" cx="1798.9" cy="766.1" r="1.4"/>
                    <circle class="st0" cx="1778.3" cy="792.9" r="1.4"/>
                    <circle class="st0" cx="1804.6" cy="807.5" r="1.4"/>
                    <circle class="st0" cx="1816.9" cy="848.3" r="1.4"/>
                    <circle class="st0" cx="1863.8" cy="815.8" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1633.4" cy="865.9" r="1.4"/>
                    <circle class="st0" cx="1596.5" cy="855" r="1.4"/>
                    <circle class="st0" cx="1615.6" cy="891.1" r="1.4"/>
                    <circle class="st0" cx="1587.5" cy="878.7" r="1.4"/>
                    <circle class="st0" cx="1595.6" cy="926.1" r="1.4"/>
                    <circle class="st0" cx="1573.5" cy="900.2" r="1.4"/>
                    <circle class="st0" cx="1544.4" cy="866.5" r="1.4"/>
                    <circle class="st0" cx="1569.2" cy="883.1" r="1.4"/>
                    <circle class="st0" cx="1548.6" cy="909.8" r="1.4"/>
                    <circle class="st0" cx="1574.9" cy="924.5" r="1.4"/>
                    <circle class="st0" cx="1587.2" cy="965.3" r="1.4"/>
                    <circle class="st0" cx="1634.1" cy="932.7" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1768" cy="489.6" r="1.4"/>
                    <circle class="st0" cx="1731.1" cy="478.7" r="1.4"/>
                    <circle class="st0" cx="1750.2" cy="514.8" r="1.4"/>
                    <circle class="st0" cx="1722.1" cy="502.4" r="1.4"/>
                    <circle class="st0" cx="1730.2" cy="549.8" r="1.4"/>
                    <circle class="st0" cx="1708.1" cy="523.9" r="1.4"/>
                    <circle class="st0" cx="1679" cy="490.2" r="1.4"/>
                    <circle class="st0" cx="1703.8" cy="506.8" r="1.4"/>
                    <circle class="st0" cx="1683.2" cy="533.5" r="1.4"/>
                    <circle class="st0" cx="1709.5" cy="548.2" r="1.4"/>
                    <circle class="st0" cx="1721.8" cy="589" r="1.4"/>
                    <circle class="st0" cx="1768.7" cy="556.4" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1655.3" cy="619" r="1.4"/>
                    <circle class="st0" cx="1618.4" cy="608.1" r="1.4"/>
                    <circle class="st0" cx="1637.5" cy="644.2" r="1.4"/>
                    <circle class="st0" cx="1609.4" cy="631.8" r="1.4"/>
                    <circle class="st0" cx="1617.5" cy="679.2" r="1.4"/>
                    <circle class="st0" cx="1595.4" cy="653.3" r="1.4"/>
                    <circle class="st0" cx="1566.2" cy="619.6" r="1.4"/>
                    <circle class="st0" cx="1591.1" cy="636.2" r="1.4"/>
                    <circle class="st0" cx="1570.5" cy="662.9" r="1.4"/>
                    <circle class="st0" cx="1596.8" cy="677.6" r="1.4"/>
                    <circle class="st0" cx="1609.1" cy="718.4" r="1.4"/>
                    <circle class="st0" cx="1656" cy="685.8" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1636.2" cy="454.6" r="1.4"/>
                    <circle class="st0" cx="1599.3" cy="443.6" r="1.4"/>
                    <circle class="st0" cx="1618.4" cy="479.8" r="1.4"/>
                    <circle class="st0" cx="1590.4" cy="467.4" r="1.4"/>
                    <circle class="st0" cx="1598.4" cy="514.8" r="1.4"/>
                    <circle class="st0" cx="1576.4" cy="488.9" r="1.4"/>
                    <circle class="st0" cx="1547.2" cy="455.2" r="1.4"/>
                    <circle class="st0" cx="1572.1" cy="471.8" r="1.4"/>
                    <circle class="st0" cx="1551.5" cy="498.5" r="1.4"/>
                    <path class="st0" d="M1577.8,511.8c0.8,0,1.4,0.6,1.4,1.4s-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4S1577,511.8,1577.8,511.8z"/>
                    <circle class="st0" cx="1590.1" cy="554" r="1.4"/>
                    <circle class="st0" cx="1636.9" cy="521.4" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1943.2" cy="624" r="1.4"/>
                    <circle class="st0" cx="1906.3" cy="613.1" r="1.4"/>
                    <circle class="st0" cx="1925.4" cy="649.3" r="1.4"/>
                    <circle class="st0" cx="1897.3" cy="636.8" r="1.4"/>
                    <circle class="st0" cx="1905.4" cy="684.3" r="1.4"/>
                    <circle class="st0" cx="1883.3" cy="658.3" r="1.4"/>
                    <circle class="st0" cx="1854.1" cy="624.6" r="1.4"/>
                    <circle class="st0" cx="1879" cy="641.2" r="1.4"/>
                    <circle class="st0" cx="1858.4" cy="668" r="1.4"/>
                    <circle class="st0" cx="1884.7" cy="682.6" r="1.4"/>
                    <circle class="st0" cx="1897" cy="723.4" r="1.4"/>
                    <circle class="st0" cx="1943.9" cy="690.9" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="2050.4" cy="543.2" r="1.4"/>
                    <circle class="st0" cx="2013.5" cy="532.3" r="1.4"/>
                    <circle class="st0" cx="2032.6" cy="568.5" r="1.4"/>
                    <circle class="st0" cx="2004.5" cy="556" r="1.4"/>
                    <circle class="st0" cx="2012.6" cy="603.5" r="1.4"/>
                    <circle class="st0" cx="1990.5" cy="577.5" r="1.4"/>
                    <circle class="st0" cx="1961.4" cy="543.8" r="1.4"/>
                    <circle class="st0" cx="1986.2" cy="560.4" r="1.4"/>
                    <circle class="st0" cx="1965.6" cy="587.1" r="1.4"/>
                    <circle class="st0" cx="1991.9" cy="601.8" r="1.4"/>
                    <circle class="st0" cx="2004.2" cy="642.6" r="1.4"/>
                    <circle class="st0" cx="2051.1" cy="610.1" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1971.3" cy="511.1" r="1.4"/>
                    <circle class="st0" cx="1934.4" cy="500.2" r="1.4"/>
                    <circle class="st0" cx="1953.5" cy="536.3" r="1.4"/>
                    <circle class="st0" cx="1925.4" cy="523.9" r="1.4"/>
                    <circle class="st0" cx="1933.5" cy="571.3" r="1.4"/>
                    <circle class="st0" cx="1911.5" cy="545.4" r="1.4"/>
                    <path class="st0" d="M1882.3,510.3c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4S1881.5,510.3,1882.3,510.3z"/>
                    <circle class="st0" cx="1907.1" cy="528.3" r="1.4"/>
                    <circle class="st0" cx="1886.5" cy="555" r="1.4"/>
                    <circle class="st0" cx="1912.8" cy="569.7" r="1.4"/>
                    <circle class="st0" cx="1925.1" cy="610.5" r="1.4"/>
                    <circle class="st0" cx="1972" cy="577.9" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="2020.4" cy="821.5" r="1.4"/>
                    <circle class="st0" cx="1983.5" cy="810.6" r="1.4"/>
                    <circle class="st0" cx="2002.6" cy="846.8" r="1.4"/>
                    <circle class="st0" cx="1974.6" cy="834.3" r="1.4"/>
                    <circle class="st0" cx="1982.6" cy="881.8" r="1.4"/>
                    <circle class="st0" cx="1960.6" cy="855.8" r="1.4"/>
                    <circle class="st0" cx="1931.4" cy="822.2" r="1.4"/>
                    <circle class="st0" cx="1956.3" cy="838.7" r="1.4"/>
                    <circle class="st0" cx="1935.7" cy="865.5" r="1.4"/>
                    <circle class="st0" cx="1962" cy="880.2" r="1.4"/>
                    <circle class="st0" cx="1974.3" cy="921" r="1.4"/>
                    <circle class="st0" cx="2021.1" cy="888.4" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1934.7" cy="850.6" r="1.4"/>
                    <circle class="st0" cx="1897.8" cy="839.7" r="1.4"/>
                    <circle class="st0" cx="1916.9" cy="875.8" r="1.4"/>
                    <circle class="st0" cx="1888.8" cy="863.4" r="1.4"/>
                    <circle class="st0" cx="1896.9" cy="910.8" r="1.4"/>
                    <circle class="st0" cx="1874.8" cy="884.9" r="1.4"/>
                    <circle class="st0" cx="1845.6" cy="851.2" r="1.4"/>
                    <circle class="st0" cx="1870.5" cy="867.8" r="1.4"/>
                    <circle class="st0" cx="1849.9" cy="894.5" r="1.4"/>
                    <circle class="st0" cx="1876.2" cy="909.2" r="1.4"/>
                    <circle class="st0" cx="1888.5" cy="950" r="1.4"/>
                    <circle class="st0" cx="1935.4" cy="917.5" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1951.1" cy="1139.3" r="1.4"/>
                    <circle class="st0" cx="1914.2" cy="1128.4" r="1.4"/>
                    <circle class="st0" cx="1933.3" cy="1164.5" r="1.4"/>
                    <circle class="st0" cx="1905.3" cy="1152.1" r="1.4"/>
                    <circle class="st0" cx="1913.3" cy="1199.5" r="1.4"/>
                    <circle class="st0" cx="1891.3" cy="1173.6" r="1.4"/>
                    <circle class="st0" cx="1862.1" cy="1139.9" r="1.4"/>
                    <circle class="st0" cx="1887" cy="1156.5" r="1.4"/>
                    <circle class="st0" cx="1866.4" cy="1183.2" r="1.4"/>
                    <circle class="st0" cx="1892.7" cy="1197.9" r="1.4"/>
                    <circle class="st0" cx="1905" cy="1238.7" r="1.4"/>
                    <circle class="st0" cx="1951.8" cy="1206.1" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="2074.4" cy="1400.9" r="1.4"/>
                    <circle class="st0" cx="2037.5" cy="1390" r="1.4"/>
                    <circle class="st0" cx="2056.6" cy="1426.1" r="1.4"/>
                    <circle class="st0" cx="2028.5" cy="1413.7" r="1.4"/>
                    <circle class="st0" cx="2036.6" cy="1461.1" r="1.4"/>
                    <circle class="st0" cx="2014.5" cy="1435.2" r="1.4"/>
                    <circle class="st0" cx="1985.4" cy="1401.5" r="1.4"/>
                    <circle class="st0" cx="2010.2" cy="1418.1" r="1.4"/>
                    <circle class="st0" cx="1989.6" cy="1444.8" r="1.4"/>
                    <circle class="st0" cx="2015.9" cy="1459.5" r="1.4"/>
                    <circle class="st0" cx="2028.2" cy="1500.3" r="1.4"/>
                    <circle class="st0" cx="2075.1" cy="1467.7" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1951.2" cy="1435.3" r="1.4"/>
                    <circle class="st0" cx="1914.4" cy="1424.4" r="1.4"/>
                    <circle class="st0" cx="1933.5" cy="1460.5" r="1.4"/>
                    <circle class="st0" cx="1905.4" cy="1448.1" r="1.4"/>
                    <circle class="st0" cx="1913.5" cy="1495.5" r="1.4"/>
                    <circle class="st0" cx="1891.4" cy="1469.6" r="1.4"/>
                    <circle class="st0" cx="1862.2" cy="1435.9" r="1.4"/>
                    <circle class="st0" cx="1887.1" cy="1452.5" r="1.4"/>
                    <circle class="st0" cx="1866.5" cy="1479.2" r="1.4"/>
                    <circle class="st0" cx="1892.8" cy="1493.9" r="1.4"/>
                    <circle class="st0" cx="1905.1" cy="1534.7" r="1.4"/>
                    <circle class="st0" cx="1952" cy="1502.1" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="2139.6" cy="1009.9" r="1.4"/>
                    <circle class="st0" cx="2102.8" cy="999" r="1.4"/>
                    <circle class="st0" cx="2121.9" cy="1035.2" r="1.4"/>
                    <path class="st0" d="M2093.8,1021.3c0.8,0,1.4,0.6,1.4,1.4s-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4S2093,1021.3,2093.8,1021.3z"/>
                    <circle class="st0" cx="2101.9" cy="1070.2" r="1.4"/>
                    <circle class="st0" cx="2079.8" cy="1044.2" r="1.4"/>
                    <circle class="st0" cx="2050.6" cy="1010.5" r="1.4"/>
                    <circle class="st0" cx="2075.5" cy="1027.1" r="1.4"/>
                    <circle class="st0" cx="2054.9" cy="1053.9" r="1.4"/>
                    <circle class="st0" cx="2081.2" cy="1068.5" r="1.4"/>
                    <circle class="st0" cx="2093.5" cy="1109.3" r="1.4"/>
                    <circle class="st0" cx="2140.4" cy="1076.8" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="2244.9" cy="887.4" r="1.4"/>
                    <circle class="st0" cx="2208" cy="876.5" r="1.4"/>
                    <circle class="st0" cx="2227.1" cy="912.7" r="1.4"/>
                    <circle class="st0" cx="2199" cy="900.2" r="1.4"/>
                    <circle class="st0" cx="2207.1" cy="947.7" r="1.4"/>
                    <circle class="st0" cx="2185.1" cy="921.7" r="1.4"/>
                    <circle class="st0" cx="2155.9" cy="888" r="1.4"/>
                    <circle class="st0" cx="2180.8" cy="904.6" r="1.4"/>
                    <circle class="st0" cx="2160.2" cy="931.4" r="1.4"/>
                    <circle class="st0" cx="2186.5" cy="946" r="1.4"/>
                    <circle class="st0" cx="2198.8" cy="986.9" r="1.4"/>
                    <circle class="st0" cx="2245.6" cy="954.3" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="2288" cy="991.1" r="1.4"/>
                    <circle class="st0" cx="2251.1" cy="980.1" r="1.4"/>
                    <circle class="st0" cx="2270.2" cy="1016.3" r="1.4"/>
                    <circle class="st0" cx="2242.1" cy="1003.9" r="1.4"/>
                    <circle class="st0" cx="2250.2" cy="1051.3" r="1.4"/>
                    <circle class="st0" cx="2228.1" cy="1025.4" r="1.4"/>
                    <circle class="st0" cx="2198.9" cy="991.7" r="1.4"/>
                    <circle class="st0" cx="2223.8" cy="1008.3" r="1.4"/>
                    <circle class="st0" cx="2203.2" cy="1035" r="1.4"/>
                    <circle class="st0" cx="2229.5" cy="1049.7" r="1.4"/>
                    <circle class="st0" cx="2241.8" cy="1090.5" r="1.4"/>
                    <circle class="st0" cx="2288.7" cy="1057.9" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="2239.3" cy="1061.4" r="1.4"/>
                    <circle class="st0" cx="2202.4" cy="1050.4" r="1.4"/>
                    <circle class="st0" cx="2221.5" cy="1086.6" r="1.4"/>
                    <circle class="st0" cx="2193.5" cy="1074.2" r="1.4"/>
                    <circle class="st0" cx="2201.5" cy="1121.6" r="1.4"/>
                    <circle class="st0" cx="2179.5" cy="1095.7" r="1.4"/>
                    <circle class="st0" cx="2150.3" cy="1062" r="1.4"/>
                    <circle class="st0" cx="2175.2" cy="1078.6" r="1.4"/>
                    <circle class="st0" cx="2154.6" cy="1105.3" r="1.4"/>
                    <circle class="st0" cx="2180.9" cy="1120" r="1.4"/>
                    <circle class="st0" cx="2193.2" cy="1160.8" r="1.4"/>
                    <circle class="st0" cx="2240" cy="1128.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="2182.3" cy="1144" r="1.4"/>
                    <circle class="st0" cx="2145.4" cy="1133.1" r="1.4"/>
                    <circle class="st0" cx="2164.5" cy="1169.2" r="1.4"/>
                    <circle class="st0" cx="2136.4" cy="1156.8" r="1.4"/>
                    <circle class="st0" cx="2144.5" cy="1204.2" r="1.4"/>
                    <circle class="st0" cx="2122.5" cy="1178.3" r="1.4"/>
                    <circle class="st0" cx="2093.3" cy="1144.6" r="1.4"/>
                    <circle class="st0" cx="2118.1" cy="1161.2" r="1.4"/>
                    <circle class="st0" cx="2097.6" cy="1187.9" r="1.4"/>
                    <circle class="st0" cx="2123.9" cy="1202.6" r="1.4"/>
                    <circle class="st0" cx="2136.2" cy="1243.4" r="1.4"/>
                    <circle class="st0" cx="2183" cy="1210.8" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1569.1" cy="997.8" r="1.4"/>
                    <circle class="st0" cx="1532.2" cy="986.9" r="1.4"/>
                    <circle class="st0" cx="1551.3" cy="1023" r="1.4"/>
                    <circle class="st0" cx="1523.3" cy="1010.6" r="1.4"/>
                    <circle class="st0" cx="1531.3" cy="1058" r="1.4"/>
                    <circle class="st0" cx="1509.3" cy="1032.1" r="1.4"/>
                    <circle class="st0" cx="1480.1" cy="998.4" r="1.4"/>
                    <circle class="st0" cx="1505" cy="1015" r="1.4"/>
                    <circle class="st0" cx="1484.4" cy="1041.7" r="1.4"/>
                    <circle class="st0" cx="1510.7" cy="1056.4" r="1.4"/>
                    <circle class="st0" cx="1523" cy="1097.2" r="1.4"/>
                    <circle class="st0" cx="1569.8" cy="1064.6" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1372.1" cy="1229.9" r="1.4"/>
                    <circle class="st0" cx="1335.2" cy="1218.9" r="1.4"/>
                    <circle class="st0" cx="1354.3" cy="1255.1" r="1.4"/>
                    <circle class="st0" cx="1326.3" cy="1242.6" r="1.4"/>
                    <circle class="st0" cx="1334.3" cy="1290.1" r="1.4"/>
                    <circle class="st0" cx="1312.3" cy="1264.2" r="1.4"/>
                    <circle class="st0" cx="1283.1" cy="1230.5" r="1.4"/>
                    <circle class="st0" cx="1308" cy="1247.1" r="1.4"/>
                    <circle class="st0" cx="1287.4" cy="1273.8" r="1.4"/>
                    <circle class="st0" cx="1313.7" cy="1288.5" r="1.4"/>
                    <circle class="st0" cx="1326" cy="1329.3" r="1.4"/>
                    <circle class="st0" cx="1372.9" cy="1296.7" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1709.2" cy="1428.7" r="1.4"/>
                    <circle class="st0" cx="1672.3" cy="1417.8" r="1.4"/>
                    <circle class="st0" cx="1691.4" cy="1454" r="1.4"/>
                    <circle class="st0" cx="1663.4" cy="1441.5" r="1.4"/>
                    <circle class="st0" cx="1671.4" cy="1489" r="1.4"/>
                    <circle class="st0" cx="1649.4" cy="1463" r="1.4"/>
                    <circle class="st0" cx="1620.2" cy="1429.3" r="1.4"/>
                    <circle class="st0" cx="1645.1" cy="1445.9" r="1.4"/>
                    <circle class="st0" cx="1624.5" cy="1472.6" r="1.4"/>
                    <circle class="st0" cx="1650.8" cy="1487.3" r="1.4"/>
                    <circle class="st0" cx="1663.1" cy="1528.1" r="1.4"/>
                    <circle class="st0" cx="1709.9" cy="1495.6" r="1.4"/>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="2138.6" cy="1587.8" r="1.1"/>
                        <circle class="st0" cx="2138.6" cy="1587.8" r="1.1"/>
                        <circle class="st0" cx="2099.1" cy="1549.1" r="1.1"/>
                        <circle class="st0" cx="2119.1" cy="1590.7" r="1.1"/>
                        <circle class="st0" cx="2079.4" cy="1582.7" r="1.1"/>
                        <circle class="st0" cx="2102.6" cy="1552.6" r="1.1"/>
                        <circle class="st0" cx="2096" cy="1621.4" r="1.1"/>
                        <circle class="st0" cx="2080.9" cy="1599" r="1.1"/>
                        <circle class="st0" cx="2101.3" cy="1572.5" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="2059" cy="1569.1" r="1.1"/>
                        <circle class="st0" cx="2059" cy="1569.1" r="1.1"/>
                        <circle class="st0" cx="2015.2" cy="1603" r="1.1"/>
                        <circle class="st0" cx="2059.2" cy="1588.8" r="1.1"/>
                        <circle class="st0" cx="2045.7" cy="1627" r="1.1"/>
                        <circle class="st0" cx="2019.2" cy="1600" r="1.1"/>
                        <circle class="st0" cx="2086.4" cy="1615.9" r="1.1"/>
                        <circle class="st0" cx="2062.2" cy="1627.8" r="1.1"/>
                        <circle class="st0" cx="2038.7" cy="1604" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="1928.1" cy="752" r="1.1"/>
                        <circle class="st0" cx="1928.1" cy="752" r="1.1"/>
                        <circle class="st0" cx="1888.6" cy="713.2" r="1.1"/>
                        <circle class="st0" cx="1908.6" cy="754.9" r="1.1"/>
                        <circle class="st0" cx="1868.9" cy="746.8" r="1.1"/>
                        <circle class="st0" cx="1892.1" cy="716.8" r="1.1"/>
                        <circle class="st0" cx="1885.5" cy="785.5" r="1.1"/>
                        <circle class="st0" cx="1870.4" cy="763.2" r="1.1"/>
                        <circle class="st0" cx="1890.8" cy="736.6" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="1848.5" cy="733.2" r="1.1"/>
                        <circle class="st0" cx="1848.5" cy="733.2" r="1.1"/>
                        <circle class="st0" cx="1804.7" cy="767.1" r="1.1"/>
                        <circle class="st0" cx="1848.7" cy="753" r="1.1"/>
                        <circle class="st0" cx="1835.2" cy="791.1" r="1.1"/>
                        <circle class="st0" cx="1808.7" cy="764.1" r="1.1"/>
                        <circle class="st0" cx="1875.8" cy="780" r="1.1"/>
                        <circle class="st0" cx="1851.7" cy="791.9" r="1.1"/>
                        <circle class="st0" cx="1828.1" cy="768.1" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="2202.8" cy="988.4" r="1.1"/>
                        <circle class="st0" cx="2202.8" cy="988.4" r="1.1"/>
                        <circle class="st0" cx="2163.3" cy="949.7" r="1.1"/>
                        <circle class="st0" cx="2183.3" cy="991.3" r="1.1"/>
                        <circle class="st0" cx="2143.6" cy="983.2" r="1.1"/>
                        <circle class="st0" cx="2166.8" cy="953.2" r="1.1"/>
                        <circle class="st0" cx="2160.2" cy="1021.9" r="1.1"/>
                        <circle class="st0" cx="2145.1" cy="999.6" r="1.1"/>
                        <circle class="st0" cx="2165.5" cy="973.1" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="2123.2" cy="969.7" r="1.1"/>
                        <circle class="st0" cx="2123.2" cy="969.7" r="1.1"/>
                        <circle class="st0" cx="2079.4" cy="1003.5" r="1.1"/>
                        <circle class="st0" cx="2123.4" cy="989.4" r="1.1"/>
                        <circle class="st0" cx="2109.9" cy="1027.6" r="1.1"/>
                        <circle class="st0" cx="2083.4" cy="1000.5" r="1.1"/>
                        <circle class="st0" cx="2150.5" cy="1016.4" r="1.1"/>
                        <circle class="st0" cx="2126.4" cy="1028.4" r="1.1"/>
                        <circle class="st0" cx="2102.8" cy="1004.6" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="2479.5" cy="857.3" r="1.1"/>
                        <circle class="st0" cx="2479.5" cy="857.3" r="1.1"/>
                        <circle class="st0" cx="2440" cy="818.6" r="1.1"/>
                        <circle class="st0" cx="2460" cy="860.2" r="1.1"/>
                        <circle class="st0" cx="2420.3" cy="852.1" r="1.1"/>
                        <circle class="st0" cx="2443.5" cy="822.1" r="1.1"/>
                        <circle class="st0" cx="2437" cy="890.8" r="1.1"/>
                        <circle class="st0" cx="2421.8" cy="868.5" r="1.1"/>
                        <circle class="st0" cx="2442.2" cy="842" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="2399.9" cy="838.6" r="1.1"/>
                        <circle class="st0" cx="2399.9" cy="838.6" r="1.1"/>
                        <circle class="st0" cx="2356.1" cy="872.4" r="1.1"/>
                        <circle class="st0" cx="2400.1" cy="858.3" r="1.1"/>
                        <circle class="st0" cx="2386.7" cy="896.5" r="1.1"/>
                        <circle class="st0" cx="2360.1" cy="869.4" r="1.1"/>
                        <circle class="st0" cx="2427.3" cy="885.3" r="1.1"/>
                        <circle class="st0" cx="2403.1" cy="897.3" r="1.1"/>
                        <circle class="st0" cx="2379.6" cy="873.4" r="1.1"/>
                    </g>
                </g>
            </g>
            <g>
                
                    <ellipse transform="matrix(3.701243e-02 -0.9993 0.9993 3.701243e-02 -1466.5806 1659.1023)" class="st0" cx="127.6" cy="1590.5" rx="4.3" ry="4.3"/>
                <circle class="st0" cx="391.9" cy="1716.1" r="4.3"/>
                <circle class="st0" cx="613.8" cy="1420.2" r="4.3"/>
                <circle class="st0" cx="981.7" cy="1953.1" r="4.3"/>
                <circle class="st0" cx="682.8" cy="2090.1" r="4.3"/>
                <circle class="st0" cx="297.9" cy="2020.1" r="4.3"/>
                <circle class="st0" cx="315.9" cy="1925.1" r="4.3"/>
                <circle class="st0" cx="291.9" cy="1705.1" r="4.3"/>
                <circle class="st0" cx="318.9" cy="1378.2" r="4.3"/>
                <circle class="st0" cx="665.8" cy="1205.2" r="4.3"/>
                <circle class="st0" cx="837.8" cy="1216.2" r="4.3"/>
                <circle class="st0" cx="1081.7" cy="1212.2" r="4.3"/>
                <circle class="st0" cx="996.7" cy="1514.2" r="4.3"/>
                <circle class="st0" cx="988.7" cy="1741.1" r="4.3"/>
                <circle class="st0" cx="916.7" cy="1854.1" r="4.3"/>
                <circle class="st0" cx="782.8" cy="1874.1" r="4.3"/>
                <circle class="st0" cx="613.8" cy="1792.1" r="4.3"/>
                <circle class="st0" cx="172.9" cy="1792.1" r="4.3"/>
                <circle class="st0" cx="196.9" cy="1499.2" r="4.3"/>
                <circle class="st0" cx="275.9" cy="1267.2" r="4.3"/>
                <circle class="st0" cx="490.8" cy="1235.2" r="4.3"/>
                <circle class="st0" cx="713.8" cy="1315.2" r="4.3"/>
                <circle class="st0" cx="845.8" cy="1484.2" r="4.3"/>
                <circle class="st0" cx="939.7" cy="1708.1" r="4.3"/>
                <circle class="st0" cx="1035.7" cy="1546.2" r="4.3"/>
                <circle class="st0" cx="1022.7" cy="1369.2" r="4.3"/>
                <circle class="st0" cx="995.7" cy="1246.2" r="4.3"/>
                <circle class="st0" cx="588.8" cy="1225.2" r="4.3"/>
                <circle class="st0" cx="182.9" cy="1160.3" r="4.3"/>
                <circle class="st0" cx="38.9" cy="1272.2" r="4.3"/>
                <circle class="st0" cx="451.8" cy="1753.1" r="4.3"/>
                <circle class="st0" cx="581.8" cy="1665.1" r="4.3"/>
                <circle class="st0" cx="886.8" cy="2216" r="4.3"/>
                <circle class="st0" cx="285.9" cy="2199" r="4.3"/>
                <circle class="st0" cx="84.9" cy="2121" r="4.3"/>
                <circle class="st0" cx="50.9" cy="1982.1" r="4.3"/>
                <circle class="st0" cx="32.9" cy="1849.1" r="4.3"/>
                <g>
                    <circle class="st0" cx="825.2" cy="1571.9" r="1.4"/>
                    <circle class="st0" cx="820.3" cy="1533.7" r="1.4"/>
                    <circle class="st0" cx="795" cy="1565.8" r="1.4"/>
                    <circle class="st0" cx="795" cy="1535.1" r="1.4"/>
                    <circle class="st0" cx="754.9" cy="1561.7" r="1.4"/>
                    <circle class="st0" cx="769.6" cy="1531.1" r="1.4"/>
                    <circle class="st0" cx="788.6" cy="1490.7" r="1.4"/>
                    <circle class="st0" cx="783.5" cy="1520.2" r="1.4"/>
                    <circle class="st0" cx="750.7" cy="1512.2" r="1.4"/>
                    <circle class="st0" cx="748" cy="1542.2" r="1.4"/>
                    <circle class="st0" cx="715.6" cy="1569.9" r="1.4"/>
                    <circle class="st0" cx="764.4" cy="1599.6" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="625.3" cy="1409.3" r="1.4"/>
                    <circle class="st0" cx="620.3" cy="1371.1" r="1.4"/>
                    <circle class="st0" cx="595" cy="1403.2" r="1.4"/>
                    <circle class="st0" cx="595" cy="1372.5" r="1.4"/>
                    <circle class="st0" cx="554.9" cy="1399.1" r="1.4"/>
                    <circle class="st0" cx="569.7" cy="1368.4" r="1.4"/>
                    <circle class="st0" cx="588.7" cy="1328.1" r="1.4"/>
                    <circle class="st0" cx="583.6" cy="1357.5" r="1.4"/>
                    <circle class="st0" cx="550.8" cy="1349.5" r="1.4"/>
                    <circle class="st0" cx="548" cy="1379.5" r="1.4"/>
                    <circle class="st0" cx="515.7" cy="1407.3" r="1.4"/>
                    <circle class="st0" cx="564.5" cy="1437" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1023.9" cy="1379.9" r="1.4"/>
                    <circle class="st0" cx="1018.9" cy="1341.8" r="1.4"/>
                    <circle class="st0" cx="993.6" cy="1373.9" r="1.4"/>
                    <circle class="st0" cx="993.6" cy="1343.2" r="1.4"/>
                    <circle class="st0" cx="953.5" cy="1369.8" r="1.4"/>
                    <circle class="st0" cx="968.3" cy="1339.1" r="1.4"/>
                    <circle class="st0" cx="987.3" cy="1298.8" r="1.4"/>
                    <circle class="st0" cx="982.1" cy="1328.2" r="1.4"/>
                    <circle class="st0" cx="949.4" cy="1320.2" r="1.4"/>
                    <circle class="st0" cx="946.6" cy="1350.2" r="1.4"/>
                    <circle class="st0" cx="914.3" cy="1378" r="1.4"/>
                    <circle class="st0" cx="963" cy="1407.6" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="859.9" cy="1329.3" r="1.4"/>
                    <circle class="st0" cx="854.9" cy="1291.1" r="1.4"/>
                    <circle class="st0" cx="829.6" cy="1323.2" r="1.4"/>
                    <circle class="st0" cx="829.6" cy="1292.5" r="1.4"/>
                    <circle class="st0" cx="789.5" cy="1319.1" r="1.4"/>
                    <circle class="st0" cx="804.3" cy="1288.4" r="1.4"/>
                    <circle class="st0" cx="823.3" cy="1248.1" r="1.4"/>
                    <circle class="st0" cx="818.2" cy="1277.6" r="1.4"/>
                    <circle class="st0" cx="785.4" cy="1269.6" r="1.4"/>
                    <circle class="st0" cx="782.6" cy="1299.6" r="1.4"/>
                    <circle class="st0" cx="750.3" cy="1327.3" r="1.4"/>
                    <circle class="st0" cx="799.1" cy="1357" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1002.5" cy="1245.3" r="1.4"/>
                    <circle class="st0" cx="997.6" cy="1207.1" r="1.4"/>
                    <circle class="st0" cx="972.3" cy="1239.2" r="1.4"/>
                    <circle class="st0" cx="972.3" cy="1208.5" r="1.4"/>
                    <circle class="st0" cx="932.2" cy="1235.1" r="1.4"/>
                    <circle class="st0" cx="946.9" cy="1204.5" r="1.4"/>
                    <circle class="st0" cx="965.9" cy="1164.1" r="1.4"/>
                    <circle class="st0" cx="960.8" cy="1193.6" r="1.4"/>
                    <circle class="st0" cx="928" cy="1185.6" r="1.4"/>
                    <circle class="st0" cx="925.3" cy="1215.6" r="1.4"/>
                    <circle class="st0" cx="892.9" cy="1243.3" r="1.4"/>
                    <circle class="st0" cx="941.7" cy="1273" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="971.9" cy="1594.5" r="1.4"/>
                    <circle class="st0" cx="966.9" cy="1556.4" r="1.4"/>
                    <circle class="st0" cx="941.6" cy="1588.5" r="1.4"/>
                    <circle class="st0" cx="941.6" cy="1557.8" r="1.4"/>
                    <circle class="st0" cx="901.5" cy="1584.4" r="1.4"/>
                    <circle class="st0" cx="916.3" cy="1553.7" r="1.4"/>
                    <circle class="st0" cx="935.3" cy="1513.4" r="1.4"/>
                    <circle class="st0" cx="930.2" cy="1542.8" r="1.4"/>
                    <circle class="st0" cx="897.4" cy="1534.8" r="1.4"/>
                    <circle class="st0" cx="894.6" cy="1564.8" r="1.4"/>
                    <circle class="st0" cx="862.3" cy="1592.6" r="1.4"/>
                    <circle class="st0" cx="911" cy="1622.3" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1089.2" cy="1659.9" r="1.4"/>
                    <circle class="st0" cx="1084.2" cy="1621.7" r="1.4"/>
                    <circle class="st0" cx="1058.9" cy="1653.8" r="1.4"/>
                    <circle class="st0" cx="1058.9" cy="1623.1" r="1.4"/>
                    <circle class="st0" cx="1018.8" cy="1649.7" r="1.4"/>
                    <circle class="st0" cx="1033.6" cy="1619" r="1.4"/>
                    <circle class="st0" cx="1052.6" cy="1578.7" r="1.4"/>
                    <circle class="st0" cx="1047.5" cy="1608.2" r="1.4"/>
                    <circle class="st0" cx="1014.7" cy="1600.2" r="1.4"/>
                    <circle class="st0" cx="1011.9" cy="1630.2" r="1.4"/>
                    <circle class="st0" cx="979.6" cy="1657.9" r="1.4"/>
                    <circle class="st0" cx="1028.4" cy="1687.6" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1086.5" cy="1574.6" r="1.4"/>
                    <circle class="st0" cx="1081.6" cy="1536.4" r="1.4"/>
                    <circle class="st0" cx="1056.2" cy="1568.5" r="1.4"/>
                    <circle class="st0" cx="1056.2" cy="1537.8" r="1.4"/>
                    <circle class="st0" cx="1016.1" cy="1564.4" r="1.4"/>
                    <circle class="st0" cx="1030.9" cy="1533.7" r="1.4"/>
                    <circle class="st0" cx="1049.9" cy="1493.4" r="1.4"/>
                    <circle class="st0" cx="1044.8" cy="1522.8" r="1.4"/>
                    <circle class="st0" cx="1012" cy="1514.8" r="1.4"/>
                    <circle class="st0" cx="1009.2" cy="1544.8" r="1.4"/>
                    <circle class="st0" cx="976.9" cy="1572.6" r="1.4"/>
                    <circle class="st0" cx="1025.7" cy="1602.3" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="822.6" cy="1745.2" r="1.4"/>
                    <circle class="st0" cx="817.6" cy="1707" r="1.4"/>
                    <circle class="st0" cx="792.3" cy="1739.1" r="1.4"/>
                    <circle class="st0" cx="792.3" cy="1708.4" r="1.4"/>
                    <circle class="st0" cx="752.2" cy="1735" r="1.4"/>
                    <circle class="st0" cx="767" cy="1704.4" r="1.4"/>
                    <circle class="st0" cx="786" cy="1664" r="1.4"/>
                    <circle class="st0" cx="780.9" cy="1693.5" r="1.4"/>
                    <circle class="st0" cx="748.1" cy="1685.5" r="1.4"/>
                    <circle class="st0" cx="745.3" cy="1715.5" r="1.4"/>
                    <circle class="st0" cx="713" cy="1743.2" r="1.4"/>
                    <circle class="st0" cx="761.7" cy="1772.9" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="761.3" cy="1678.5" r="1.4"/>
                    <circle class="st0" cx="756.3" cy="1640.4" r="1.4"/>
                    <circle class="st0" cx="731" cy="1672.5" r="1.4"/>
                    <circle class="st0" cx="731" cy="1641.8" r="1.4"/>
                    <circle class="st0" cx="690.9" cy="1668.4" r="1.4"/>
                    <circle class="st0" cx="705.6" cy="1637.7" r="1.4"/>
                    <circle class="st0" cx="724.6" cy="1597.4" r="1.4"/>
                    <circle class="st0" cx="719.5" cy="1626.8" r="1.4"/>
                    <circle class="st0" cx="686.8" cy="1618.8" r="1.4"/>
                    <circle class="st0" cx="684" cy="1648.8" r="1.4"/>
                    <circle class="st0" cx="651.7" cy="1676.6" r="1.4"/>
                    <circle class="st0" cx="700.4" cy="1706.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="504" cy="1810.5" r="1.4"/>
                    <circle class="st0" cx="499" cy="1772.3" r="1.4"/>
                    <circle class="st0" cx="473.7" cy="1804.4" r="1.4"/>
                    <circle class="st0" cx="473.7" cy="1773.7" r="1.4"/>
                    <circle class="st0" cx="433.6" cy="1800.3" r="1.4"/>
                    <circle class="st0" cx="448.4" cy="1769.7" r="1.4"/>
                    <circle class="st0" cx="467.4" cy="1729.4" r="1.4"/>
                    <circle class="st0" cx="462.3" cy="1758.8" r="1.4"/>
                    <circle class="st0" cx="429.5" cy="1750.8" r="1.4"/>
                    <circle class="st0" cx="426.7" cy="1780.8" r="1.4"/>
                    <circle class="st0" cx="394.4" cy="1808.6" r="1.4"/>
                    <circle class="st0" cx="443.1" cy="1838.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="314.7" cy="2029.1" r="1.4"/>
                    <circle class="st0" cx="309.7" cy="1991" r="1.4"/>
                    <circle class="st0" cx="284.4" cy="2023.1" r="1.4"/>
                    <circle class="st0" cx="284.4" cy="1992.4" r="1.4"/>
                    <circle class="st0" cx="244.3" cy="2019" r="1.4"/>
                    <circle class="st0" cx="259.1" cy="1988.3" r="1.4"/>
                    <circle class="st0" cx="278.1" cy="1948" r="1.4"/>
                    <circle class="st0" cx="273" cy="1977.4" r="1.4"/>
                    <circle class="st0" cx="240.2" cy="1969.4" r="1.4"/>
                    <circle class="st0" cx="237.4" cy="1999.4" r="1.4"/>
                    <circle class="st0" cx="205.1" cy="2027.2" r="1.4"/>
                    <circle class="st0" cx="253.9" cy="2056.8" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="233.4" cy="1930.5" r="1.4"/>
                    <circle class="st0" cx="228.4" cy="1892.3" r="1.4"/>
                    <circle class="st0" cx="203.1" cy="1924.4" r="1.4"/>
                    <circle class="st0" cx="203.1" cy="1893.7" r="1.4"/>
                    <circle class="st0" cx="163" cy="1920.3" r="1.4"/>
                    <circle class="st0" cx="177.8" cy="1889.7" r="1.4"/>
                    <circle class="st0" cx="196.8" cy="1849.3" r="1.4"/>
                    <circle class="st0" cx="191.6" cy="1878.8" r="1.4"/>
                    <circle class="st0" cx="158.9" cy="1870.8" r="1.4"/>
                    <circle class="st0" cx="156.1" cy="1900.8" r="1.4"/>
                    <circle class="st0" cx="123.8" cy="1928.5" r="1.4"/>
                    <circle class="st0" cx="172.5" cy="1958.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="698.6" cy="1930.5" r="1.4"/>
                    <circle class="st0" cx="693.7" cy="1892.3" r="1.4"/>
                    <circle class="st0" cx="668.3" cy="1924.4" r="1.4"/>
                    <circle class="st0" cx="668.3" cy="1893.7" r="1.4"/>
                    <circle class="st0" cx="628.2" cy="1920.3" r="1.4"/>
                    <circle class="st0" cx="643" cy="1889.7" r="1.4"/>
                    <circle class="st0" cx="662" cy="1849.3" r="1.4"/>
                    <circle class="st0" cx="656.9" cy="1878.8" r="1.4"/>
                    <circle class="st0" cx="624.1" cy="1870.8" r="1.4"/>
                    <circle class="st0" cx="621.3" cy="1900.8" r="1.4"/>
                    <circle class="st0" cx="589" cy="1928.5" r="1.4"/>
                    <circle class="st0" cx="637.8" cy="1958.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="853.2" cy="1977.1" r="1.4"/>
                    <circle class="st0" cx="848.3" cy="1939" r="1.4"/>
                    <circle class="st0" cx="823" cy="1971.1" r="1.4"/>
                    <circle class="st0" cx="823" cy="1940.4" r="1.4"/>
                    <circle class="st0" cx="782.9" cy="1967" r="1.4"/>
                    <circle class="st0" cx="797.6" cy="1936.3" r="1.4"/>
                    <circle class="st0" cx="816.6" cy="1896" r="1.4"/>
                    <circle class="st0" cx="811.5" cy="1925.4" r="1.4"/>
                    <circle class="st0" cx="778.7" cy="1917.4" r="1.4"/>
                    <circle class="st0" cx="776" cy="1947.4" r="1.4"/>
                    <circle class="st0" cx="743.6" cy="1975.2" r="1.4"/>
                    <circle class="st0" cx="792.4" cy="2004.9" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="775.9" cy="2058.4" r="1.4"/>
                    <circle class="st0" cx="771" cy="2020.3" r="1.4"/>
                    <circle class="st0" cx="745.6" cy="2052.4" r="1.4"/>
                    <circle class="st0" cx="745.6" cy="2021.7" r="1.4"/>
                    <path class="st0" d="M705.5,2046.9c0.8,0,1.4,0.6,1.4,1.4s-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4S704.7,2046.9,705.5,2046.9z"/>
                    <circle class="st0" cx="720.3" cy="2017.6" r="1.4"/>
                    <circle class="st0" cx="739.3" cy="1977.3" r="1.4"/>
                    <circle class="st0" cx="734.2" cy="2006.7" r="1.4"/>
                    <circle class="st0" cx="701.4" cy="1998.7" r="1.4"/>
                    <circle class="st0" cx="698.6" cy="2028.7" r="1.4"/>
                    <circle class="st0" cx="666.3" cy="2056.5" r="1.4"/>
                    <circle class="st0" cx="715.1" cy="2086.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="691.9" cy="2042.5" r="1.4"/>
                    <circle class="st0" cx="687" cy="2004.3" r="1.4"/>
                    <circle class="st0" cx="661.7" cy="2036.4" r="1.4"/>
                    <circle class="st0" cx="661.7" cy="2005.7" r="1.4"/>
                    <circle class="st0" cx="621.6" cy="2032.3" r="1.4"/>
                    <circle class="st0" cx="636.3" cy="2001.6" r="1.4"/>
                    <circle class="st0" cx="655.3" cy="1961.3" r="1.4"/>
                    <circle class="st0" cx="650.2" cy="1990.7" r="1.4"/>
                    <circle class="st0" cx="617.4" cy="1982.7" r="1.4"/>
                    <circle class="st0" cx="614.7" cy="2012.7" r="1.4"/>
                    <circle class="st0" cx="582.3" cy="2040.5" r="1.4"/>
                    <circle class="st0" cx="631.1" cy="2070.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="593.3" cy="2023.8" r="1.4"/>
                    <circle class="st0" cx="588.3" cy="1985.6" r="1.4"/>
                    <circle class="st0" cx="563" cy="2017.7" r="1.4"/>
                    <circle class="st0" cx="563" cy="1987" r="1.4"/>
                    <circle class="st0" cx="522.9" cy="2013.6" r="1.4"/>
                    <circle class="st0" cx="537.7" cy="1983" r="1.4"/>
                    <circle class="st0" cx="556.7" cy="1942.6" r="1.4"/>
                    <circle class="st0" cx="551.6" cy="1972.1" r="1.4"/>
                    <circle class="st0" cx="518.8" cy="1964.1" r="1.4"/>
                    <circle class="st0" cx="516" cy="1994.1" r="1.4"/>
                    <circle class="st0" cx="483.7" cy="2021.8" r="1.4"/>
                    <circle class="st0" cx="532.5" cy="2051.5" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="478.6" cy="1403.9" r="1.4"/>
                    <circle class="st0" cx="473.7" cy="1365.8" r="1.4"/>
                    <circle class="st0" cx="448.4" cy="1397.9" r="1.4"/>
                    <circle class="st0" cx="448.4" cy="1367.2" r="1.4"/>
                    <circle class="st0" cx="408.3" cy="1393.8" r="1.4"/>
                    <circle class="st0" cx="423" cy="1363.1" r="1.4"/>
                    <circle class="st0" cx="442" cy="1322.8" r="1.4"/>
                    <circle class="st0" cx="436.9" cy="1352.2" r="1.4"/>
                    <circle class="st0" cx="404.2" cy="1344.2" r="1.4"/>
                    <circle class="st0" cx="401.4" cy="1374.2" r="1.4"/>
                    <circle class="st0" cx="369.1" cy="1402" r="1.4"/>
                    <circle class="st0" cx="417.8" cy="1431.6" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="186.7" cy="1317.8" r="1.4"/>
                    <circle class="st0" cx="181.8" cy="1279.6" r="1.4"/>
                    <circle class="st0" cx="156.4" cy="1311.7" r="1.4"/>
                    <circle class="st0" cx="156.4" cy="1281" r="1.4"/>
                    <circle class="st0" cx="116.3" cy="1307.6" r="1.4"/>
                    <circle class="st0" cx="131.1" cy="1277" r="1.4"/>
                    <circle class="st0" cx="150.1" cy="1236.6" r="1.4"/>
                    <circle class="st0" cx="145" cy="1266.1" r="1.4"/>
                    <circle class="st0" cx="112.2" cy="1258.1" r="1.4"/>
                    <circle class="st0" cx="109.4" cy="1288.1" r="1.4"/>
                    <circle class="st0" cx="77.1" cy="1315.8" r="1.4"/>
                    <circle class="st0" cx="125.9" cy="1345.5" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="141.4" cy="1706.5" r="1.4"/>
                    <circle class="st0" cx="136.4" cy="1668.4" r="1.4"/>
                    <circle class="st0" cx="111.1" cy="1700.5" r="1.4"/>
                    <circle class="st0" cx="111.1" cy="1669.8" r="1.4"/>
                    <circle class="st0" cx="71" cy="1696.4" r="1.4"/>
                    <circle class="st0" cx="85.8" cy="1665.7" r="1.4"/>
                    <circle class="st0" cx="104.8" cy="1625.4" r="1.4"/>
                    <circle class="st0" cx="99.7" cy="1654.8" r="1.4"/>
                    <circle class="st0" cx="66.9" cy="1646.8" r="1.4"/>
                    <circle class="st0" cx="64.1" cy="1676.8" r="1.4"/>
                    
                        <ellipse transform="matrix(0.9998 -2.040459e-02 2.040459e-02 0.9998 -34.7734 1.0037)" class="st0" cx="31.8" cy="1704.5" rx="1.4" ry="1.4"/>
                    <circle class="st0" cx="80.6" cy="1734.2" r="1.4"/>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="169.8" cy="2163.5" r="1.1"/>
                        <circle class="st0" cx="169.8" cy="2163.5" r="1.1"/>
                        <circle class="st0" cx="189.2" cy="2111.7" r="1.1"/>
                        <circle class="st0" cx="159.2" cy="2146.9" r="1.1"/>
                        <circle class="st0" cx="150.5" cy="2107.3" r="1.1"/>
                        <circle class="st0" cx="187.4" cy="2116.4" r="1.1"/>
                        <circle class="st0" cx="121.9" cy="2138.2" r="1.1"/>
                        <circle class="st0" cx="136.2" cy="2115.3" r="1.1"/>
                        <circle class="st0" cx="168.7" cy="2123.2" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="154.6" cy="2083.2" r="1.1"/>
                        <circle class="st0" cx="154.6" cy="2083.2" r="1.1"/>
                        <circle class="st0" cx="106" cy="2056.8" r="1.1"/>
                        <circle class="st0" cx="136.7" cy="2091.3" r="1.1"/>
                        <circle class="st0" cx="96.3" cy="2094.5" r="1.1"/>
                        <circle class="st0" cx="110.3" cy="2059.3" r="1.1"/>
                        <circle class="st0" cx="123" cy="2127.1" r="1.1"/>
                        <circle class="st0" cx="102.3" cy="2109.9" r="1.1"/>
                        <circle class="st0" cx="114.5" cy="2078.7" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="848.8" cy="1632.6" r="1.1"/>
                        <circle class="st0" cx="848.8" cy="1632.6" r="1.1"/>
                        <circle class="st0" cx="868.2" cy="1580.7" r="1.1"/>
                        <circle class="st0" cx="838.2" cy="1615.9" r="1.1"/>
                        <circle class="st0" cx="829.6" cy="1576.3" r="1.1"/>
                        <circle class="st0" cx="866.4" cy="1585.4" r="1.1"/>
                        <circle class="st0" cx="800.9" cy="1607.2" r="1.1"/>
                        <circle class="st0" cx="815.2" cy="1584.3" r="1.1"/>
                        <circle class="st0" cx="847.7" cy="1592.2" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="833.7" cy="1552.2" r="1.1"/>
                        <circle class="st0" cx="833.7" cy="1552.2" r="1.1"/>
                        <circle class="st0" cx="785" cy="1525.8" r="1.1"/>
                        <circle class="st0" cx="815.7" cy="1560.4" r="1.1"/>
                        <circle class="st0" cx="775.4" cy="1563.5" r="1.1"/>
                        <circle class="st0" cx="789.4" cy="1528.3" r="1.1"/>
                        <circle class="st0" cx="802" cy="1596.2" r="1.1"/>
                        <circle class="st0" cx="781.3" cy="1578.9" r="1.1"/>
                        <circle class="st0" cx="793.6" cy="1547.7" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="743.8" cy="1979.5" r="1.1"/>
                        <circle class="st0" cx="743.8" cy="1979.5" r="1.1"/>
                        <circle class="st0" cx="763.3" cy="1927.7" r="1.1"/>
                        <circle class="st0" cx="733.3" cy="1962.8" r="1.1"/>
                        <circle class="st0" cx="724.6" cy="1923.3" r="1.1"/>
                        <circle class="st0" cx="761.4" cy="1932.3" r="1.1"/>
                        <circle class="st0" cx="695.9" cy="1954.2" r="1.1"/>
                        <circle class="st0" cx="710.2" cy="1931.3" r="1.1"/>
                        <circle class="st0" cx="742.8" cy="1939.2" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="728.7" cy="1899.1" r="1.1"/>
                        <circle class="st0" cx="728.7" cy="1899.1" r="1.1"/>
                        <circle class="st0" cx="680" cy="1872.8" r="1.1"/>
                        <circle class="st0" cx="710.7" cy="1907.3" r="1.1"/>
                        <circle class="st0" cx="670.4" cy="1910.5" r="1.1"/>
                        <circle class="st0" cx="684.4" cy="1875.2" r="1.1"/>
                        <circle class="st0" cx="697.1" cy="1943.1" r="1.1"/>
                        <circle class="st0" cx="676.3" cy="1925.8" r="1.1"/>
                        <circle class="st0" cx="688.6" cy="1894.6" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="975.8" cy="2179.4" r="1.1"/>
                        <circle class="st0" cx="975.8" cy="2179.4" r="1.1"/>
                        <circle class="st0" cx="995.2" cy="2127.6" r="1.1"/>
                        <circle class="st0" cx="965.2" cy="2162.8" r="1.1"/>
                        <circle class="st0" cx="956.6" cy="2123.2" r="1.1"/>
                        <circle class="st0" cx="993.4" cy="2132.3" r="1.1"/>
                        <circle class="st0" cx="927.9" cy="2154.1" r="1.1"/>
                        <circle class="st0" cx="942.2" cy="2131.2" r="1.1"/>
                        <circle class="st0" cx="974.7" cy="2139.1" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="960.6" cy="2099.1" r="1.1"/>
                        <circle class="st0" cx="960.6" cy="2099.1" r="1.1"/>
                        <circle class="st0" cx="912" cy="2072.7" r="1.1"/>
                        <circle class="st0" cx="942.7" cy="2107.3" r="1.1"/>
                        <circle class="st0" cx="902.3" cy="2110.4" r="1.1"/>
                        <circle class="st0" cx="916.3" cy="2075.2" r="1.1"/>
                        <circle class="st0" cx="929" cy="2143" r="1.1"/>
                        <circle class="st0" cx="908.3" cy="2125.8" r="1.1"/>
                        <circle class="st0" cx="920.6" cy="2094.6" r="1.1"/>
                    </g>
                </g>
            </g>
            <g>
                <circle class="st0" cx="1112.4" cy="1413.4" r="4.3"/>
                <circle class="st0" cx="1376.6" cy="1539.1" r="4.3"/>
                <circle class="st0" cx="1598.6" cy="1243.1" r="4.3"/>
                <circle class="st0" cx="1966.5" cy="1776" r="4.3"/>
                <circle class="st0" cx="1667.6" cy="1913" r="4.3"/>
                <circle class="st0" cx="1282.7" cy="1843" r="4.3"/>
                <circle class="st0" cx="1300.6" cy="1748" r="4.3"/>
                <circle class="st0" cx="1276.7" cy="1528.1" r="4.3"/>
                <circle class="st0" cx="1303.6" cy="1201.2" r="4.3"/>
                <circle class="st0" cx="1650.6" cy="1028.2" r="4.3"/>
                <circle class="st0" cx="1822.5" cy="1039.2" r="4.3"/>
                <circle class="st0" cx="2066.5" cy="1035.2" r="4.3"/>
                <circle class="st0" cx="1981.5" cy="1337.1" r="4.3"/>
                <circle class="st0" cx="1973.5" cy="1564.1" r="4.3"/>
                <circle class="st0" cx="1901.5" cy="1677.1" r="4.3"/>
                <circle class="st0" cx="1767.5" cy="1697.1" r="4.3"/>
                <circle class="st0" cx="1598.6" cy="1615.1" r="4.3"/>
                <circle class="st0" cx="1157.7" cy="1615.1" r="4.3"/>
                <circle class="st0" cx="1181.7" cy="1322.1" r="4.3"/>
                <circle class="st0" cx="1260.7" cy="1090.2" r="4.3"/>
                <circle class="st0" cx="1475.6" cy="1058.2" r="4.3"/>
                <circle class="st0" cx="1698.6" cy="1138.2" r="4.3"/>
                <circle class="st0" cx="1830.5" cy="1307.1" r="4.3"/>
                <circle class="st0" cx="1924.5" cy="1531.1" r="4.3"/>
                <circle class="st0" cx="2020.5" cy="1369.1" r="4.3"/>
                <circle class="st0" cx="2007.5" cy="1192.2" r="4.3"/>
                <circle class="st0" cx="1980.5" cy="1069.2" r="4.3"/>
                <circle class="st0" cx="1573.6" cy="1048.2" r="4.3"/>
                <circle class="st0" cx="1167.7" cy="983.2" r="4.3"/>
                <circle class="st0" cx="1023.7" cy="1095.2" r="4.3"/>
                <circle class="st0" cx="1436.6" cy="1576.1" r="4.3"/>
                <circle class="st0" cx="1566.6" cy="1488.1" r="4.3"/>
                <circle class="st0" cx="1871.5" cy="2039" r="4.3"/>
                <circle class="st0" cx="1270.7" cy="2022" r="4.3"/>
                <circle class="st0" cx="1069.7" cy="1944" r="4.3"/>
                <circle class="st0" cx="1035.7" cy="1805" r="4.3"/>
                <circle class="st0" cx="1017.7" cy="1672.1" r="4.3"/>
                <g>
                    <circle class="st0" cx="1810" cy="1394.8" r="1.4"/>
                    <circle class="st0" cx="1805.1" cy="1356.7" r="1.4"/>
                    <circle class="st0" cx="1779.7" cy="1388.8" r="1.4"/>
                    <circle class="st0" cx="1779.7" cy="1358.1" r="1.4"/>
                    <circle class="st0" cx="1739.6" cy="1384.7" r="1.4"/>
                    <circle class="st0" cx="1754.4" cy="1354" r="1.4"/>
                    <circle class="st0" cx="1773.4" cy="1313.7" r="1.4"/>
                    <circle class="st0" cx="1768.3" cy="1343.1" r="1.4"/>
                    <circle class="st0" cx="1735.5" cy="1335.1" r="1.4"/>
                    <circle class="st0" cx="1732.7" cy="1365.1" r="1.4"/>
                    <circle class="st0" cx="1700.4" cy="1392.9" r="1.4"/>
                    <circle class="st0" cx="1749.2" cy="1422.6" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1610.1" cy="1232.2" r="1.4"/>
                    <circle class="st0" cx="1605.1" cy="1194" r="1.4"/>
                    <circle class="st0" cx="1579.8" cy="1226.2" r="1.4"/>
                    <circle class="st0" cx="1579.8" cy="1195.4" r="1.4"/>
                    <circle class="st0" cx="1539.7" cy="1222" r="1.4"/>
                    <circle class="st0" cx="1554.5" cy="1191.4" r="1.4"/>
                    <circle class="st0" cx="1573.4" cy="1151.1" r="1.4"/>
                    <circle class="st0" cx="1568.3" cy="1180.5" r="1.4"/>
                    <circle class="st0" cx="1535.6" cy="1172.5" r="1.4"/>
                    <circle class="st0" cx="1532.8" cy="1202.5" r="1.4"/>
                    <circle class="st0" cx="1500.5" cy="1230.3" r="1.4"/>
                    <circle class="st0" cx="1549.2" cy="1259.9" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="2008.6" cy="1202.9" r="1.4"/>
                    <circle class="st0" cx="2003.7" cy="1164.7" r="1.4"/>
                    <circle class="st0" cx="1978.4" cy="1196.8" r="1.4"/>
                    <circle class="st0" cx="1978.4" cy="1166.1" r="1.4"/>
                    <circle class="st0" cx="1938.3" cy="1192.7" r="1.4"/>
                    <circle class="st0" cx="1953" cy="1162.1" r="1.4"/>
                    <circle class="st0" cx="1972" cy="1121.7" r="1.4"/>
                    <circle class="st0" cx="1966.9" cy="1151.2" r="1.4"/>
                    <circle class="st0" cx="1934.1" cy="1143.2" r="1.4"/>
                    <circle class="st0" cx="1931.4" cy="1173.2" r="1.4"/>
                    <circle class="st0" cx="1899" cy="1200.9" r="1.4"/>
                    <circle class="st0" cx="1947.8" cy="1230.6" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1844.7" cy="1152.2" r="1.4"/>
                    <circle class="st0" cx="1839.7" cy="1114.1" r="1.4"/>
                    <circle class="st0" cx="1814.4" cy="1146.2" r="1.4"/>
                    <circle class="st0" cx="1814.4" cy="1115.5" r="1.4"/>
                    <circle class="st0" cx="1774.3" cy="1142.1" r="1.4"/>
                    <circle class="st0" cx="1789.1" cy="1111.4" r="1.4"/>
                    <circle class="st0" cx="1808.1" cy="1071.1" r="1.4"/>
                    <circle class="st0" cx="1803" cy="1100.5" r="1.4"/>
                    <circle class="st0" cx="1770.2" cy="1092.5" r="1.4"/>
                    <circle class="st0" cx="1767.4" cy="1122.5" r="1.4"/>
                    <circle class="st0" cx="1735.1" cy="1150.3" r="1.4"/>
                    <circle class="st0" cx="1783.8" cy="1179.9" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1987.3" cy="1068.2" r="1.4"/>
                    <circle class="st0" cx="1982.4" cy="1030.1" r="1.4"/>
                    <circle class="st0" cx="1957" cy="1062.2" r="1.4"/>
                    <circle class="st0" cx="1957" cy="1031.5" r="1.4"/>
                    <circle class="st0" cx="1916.9" cy="1058.1" r="1.4"/>
                    <circle class="st0" cx="1931.7" cy="1027.4" r="1.4"/>
                    <circle class="st0" cx="1950.7" cy="987.1" r="1.4"/>
                    <circle class="st0" cx="1945.6" cy="1016.5" r="1.4"/>
                    <circle class="st0" cx="1912.8" cy="1008.5" r="1.4"/>
                    <circle class="st0" cx="1910" cy="1038.5" r="1.4"/>
                    <circle class="st0" cx="1877.7" cy="1066.3" r="1.4"/>
                    <circle class="st0" cx="1926.5" cy="1096" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1956.6" cy="1417.5" r="1.4"/>
                    <circle class="st0" cx="1951.7" cy="1379.3" r="1.4"/>
                    <circle class="st0" cx="1926.4" cy="1411.4" r="1.4"/>
                    <circle class="st0" cx="1926.4" cy="1380.7" r="1.4"/>
                    <circle class="st0" cx="1886.3" cy="1407.3" r="1.4"/>
                    <circle class="st0" cx="1901" cy="1376.7" r="1.4"/>
                    <circle class="st0" cx="1920" cy="1336.4" r="1.4"/>
                    <circle class="st0" cx="1914.9" cy="1365.8" r="1.4"/>
                    <circle class="st0" cx="1882.2" cy="1357.8" r="1.4"/>
                    <circle class="st0" cx="1879.4" cy="1387.8" r="1.4"/>
                    <circle class="st0" cx="1847.1" cy="1415.6" r="1.4"/>
                    <circle class="st0" cx="1895.8" cy="1445.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="2074" cy="1482.8" r="1.4"/>
                    <circle class="st0" cx="2069" cy="1444.7" r="1.4"/>
                    <circle class="st0" cx="2043.7" cy="1476.8" r="1.4"/>
                    <circle class="st0" cx="2043.7" cy="1446.1" r="1.4"/>
                    <circle class="st0" cx="2003.6" cy="1472.7" r="1.4"/>
                    <circle class="st0" cx="2018.4" cy="1442" r="1.4"/>
                    <circle class="st0" cx="2037.3" cy="1401.7" r="1.4"/>
                    <circle class="st0" cx="2032.2" cy="1431.1" r="1.4"/>
                    <circle class="st0" cx="1999.5" cy="1423.1" r="1.4"/>
                    <circle class="st0" cx="1996.7" cy="1453.1" r="1.4"/>
                    <circle class="st0" cx="1964.4" cy="1480.9" r="1.4"/>
                    <circle class="st0" cx="2013.1" cy="1510.5" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="2071.3" cy="1397.5" r="1.4"/>
                    <circle class="st0" cx="2066.3" cy="1359.3" r="1.4"/>
                    <circle class="st0" cx="2041" cy="1391.5" r="1.4"/>
                    <circle class="st0" cx="2041" cy="1360.7" r="1.4"/>
                    <circle class="st0" cx="2000.9" cy="1387.3" r="1.4"/>
                    <circle class="st0" cx="2015.7" cy="1356.7" r="1.4"/>
                    <circle class="st0" cx="2034.7" cy="1316.4" r="1.4"/>
                    <circle class="st0" cx="2029.6" cy="1345.8" r="1.4"/>
                    <circle class="st0" cx="1996.8" cy="1337.8" r="1.4"/>
                    <circle class="st0" cx="1994" cy="1367.8" r="1.4"/>
                    <circle class="st0" cx="1961.7" cy="1395.6" r="1.4"/>
                    <circle class="st0" cx="2010.5" cy="1425.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1807.3" cy="1568.1" r="1.4"/>
                    <circle class="st0" cx="1802.4" cy="1530" r="1.4"/>
                    <circle class="st0" cx="1777.1" cy="1562.1" r="1.4"/>
                    <circle class="st0" cx="1777.1" cy="1531.4" r="1.4"/>
                    <circle class="st0" cx="1737" cy="1558" r="1.4"/>
                    <circle class="st0" cx="1751.7" cy="1527.3" r="1.4"/>
                    <circle class="st0" cx="1770.7" cy="1487" r="1.4"/>
                    <circle class="st0" cx="1765.6" cy="1516.4" r="1.4"/>
                    <circle class="st0" cx="1732.9" cy="1508.4" r="1.4"/>
                    <circle class="st0" cx="1730.1" cy="1538.4" r="1.4"/>
                    <circle class="st0" cx="1697.8" cy="1566.2" r="1.4"/>
                    <circle class="st0" cx="1746.5" cy="1595.9" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1746" cy="1501.5" r="1.4"/>
                    <circle class="st0" cx="1741.1" cy="1463.3" r="1.4"/>
                    <circle class="st0" cx="1715.8" cy="1495.4" r="1.4"/>
                    <circle class="st0" cx="1715.8" cy="1464.7" r="1.4"/>
                    <circle class="st0" cx="1675.6" cy="1491.3" r="1.4"/>
                    <circle class="st0" cx="1690.4" cy="1460.7" r="1.4"/>
                    <circle class="st0" cx="1709.4" cy="1420.3" r="1.4"/>
                    <circle class="st0" cx="1704.3" cy="1449.8" r="1.4"/>
                    <circle class="st0" cx="1671.5" cy="1441.8" r="1.4"/>
                    <circle class="st0" cx="1668.8" cy="1471.8" r="1.4"/>
                    <circle class="st0" cx="1636.4" cy="1499.5" r="1.4"/>
                    <circle class="st0" cx="1685.2" cy="1529.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1488.7" cy="1633.5" r="1.4"/>
                    <circle class="st0" cx="1483.8" cy="1595.3" r="1.4"/>
                    <circle class="st0" cx="1458.5" cy="1627.4" r="1.4"/>
                    <circle class="st0" cx="1458.5" cy="1596.7" r="1.4"/>
                    <circle class="st0" cx="1418.4" cy="1623.3" r="1.4"/>
                    <circle class="st0" cx="1433.1" cy="1592.6" r="1.4"/>
                    <circle class="st0" cx="1452.1" cy="1552.3" r="1.4"/>
                    <circle class="st0" cx="1447" cy="1581.7" r="1.4"/>
                    <circle class="st0" cx="1414.3" cy="1573.7" r="1.4"/>
                    <circle class="st0" cx="1411.5" cy="1603.7" r="1.4"/>
                    <circle class="st0" cx="1379.2" cy="1631.5" r="1.4"/>
                    <circle class="st0" cx="1427.9" cy="1661.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1299.5" cy="1852.1" r="1.4"/>
                    <circle class="st0" cx="1294.5" cy="1813.9" r="1.4"/>
                    <circle class="st0" cx="1269.2" cy="1846" r="1.4"/>
                    <circle class="st0" cx="1269.2" cy="1815.3" r="1.4"/>
                    <circle class="st0" cx="1229.1" cy="1841.9" r="1.4"/>
                    <circle class="st0" cx="1243.9" cy="1811.2" r="1.4"/>
                    <circle class="st0" cx="1262.8" cy="1770.9" r="1.4"/>
                    <circle class="st0" cx="1257.7" cy="1800.4" r="1.4"/>
                    <circle class="st0" cx="1225" cy="1792.4" r="1.4"/>
                    <circle class="st0" cx="1222.2" cy="1822.4" r="1.4"/>
                    <circle class="st0" cx="1189.9" cy="1850.1" r="1.4"/>
                    <circle class="st0" cx="1238.6" cy="1879.8" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1218.1" cy="1753.4" r="1.4"/>
                    <circle class="st0" cx="1213.2" cy="1715.3" r="1.4"/>
                    <circle class="st0" cx="1187.9" cy="1747.4" r="1.4"/>
                    <circle class="st0" cx="1187.9" cy="1716.7" r="1.4"/>
                    <circle class="st0" cx="1147.8" cy="1743.3" r="1.4"/>
                    <circle class="st0" cx="1162.5" cy="1712.6" r="1.4"/>
                    <circle class="st0" cx="1181.5" cy="1672.3" r="1.4"/>
                    <circle class="st0" cx="1176.4" cy="1701.7" r="1.4"/>
                    <circle class="st0" cx="1143.7" cy="1693.7" r="1.4"/>
                    <circle class="st0" cx="1140.9" cy="1723.7" r="1.4"/>
                    <circle class="st0" cx="1108.5" cy="1751.5" r="1.4"/>
                    <circle class="st0" cx="1157.3" cy="1781.1" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1683.4" cy="1753.4" r="1.4"/>
                    <circle class="st0" cx="1678.4" cy="1715.3" r="1.4"/>
                    <circle class="st0" cx="1653.1" cy="1747.4" r="1.4"/>
                    <circle class="st0" cx="1653.1" cy="1716.7" r="1.4"/>
                    <circle class="st0" cx="1613" cy="1743.3" r="1.4"/>
                    <circle class="st0" cx="1627.8" cy="1712.6" r="1.4"/>
                    <circle class="st0" cx="1646.8" cy="1672.3" r="1.4"/>
                    <circle class="st0" cx="1641.7" cy="1701.7" r="1.4"/>
                    <circle class="st0" cx="1608.9" cy="1693.7" r="1.4"/>
                    <circle class="st0" cx="1606.1" cy="1723.7" r="1.4"/>
                    <circle class="st0" cx="1573.8" cy="1751.5" r="1.4"/>
                    <circle class="st0" cx="1622.5" cy="1781.1" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1838" cy="1800.1" r="1.4"/>
                    <circle class="st0" cx="1833.1" cy="1761.9" r="1.4"/>
                    <circle class="st0" cx="1807.7" cy="1794" r="1.4"/>
                    <circle class="st0" cx="1807.7" cy="1763.3" r="1.4"/>
                    <circle class="st0" cx="1767.6" cy="1789.9" r="1.4"/>
                    <circle class="st0" cx="1782.4" cy="1759.3" r="1.4"/>
                    <circle class="st0" cx="1801.4" cy="1718.9" r="1.4"/>
                    <circle class="st0" cx="1796.3" cy="1748.4" r="1.4"/>
                    <circle class="st0" cx="1763.5" cy="1740.4" r="1.4"/>
                    <circle class="st0" cx="1760.7" cy="1770.4" r="1.4"/>
                    <circle class="st0" cx="1728.4" cy="1798.1" r="1.4"/>
                    <circle class="st0" cx="1777.2" cy="1827.8" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1760.7" cy="1881.4" r="1.4"/>
                    <circle class="st0" cx="1755.7" cy="1843.2" r="1.4"/>
                    <circle class="st0" cx="1730.4" cy="1875.3" r="1.4"/>
                    <circle class="st0" cx="1730.4" cy="1844.6" r="1.4"/>
                    <circle class="st0" cx="1690.3" cy="1871.2" r="1.4"/>
                    <circle class="st0" cx="1705.1" cy="1840.6" r="1.4"/>
                    <circle class="st0" cx="1724.1" cy="1800.3" r="1.4"/>
                    <circle class="st0" cx="1719" cy="1829.7" r="1.4"/>
                    <circle class="st0" cx="1686.2" cy="1821.7" r="1.4"/>
                    <circle class="st0" cx="1683.4" cy="1851.7" r="1.4"/>
                    <circle class="st0" cx="1651.1" cy="1879.5" r="1.4"/>
                    <circle class="st0" cx="1699.9" cy="1909.1" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1676.7" cy="1865.4" r="1.4"/>
                    <circle class="st0" cx="1671.8" cy="1827.2" r="1.4"/>
                    <circle class="st0" cx="1646.4" cy="1859.4" r="1.4"/>
                    <circle class="st0" cx="1646.4" cy="1828.6" r="1.4"/>
                    <circle class="st0" cx="1606.3" cy="1855.2" r="1.4"/>
                    <circle class="st0" cx="1621.1" cy="1824.6" r="1.4"/>
                    <circle class="st0" cx="1640.1" cy="1784.3" r="1.4"/>
                    <circle class="st0" cx="1635" cy="1813.7" r="1.4"/>
                    <circle class="st0" cx="1602.2" cy="1805.7" r="1.4"/>
                    <circle class="st0" cx="1599.4" cy="1835.7" r="1.4"/>
                    <circle class="st0" cx="1567.1" cy="1863.5" r="1.4"/>
                    <circle class="st0" cx="1615.9" cy="1893.1" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1578.1" cy="1846.7" r="1.4"/>
                    <circle class="st0" cx="1573.1" cy="1808.6" r="1.4"/>
                    <circle class="st0" cx="1547.8" cy="1840.7" r="1.4"/>
                    <circle class="st0" cx="1547.8" cy="1810" r="1.4"/>
                    <circle class="st0" cx="1507.7" cy="1836.6" r="1.4"/>
                    <circle class="st0" cx="1522.5" cy="1805.9" r="1.4"/>
                    <circle class="st0" cx="1541.5" cy="1765.6" r="1.4"/>
                    <circle class="st0" cx="1536.3" cy="1795" r="1.4"/>
                    <circle class="st0" cx="1503.6" cy="1787" r="1.4"/>
                    <circle class="st0" cx="1500.8" cy="1817" r="1.4"/>
                    <circle class="st0" cx="1468.5" cy="1844.8" r="1.4"/>
                    <circle class="st0" cx="1517.2" cy="1874.5" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1463.4" cy="1226.9" r="1.4"/>
                    <circle class="st0" cx="1458.5" cy="1188.7" r="1.4"/>
                    <circle class="st0" cx="1433.1" cy="1220.8" r="1.4"/>
                    <circle class="st0" cx="1433.1" cy="1190.1" r="1.4"/>
                    <circle class="st0" cx="1393" cy="1216.7" r="1.4"/>
                    <circle class="st0" cx="1407.8" cy="1186.1" r="1.4"/>
                    <circle class="st0" cx="1426.8" cy="1145.7" r="1.4"/>
                    <circle class="st0" cx="1421.7" cy="1175.2" r="1.4"/>
                    <circle class="st0" cx="1388.9" cy="1167.2" r="1.4"/>
                    <circle class="st0" cx="1386.2" cy="1197.2" r="1.4"/>
                    <circle class="st0" cx="1353.8" cy="1224.9" r="1.4"/>
                    <circle class="st0" cx="1402.6" cy="1254.6" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1171.5" cy="1140.7" r="1.4"/>
                    <circle class="st0" cx="1166.5" cy="1102.6" r="1.4"/>
                    <circle class="st0" cx="1141.2" cy="1134.7" r="1.4"/>
                    <circle class="st0" cx="1141.2" cy="1104" r="1.4"/>
                    <circle class="st0" cx="1101.1" cy="1130.6" r="1.4"/>
                    <circle class="st0" cx="1115.9" cy="1099.9" r="1.4"/>
                    <circle class="st0" cx="1134.9" cy="1059.6" r="1.4"/>
                    <circle class="st0" cx="1129.8" cy="1089" r="1.4"/>
                    <circle class="st0" cx="1097" cy="1081" r="1.4"/>
                    <circle class="st0" cx="1094.2" cy="1111" r="1.4"/>
                    <circle class="st0" cx="1061.9" cy="1138.8" r="1.4"/>
                    <circle class="st0" cx="1110.7" cy="1168.4" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1126.2" cy="1529.5" r="1.4"/>
                    <circle class="st0" cx="1121.2" cy="1491.3" r="1.4"/>
                    <circle class="st0" cx="1095.9" cy="1523.4" r="1.4"/>
                    <circle class="st0" cx="1095.9" cy="1492.7" r="1.4"/>
                    <circle class="st0" cx="1055.8" cy="1519.3" r="1.4"/>
                    <circle class="st0" cx="1070.6" cy="1488.7" r="1.4"/>
                    <circle class="st0" cx="1089.6" cy="1448.3" r="1.4"/>
                    <circle class="st0" cx="1084.4" cy="1477.8" r="1.4"/>
                    <circle class="st0" cx="1051.7" cy="1469.8" r="1.4"/>
                    <circle class="st0" cx="1048.9" cy="1499.8" r="1.4"/>
                    <circle class="st0" cx="1016.6" cy="1527.5" r="1.4"/>
                    <circle class="st0" cx="1065.3" cy="1557.2" r="1.4"/>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="1154.5" cy="1986.5" r="1.1"/>
                        <circle class="st0" cx="1154.5" cy="1986.5" r="1.1"/>
                        <circle class="st0" cx="1174" cy="1934.7" r="1.1"/>
                        <circle class="st0" cx="1144" cy="1969.8" r="1.1"/>
                        <circle class="st0" cx="1135.3" cy="1930.3" r="1.1"/>
                        <circle class="st0" cx="1172.1" cy="1939.3" r="1.1"/>
                        <circle class="st0" cx="1106.7" cy="1961.2" r="1.1"/>
                        <circle class="st0" cx="1120.9" cy="1938.3" r="1.1"/>
                        <circle class="st0" cx="1153.5" cy="1946.2" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="1139.4" cy="1906.1" r="1.1"/>
                        <circle class="st0" cx="1139.4" cy="1906.1" r="1.1"/>
                        <circle class="st0" cx="1090.7" cy="1879.8" r="1.1"/>
                        <circle class="st0" cx="1121.5" cy="1914.3" r="1.1"/>
                        <circle class="st0" cx="1081.1" cy="1917.5" r="1.1"/>
                        <circle class="st0" cx="1095.1" cy="1882.2" r="1.1"/>
                        <circle class="st0" cx="1107.8" cy="1950.1" r="1.1"/>
                        <circle class="st0" cx="1087.1" cy="1932.8" r="1.1"/>
                        <circle class="st0" cx="1099.3" cy="1901.6" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="1833.6" cy="1455.5" r="1.1"/>
                        <circle class="st0" cx="1833.6" cy="1455.5" r="1.1"/>
                        <circle class="st0" cx="1853" cy="1403.7" r="1.1"/>
                        <circle class="st0" cx="1823" cy="1438.8" r="1.1"/>
                        <circle class="st0" cx="1814.4" cy="1399.3" r="1.1"/>
                        <circle class="st0" cx="1851.2" cy="1408.3" r="1.1"/>
                        <circle class="st0" cx="1785.7" cy="1430.2" r="1.1"/>
                        <circle class="st0" cx="1800" cy="1407.3" r="1.1"/>
                        <circle class="st0" cx="1832.5" cy="1415.2" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="1818.4" cy="1375.1" r="1.1"/>
                        <circle class="st0" cx="1818.4" cy="1375.1" r="1.1"/>
                        <circle class="st0" cx="1769.8" cy="1348.8" r="1.1"/>
                        <circle class="st0" cx="1800.5" cy="1383.3" r="1.1"/>
                        <circle class="st0" cx="1760.1" cy="1386.5" r="1.1"/>
                        <circle class="st0" cx="1774.1" cy="1351.2" r="1.1"/>
                        <circle class="st0" cx="1786.8" cy="1419.1" r="1.1"/>
                        <circle class="st0" cx="1766.1" cy="1401.8" r="1.1"/>
                        <circle class="st0" cx="1778.4" cy="1370.7" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="1728.6" cy="1802.4" r="1.1"/>
                        <circle class="st0" cx="1728.6" cy="1802.4" r="1.1"/>
                        <circle class="st0" cx="1748" cy="1750.6" r="1.1"/>
                        <circle class="st0" cx="1718" cy="1785.8" r="1.1"/>
                        <circle class="st0" cx="1709.4" cy="1746.2" r="1.1"/>
                        <circle class="st0" cx="1746.2" cy="1755.3" r="1.1"/>
                        <circle class="st0" cx="1680.7" cy="1777.1" r="1.1"/>
                        <circle class="st0" cx="1695" cy="1754.2" r="1.1"/>
                        <circle class="st0" cx="1727.5" cy="1762.1" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="1713.5" cy="1722.1" r="1.1"/>
                        <circle class="st0" cx="1713.5" cy="1722.1" r="1.1"/>
                        <circle class="st0" cx="1664.8" cy="1695.7" r="1.1"/>
                        <circle class="st0" cx="1695.5" cy="1730.2" r="1.1"/>
                        <circle class="st0" cx="1655.2" cy="1733.4" r="1.1"/>
                        <circle class="st0" cx="1669.2" cy="1698.2" r="1.1"/>
                        <circle class="st0" cx="1681.8" cy="1766" r="1.1"/>
                        <circle class="st0" cx="1661.1" cy="1748.8" r="1.1"/>
                        <circle class="st0" cx="1673.4" cy="1717.6" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="1960.5" cy="2002.4" r="1.1"/>
                        <circle class="st0" cx="1960.5" cy="2002.4" r="1.1"/>
                        <circle class="st0" cx="1980" cy="1950.6" r="1.1"/>
                        <circle class="st0" cx="1950" cy="1985.7" r="1.1"/>
                        <circle class="st0" cx="1941.3" cy="1946.2" r="1.1"/>
                        <circle class="st0" cx="1978.2" cy="1955.2" r="1.1"/>
                        <circle class="st0" cx="1912.7" cy="1977.1" r="1.1"/>
                        <circle class="st0" cx="1926.9" cy="1954.2" r="1.1"/>
                        <circle class="st0" cx="1959.5" cy="1962.1" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="1945.4" cy="1922" r="1.1"/>
                        <circle class="st0" cx="1945.4" cy="1922" r="1.1"/>
                        <circle class="st0" cx="1896.8" cy="1895.7" r="1.1"/>
                        <circle class="st0" cx="1927.5" cy="1930.2" r="1.1"/>
                        <circle class="st0" cx="1887.1" cy="1933.4" r="1.1"/>
                        <circle class="st0" cx="1901.1" cy="1898.1" r="1.1"/>
                        <circle class="st0" cx="1913.8" cy="1966" r="1.1"/>
                        <circle class="st0" cx="1893.1" cy="1948.7" r="1.1"/>
                        <circle class="st0" cx="1905.3" cy="1917.6" r="1.1"/>
                    </g>
                </g>
            </g>
            <linearGradient id="SVGID_17_" gradientUnits="userSpaceOnUse" x1="2889.2" y1="-1280.1" x2="3027" y2="-1280.1" gradientTransform="matrix(1 0 0 1 0 1968)">
                <stop  offset="0.2723" style="stop-color:#2D2D73"/>
                <stop  offset="0.9418" style="stop-color:#171344"/>
            </linearGradient>
            <rect x="2889.2" y="619" class="st27" width="137.8" height="137.8"/>
            <rect x="2713.5" y="619" class="st15" width="137.8" height="137.8"/>
            <rect x="2713.5" y="431.6" class="st22" width="137.8" height="137.8"/>
            <rect x="2889.2" y="431.6" class="st22" width="137.8" height="137.8"/>
            <rect x="3046.4" y="414.7" class="st23" width="155.8" height="155.8"/>
            <rect x="3166.8" y="627.9" class="st24" width="173.9" height="173.9"/>
            <linearGradient id="SVGID_18_" gradientUnits="userSpaceOnUse" x1="114.9847" y1="-1828.6229" x2="158.1595" y2="-1877.8573" gradientTransform="matrix(1 0 0 1 0 1968)">
                <stop  offset="0.2536" style="stop-color:#555496"/>
                <stop  offset="0.9418" style="stop-color:#612A81"/>
            </linearGradient>
            <circle class="st28" cx="131.1" cy="121" r="50.9"/>
            <rect x="-1811.6" y="892.4" class="st29" width="173.9" height="173.9"/>
            <rect x="-1713.1" y="586.1" class="st30" width="173.9" height="173.9"/>
            <rect x="2538" y="395.3" class="st29" width="173.9" height="173.9"/>
            <rect x="2636.6" y="89" class="st30" width="173.9" height="173.9"/>
            <rect x="-1414.1" y="655.6" class="st31" width="137.8" height="137.8"/>
            <rect x="3230" y="1264.9" class="st31" width="137.8" height="137.8"/>
            <g class="st32">
                <circle class="st0" cx="-297.5" cy="631" r="4.3"/>
                <circle class="st0" cx="-33.2" cy="756.7" r="4.3"/>
                <circle class="st0" cx="188.7" cy="460.7" r="4.3"/>
                <circle class="st0" cx="556.7" cy="993.6" r="4.3"/>
                
                    <ellipse transform="matrix(6.652097e-02 -0.9978 0.9978 6.652097e-02 -887.5986 1312.4797)" class="st0" cx="257.6" cy="1130.6" rx="4.3" ry="4.3"/>
                <circle class="st0" cx="-127.2" cy="1060.6" r="4.3"/>
                <circle class="st0" cx="-109.2" cy="965.6" r="4.3"/>
                <circle class="st0" cx="-133.2" cy="745.7" r="4.3"/>
                <circle class="st0" cx="-106.2" cy="418.7" r="4.3"/>
                <circle class="st0" cx="240.7" cy="245.8" r="4.3"/>
                <circle class="st0" cx="412.7" cy="256.8" r="4.3"/>
                <circle class="st0" cx="656.6" cy="252.8" r="4.3"/>
                <circle class="st0" cx="571.6" cy="554.7" r="4.3"/>
                <circle class="st0" cx="563.7" cy="781.7" r="4.3"/>
                <circle class="st0" cx="491.7" cy="894.6" r="4.3"/>
                <circle class="st0" cx="357.7" cy="914.6" r="4.3"/>
                <circle class="st0" cx="188.7" cy="832.6" r="4.3"/>
                <circle class="st0" cx="-252.2" cy="832.6" r="4.3"/>
                <circle class="st0" cx="-228.2" cy="539.7" r="4.3"/>
                <circle class="st0" cx="-149.2" cy="307.8" r="4.3"/>
                
                    <ellipse transform="matrix(6.652045e-02 -0.9978 0.9978 6.652045e-02 -213.781 323.0981)" class="st0" cx="65.8" cy="275.8" rx="4.3" ry="4.3"/>
                <circle class="st0" cx="288.7" cy="355.8" r="4.3"/>
                <circle class="st0" cx="420.7" cy="524.7" r="4.3"/>
                <circle class="st0" cx="514.7" cy="748.7" r="4.3"/>
                <circle class="st0" cx="610.6" cy="586.7" r="4.3"/>
                <circle class="st0" cx="597.6" cy="409.7" r="4.3"/>
                <circle class="st0" cx="570.6" cy="286.8" r="4.3"/>
                <circle class="st0" cx="163.7" cy="265.8" r="4.3"/>
                <circle class="st0" cx="-242.2" cy="200.8" r="4.3"/>
                <circle class="st0" cx="-386.1" cy="312.8" r="4.3"/>
                <circle class="st0" cx="26.8" cy="793.7" r="4.3"/>
                <circle class="st0" cx="156.7" cy="705.7" r="4.3"/>
                <circle class="st0" cx="461.7" cy="1256.6" r="4.3"/>
                <circle class="st0" cx="-139.2" cy="1239.6" r="4.3"/>
                <circle class="st0" cx="-340.2" cy="1161.6" r="4.3"/>
                <circle class="st0" cx="-374.1" cy="1022.6" r="4.3"/>
                <circle class="st0" cx="-392.1" cy="889.6" r="4.3"/>
                <g>
                    <circle class="st0" cx="400.2" cy="612.4" r="1.4"/>
                    <circle class="st0" cx="395.2" cy="574.3" r="1.4"/>
                    <circle class="st0" cx="369.9" cy="606.4" r="1.4"/>
                    <circle class="st0" cx="369.9" cy="575.7" r="1.4"/>
                    <circle class="st0" cx="329.8" cy="602.3" r="1.4"/>
                    <circle class="st0" cx="344.6" cy="571.6" r="1.4"/>
                    <circle class="st0" cx="363.6" cy="531.3" r="1.4"/>
                    <circle class="st0" cx="358.4" cy="560.7" r="1.4"/>
                    <circle class="st0" cx="325.7" cy="552.7" r="1.4"/>
                    <circle class="st0" cx="322.9" cy="582.7" r="1.4"/>
                    <circle class="st0" cx="290.6" cy="610.5" r="1.4"/>
                    <circle class="st0" cx="339.3" cy="640.1" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="200.2" cy="449.8" r="1.4"/>
                    <circle class="st0" cx="195.3" cy="411.6" r="1.4"/>
                    <circle class="st0" cx="169.9" cy="443.7" r="1.4"/>
                    <circle class="st0" cx="169.9" cy="413" r="1.4"/>
                    <circle class="st0" cx="129.8" cy="439.6" r="1.4"/>
                    <circle class="st0" cx="144.6" cy="409" r="1.4"/>
                    <circle class="st0" cx="163.6" cy="368.6" r="1.4"/>
                    <circle class="st0" cx="158.5" cy="398.1" r="1.4"/>
                    <circle class="st0" cx="125.7" cy="390.1" r="1.4"/>
                    <circle class="st0" cx="122.9" cy="420.1" r="1.4"/>
                    <circle class="st0" cx="90.6" cy="447.8" r="1.4"/>
                    <circle class="st0" cx="139.4" cy="477.5" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="598.8" cy="420.5" r="1.4"/>
                    <circle class="st0" cx="593.8" cy="382.3" r="1.4"/>
                    <circle class="st0" cx="568.5" cy="414.4" r="1.4"/>
                    <circle class="st0" cx="568.5" cy="383.7" r="1.4"/>
                    <circle class="st0" cx="528.4" cy="410.3" r="1.4"/>
                    <circle class="st0" cx="543.2" cy="379.6" r="1.4"/>
                    <circle class="st0" cx="562.2" cy="339.3" r="1.4"/>
                    <circle class="st0" cx="557.1" cy="368.7" r="1.4"/>
                    <circle class="st0" cx="524.3" cy="360.8" r="1.4"/>
                    <circle class="st0" cx="521.5" cy="390.7" r="1.4"/>
                    <circle class="st0" cx="489.2" cy="418.5" r="1.4"/>
                    <circle class="st0" cx="538" cy="448.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="434.8" cy="369.8" r="1.4"/>
                    <circle class="st0" cx="429.9" cy="331.6" r="1.4"/>
                    <circle class="st0" cx="404.5" cy="363.7" r="1.4"/>
                    <circle class="st0" cx="404.5" cy="333" r="1.4"/>
                    <circle class="st0" cx="364.4" cy="359.6" r="1.4"/>
                    <circle class="st0" cx="379.2" cy="329" r="1.4"/>
                    <circle class="st0" cx="398.2" cy="288.7" r="1.4"/>
                    <circle class="st0" cx="393.1" cy="318.1" r="1.4"/>
                    <circle class="st0" cx="360.3" cy="310.1" r="1.4"/>
                    <circle class="st0" cx="357.6" cy="340.1" r="1.4"/>
                    <circle class="st0" cx="325.2" cy="367.9" r="1.4"/>
                    <circle class="st0" cx="374" cy="397.5" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="577.5" cy="285.8" r="1.4"/>
                    <circle class="st0" cx="572.5" cy="247.7" r="1.4"/>
                    <circle class="st0" cx="547.2" cy="279.8" r="1.4"/>
                    <circle class="st0" cx="547.2" cy="249.1" r="1.4"/>
                    <circle class="st0" cx="507.1" cy="275.7" r="1.4"/>
                    <circle class="st0" cx="521.9" cy="245" r="1.4"/>
                    <circle class="st0" cx="540.8" cy="204.7" r="1.4"/>
                    <circle class="st0" cx="535.7" cy="234.1" r="1.4"/>
                    <circle class="st0" cx="503" cy="226.1" r="1.4"/>
                    <circle class="st0" cx="500.2" cy="256.1" r="1.4"/>
                    <circle class="st0" cx="467.9" cy="283.9" r="1.4"/>
                    <circle class="st0" cx="516.6" cy="313.5" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="546.8" cy="635.1" r="1.4"/>
                    <circle class="st0" cx="541.8" cy="596.9" r="1.4"/>
                    <circle class="st0" cx="516.5" cy="629" r="1.4"/>
                    <circle class="st0" cx="516.5" cy="598.3" r="1.4"/>
                    <circle class="st0" cx="476.4" cy="624.9" r="1.4"/>
                    <circle class="st0" cx="491.2" cy="594.3" r="1.4"/>
                    <circle class="st0" cx="510.2" cy="553.9" r="1.4"/>
                    <circle class="st0" cx="505.1" cy="583.4" r="1.4"/>
                    <circle class="st0" cx="472.3" cy="575.4" r="1.4"/>
                    <circle class="st0" cx="469.5" cy="605.4" r="1.4"/>
                    <circle class="st0" cx="437.2" cy="633.1" r="1.4"/>
                    <circle class="st0" cx="486" cy="662.8" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="664.1" cy="700.4" r="1.4"/>
                    <circle class="st0" cx="659.2" cy="662.2" r="1.4"/>
                    <circle class="st0" cx="633.8" cy="694.3" r="1.4"/>
                    <circle class="st0" cx="633.8" cy="663.6" r="1.4"/>
                    <circle class="st0" cx="593.7" cy="690.2" r="1.4"/>
                    <circle class="st0" cx="608.5" cy="659.6" r="1.4"/>
                    <circle class="st0" cx="627.5" cy="619.2" r="1.4"/>
                    <circle class="st0" cx="622.4" cy="648.7" r="1.4"/>
                    <circle class="st0" cx="589.6" cy="640.7" r="1.4"/>
                    <circle class="st0" cx="586.8" cy="670.7" r="1.4"/>
                    <circle class="st0" cx="554.5" cy="698.5" r="1.4"/>
                    <circle class="st0" cx="603.3" cy="728.1" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="661.4" cy="615.1" r="1.4"/>
                    <circle class="st0" cx="656.5" cy="576.9" r="1.4"/>
                    <circle class="st0" cx="631.2" cy="609" r="1.4"/>
                    <circle class="st0" cx="631.2" cy="578.3" r="1.4"/>
                    <circle class="st0" cx="591.1" cy="604.9" r="1.4"/>
                    <circle class="st0" cx="605.8" cy="574.3" r="1.4"/>
                    <circle class="st0" cx="624.8" cy="533.9" r="1.4"/>
                    <circle class="st0" cx="619.7" cy="563.4" r="1.4"/>
                    <circle class="st0" cx="586.9" cy="555.4" r="1.4"/>
                    <circle class="st0" cx="584.2" cy="585.4" r="1.4"/>
                    <circle class="st0" cx="551.8" cy="613.1" r="1.4"/>
                    <circle class="st0" cx="600.6" cy="642.8" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="397.5" cy="785.7" r="1.4"/>
                    <circle class="st0" cx="392.5" cy="747.6" r="1.4"/>
                    <circle class="st0" cx="367.2" cy="779.7" r="1.4"/>
                    <circle class="st0" cx="367.2" cy="748.9" r="1.4"/>
                    <circle class="st0" cx="327.1" cy="775.5" r="1.4"/>
                    <circle class="st0" cx="341.9" cy="744.9" r="1.4"/>
                    <circle class="st0" cx="360.9" cy="704.6" r="1.4"/>
                    <circle class="st0" cx="355.8" cy="734" r="1.4"/>
                    <circle class="st0" cx="323" cy="726" r="1.4"/>
                    <circle class="st0" cx="320.2" cy="756" r="1.4"/>
                    <circle class="st0" cx="287.9" cy="783.8" r="1.4"/>
                    <circle class="st0" cx="336.7" cy="813.4" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="336.2" cy="719.1" r="1.4"/>
                    <circle class="st0" cx="331.2" cy="680.9" r="1.4"/>
                    <circle class="st0" cx="305.9" cy="713" r="1.4"/>
                    <circle class="st0" cx="305.9" cy="682.3" r="1.4"/>
                    <circle class="st0" cx="265.8" cy="708.9" r="1.4"/>
                    <circle class="st0" cx="280.6" cy="678.2" r="1.4"/>
                    <circle class="st0" cx="299.6" cy="637.9" r="1.4"/>
                    <circle class="st0" cx="294.5" cy="667.4" r="1.4"/>
                    <circle class="st0" cx="261.7" cy="659.4" r="1.4"/>
                    <circle class="st0" cx="258.9" cy="689.3" r="1.4"/>
                    <circle class="st0" cx="226.6" cy="717.1" r="1.4"/>
                    <circle class="st0" cx="275.4" cy="746.8" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="78.9" cy="851" r="1.4"/>
                    <circle class="st0" cx="73.9" cy="812.9" r="1.4"/>
                    <circle class="st0" cx="48.6" cy="845" r="1.4"/>
                    <circle class="st0" cx="48.6" cy="814.3" r="1.4"/>
                    
                        <ellipse transform="matrix(4.830883e-03 -1 1 4.830883e-03 -832.4287 845.34)" class="st0" cx="8.5" cy="840.9" rx="1.4" ry="1.4"/>
                    <circle class="st0" cx="23.3" cy="810.2" r="1.4"/>
                    <circle class="st0" cx="42.3" cy="769.9" r="1.4"/>
                    <circle class="st0" cx="37.2" cy="799.3" r="1.4"/>
                    <circle class="st0" cx="4.4" cy="791.3" r="1.4"/>
                    <circle class="st0" cx="1.6" cy="821.3" r="1.4"/>
                    
                        <ellipse transform="matrix(1.960376e-02 -0.9998 0.9998 1.960376e-02 -878.9966 801.8026)" class="st0" cx="-30.7" cy="849.1" rx="1.4" ry="1.4"/>
                    <circle class="st0" cx="18.1" cy="878.7" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="-110.4" cy="1069.6" r="1.4"/>
                    <circle class="st0" cx="-115.3" cy="1031.5" r="1.4"/>
                    <circle class="st0" cx="-140.7" cy="1063.6" r="1.4"/>
                    <circle class="st0" cx="-140.7" cy="1032.9" r="1.4"/>
                    <circle class="st0" cx="-180.8" cy="1059.5" r="1.4"/>
                    <circle class="st0" cx="-166" cy="1028.8" r="1.4"/>
                    <circle class="st0" cx="-147" cy="988.5" r="1.4"/>
                    <circle class="st0" cx="-152.1" cy="1017.9" r="1.4"/>
                    <circle class="st0" cx="-184.9" cy="1009.9" r="1.4"/>
                    <circle class="st0" cx="-187.7" cy="1039.9" r="1.4"/>
                    <circle class="st0" cx="-220" cy="1067.7" r="1.4"/>
                    <circle class="st0" cx="-171.2" cy="1097.4" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="-191.7" cy="971" r="1.4"/>
                    <circle class="st0" cx="-196.7" cy="932.8" r="1.4"/>
                    <circle class="st0" cx="-222" cy="965" r="1.4"/>
                    <circle class="st0" cx="-222" cy="934.2" r="1.4"/>
                    <circle class="st0" cx="-262.1" cy="960.8" r="1.4"/>
                    <circle class="st0" cx="-247.3" cy="930.2" r="1.4"/>
                    <circle class="st0" cx="-228.3" cy="889.9" r="1.4"/>
                    <circle class="st0" cx="-233.4" cy="919.3" r="1.4"/>
                    <circle class="st0" cx="-266.2" cy="911.3" r="1.4"/>
                    <circle class="st0" cx="-269" cy="941.3" r="1.4"/>
                    <circle class="st0" cx="-301.3" cy="969.1" r="1.4"/>
                    <circle class="st0" cx="-252.5" cy="998.7" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="273.5" cy="971" r="1.4"/>
                    <circle class="st0" cx="268.6" cy="932.8" r="1.4"/>
                    <circle class="st0" cx="243.2" cy="965" r="1.4"/>
                    <circle class="st0" cx="243.2" cy="934.2" r="1.4"/>
                    <circle class="st0" cx="203.1" cy="960.8" r="1.4"/>
                    <circle class="st0" cx="217.9" cy="930.2" r="1.4"/>
                    <circle class="st0" cx="236.9" cy="889.9" r="1.4"/>
                    <circle class="st0" cx="231.8" cy="919.3" r="1.4"/>
                    <circle class="st0" cx="199" cy="911.3" r="1.4"/>
                    <circle class="st0" cx="196.3" cy="941.3" r="1.4"/>
                    <circle class="st0" cx="163.9" cy="969.1" r="1.4"/>
                    <circle class="st0" cx="212.7" cy="998.7" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="428.2" cy="1017.7" r="1.4"/>
                    <circle class="st0" cx="423.2" cy="979.5" r="1.4"/>
                    <circle class="st0" cx="397.9" cy="1011.6" r="1.4"/>
                    <circle class="st0" cx="397.9" cy="980.9" r="1.4"/>
                    <circle class="st0" cx="357.8" cy="1007.5" r="1.4"/>
                    <circle class="st0" cx="372.6" cy="976.8" r="1.4"/>
                    <circle class="st0" cx="391.5" cy="936.5" r="1.4"/>
                    <circle class="st0" cx="386.4" cy="966" r="1.4"/>
                    <circle class="st0" cx="353.7" cy="958" r="1.4"/>
                    <circle class="st0" cx="350.9" cy="987.9" r="1.4"/>
                    <circle class="st0" cx="318.6" cy="1015.7" r="1.4"/>
                    <circle class="st0" cx="367.3" cy="1045.4" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="350.8" cy="1099" r="1.4"/>
                    <circle class="st0" cx="345.9" cy="1060.8" r="1.4"/>
                    <circle class="st0" cx="320.6" cy="1092.9" r="1.4"/>
                    <circle class="st0" cx="320.6" cy="1062.2" r="1.4"/>
                    <circle class="st0" cx="280.5" cy="1088.8" r="1.4"/>
                    <circle class="st0" cx="295.2" cy="1058.2" r="1.4"/>
                    <circle class="st0" cx="314.2" cy="1017.8" r="1.4"/>
                    <circle class="st0" cx="309.1" cy="1047.3" r="1.4"/>
                    <circle class="st0" cx="276.4" cy="1039.3" r="1.4"/>
                    <circle class="st0" cx="273.6" cy="1069.3" r="1.4"/>
                    <circle class="st0" cx="241.2" cy="1097" r="1.4"/>
                    <circle class="st0" cx="290" cy="1126.7" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="266.9" cy="1083" r="1.4"/>
                    <circle class="st0" cx="261.9" cy="1044.8" r="1.4"/>
                    <circle class="st0" cx="236.6" cy="1076.9" r="1.4"/>
                    <circle class="st0" cx="236.6" cy="1046.2" r="1.4"/>
                    <circle class="st0" cx="196.5" cy="1072.8" r="1.4"/>
                    <circle class="st0" cx="211.3" cy="1042.2" r="1.4"/>
                    <circle class="st0" cx="230.2" cy="1001.8" r="1.4"/>
                    <circle class="st0" cx="225.1" cy="1031.3" r="1.4"/>
                    <path class="st0" d="M192.4,1021.9c0.8,0,1.4,0.6,1.4,1.4s-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4S191.6,1021.9,192.4,1021.9z"/>
                    <circle class="st0" cx="189.6" cy="1053.3" r="1.4"/>
                    <circle class="st0" cx="157.3" cy="1081" r="1.4"/>
                    <circle class="st0" cx="206" cy="1110.7" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="168.2" cy="1064.3" r="1.4"/>
                    <circle class="st0" cx="163.3" cy="1026.2" r="1.4"/>
                    <circle class="st0" cx="137.9" cy="1058.3" r="1.4"/>
                    <circle class="st0" cx="137.9" cy="1027.6" r="1.4"/>
                    <circle class="st0" cx="97.8" cy="1054.2" r="1.4"/>
                    <circle class="st0" cx="112.6" cy="1023.5" r="1.4"/>
                    <circle class="st0" cx="131.6" cy="983.2" r="1.4"/>
                    <circle class="st0" cx="126.5" cy="1012.6" r="1.4"/>
                    <circle class="st0" cx="93.7" cy="1004.6" r="1.4"/>
                    <circle class="st0" cx="90.9" cy="1034.6" r="1.4"/>
                    <circle class="st0" cx="58.6" cy="1062.4" r="1.4"/>
                    <circle class="st0" cx="107.4" cy="1092" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="53.6" cy="444.5" r="1.4"/>
                    <circle class="st0" cx="48.6" cy="406.3" r="1.4"/>
                    <circle class="st0" cx="23.3" cy="438.4" r="1.4"/>
                    <circle class="st0" cx="23.3" cy="407.7" r="1.4"/>
                    <circle class="st0" cx="-16.8" cy="434.3" r="1.4"/>
                    <circle class="st0" cx="-2" cy="403.6" r="1.4"/>
                    <circle class="st0" cx="17" cy="363.3" r="1.4"/>
                    <circle class="st0" cx="11.9" cy="392.7" r="1.4"/>
                    <circle class="st0" cx="-20.9" cy="384.7" r="1.4"/>
                    <circle class="st0" cx="-23.7" cy="414.7" r="1.4"/>
                    <circle class="st0" cx="-56" cy="442.5" r="1.4"/>
                    <circle class="st0" cx="-7.3" cy="472.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="-238.4" cy="358.3" r="1.4"/>
                    <circle class="st0" cx="-243.3" cy="320.2" r="1.4"/>
                    <circle class="st0" cx="-268.6" cy="352.3" r="1.4"/>
                    <circle class="st0" cx="-268.6" cy="321.5" r="1.4"/>
                    <circle class="st0" cx="-308.7" cy="348.1" r="1.4"/>
                    <circle class="st0" cx="-294" cy="317.5" r="1.4"/>
                    <circle class="st0" cx="-275" cy="277.2" r="1.4"/>
                    <circle class="st0" cx="-280.1" cy="306.6" r="1.4"/>
                    <circle class="st0" cx="-312.9" cy="298.6" r="1.4"/>
                    <circle class="st0" cx="-315.6" cy="328.6" r="1.4"/>
                    <circle class="st0" cx="-348" cy="356.4" r="1.4"/>
                    <circle class="st0" cx="-299.2" cy="386" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="-283.7" cy="747.1" r="1.4"/>
                    <circle class="st0" cx="-288.6" cy="708.9" r="1.4"/>
                    <circle class="st0" cx="-314" cy="741" r="1.4"/>
                    <circle class="st0" cx="-314" cy="710.3" r="1.4"/>
                    <circle class="st0" cx="-354.1" cy="736.9" r="1.4"/>
                    <circle class="st0" cx="-339.3" cy="706.2" r="1.4"/>
                    <circle class="st0" cx="-320.3" cy="665.9" r="1.4"/>
                    <circle class="st0" cx="-325.4" cy="695.3" r="1.4"/>
                    <circle class="st0" cx="-358.2" cy="687.3" r="1.4"/>
                    <circle class="st0" cx="-361" cy="717.3" r="1.4"/>
                    <circle class="st0" cx="-393.3" cy="745.1" r="1.4"/>
                    <circle class="st0" cx="-344.5" cy="774.8" r="1.4"/>
                </g>
                <g>
                    <g>
                        <path class="st0" d="M-255.3,1203c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1S-255.9,1203-255.3,1203z"/>
                        <path class="st0" d="M-255.3,1203c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1S-255.9,1203-255.3,1203z"/>
                        <circle class="st0" cx="-235.9" cy="1152.2" r="1.1"/>
                        <circle class="st0" cx="-265.9" cy="1187.4" r="1.1"/>
                        <circle class="st0" cx="-274.5" cy="1147.9" r="1.1"/>
                        <circle class="st0" cx="-237.7" cy="1156.9" r="1.1"/>
                        <circle class="st0" cx="-303.2" cy="1178.7" r="1.1"/>
                        <circle class="st0" cx="-288.9" cy="1155.8" r="1.1"/>
                        <circle class="st0" cx="-256.4" cy="1163.7" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="-270.4" cy="1123.7" r="1.1"/>
                        <circle class="st0" cx="-270.4" cy="1123.7" r="1.1"/>
                        <circle class="st0" cx="-319.1" cy="1097.3" r="1.1"/>
                        <circle class="st0" cx="-288.4" cy="1131.9" r="1.1"/>
                        <circle class="st0" cx="-328.8" cy="1135" r="1.1"/>
                        <circle class="st0" cx="-314.7" cy="1099.8" r="1.1"/>
                        <circle class="st0" cx="-302.1" cy="1167.7" r="1.1"/>
                        <circle class="st0" cx="-322.8" cy="1150.4" r="1.1"/>
                        <circle class="st0" cx="-310.5" cy="1119.2" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="423.7" cy="673.1" r="1.1"/>
                        <circle class="st0" cx="423.7" cy="673.1" r="1.1"/>
                        <circle class="st0" cx="443.2" cy="621.3" r="1.1"/>
                        <circle class="st0" cx="413.2" cy="656.4" r="1.1"/>
                        <circle class="st0" cx="404.5" cy="616.9" r="1.1"/>
                        <circle class="st0" cx="441.3" cy="625.9" r="1.1"/>
                        <circle class="st0" cx="375.8" cy="647.8" r="1.1"/>
                        <circle class="st0" cx="390.1" cy="624.9" r="1.1"/>
                        <circle class="st0" cx="422.7" cy="632.8" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="408.6" cy="592.7" r="1.1"/>
                        <circle class="st0" cx="408.6" cy="592.7" r="1.1"/>
                        <circle class="st0" cx="359.9" cy="566.4" r="1.1"/>
                        <circle class="st0" cx="390.6" cy="600.9" r="1.1"/>
                        <circle class="st0" cx="350.3" cy="604.1" r="1.1"/>
                        <circle class="st0" cx="364.3" cy="568.8" r="1.1"/>
                        <circle class="st0" cx="377" cy="636.7" r="1.1"/>
                        <circle class="st0" cx="356.2" cy="619.4" r="1.1"/>
                        <circle class="st0" cx="368.5" cy="588.3" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="318.7" cy="1020" r="1.1"/>
                        <circle class="st0" cx="318.7" cy="1020" r="1.1"/>
                        <circle class="st0" cx="338.2" cy="968.2" r="1.1"/>
                        <circle class="st0" cx="308.2" cy="1003.3" r="1.1"/>
                        <circle class="st0" cx="299.5" cy="963.8" r="1.1"/>
                        <circle class="st0" cx="336.3" cy="972.9" r="1.1"/>
                        <circle class="st0" cx="270.9" cy="994.7" r="1.1"/>
                        <circle class="st0" cx="285.1" cy="971.8" r="1.1"/>
                        <circle class="st0" cx="317.7" cy="979.7" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="303.6" cy="939.7" r="1.1"/>
                        <circle class="st0" cx="303.6" cy="939.7" r="1.1"/>
                        <circle class="st0" cx="254.9" cy="913.3" r="1.1"/>
                        <circle class="st0" cx="285.7" cy="947.8" r="1.1"/>
                        <circle class="st0" cx="245.3" cy="951" r="1.1"/>
                        <circle class="st0" cx="259.3" cy="915.8" r="1.1"/>
                        <circle class="st0" cx="272" cy="983.6" r="1.1"/>
                        <circle class="st0" cx="251.3" cy="966.3" r="1.1"/>
                        <circle class="st0" cx="263.5" cy="935.2" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="550.7" cy="1220" r="1.1"/>
                        <circle class="st0" cx="550.7" cy="1220" r="1.1"/>
                        <circle class="st0" cx="570.1" cy="1168.1" r="1.1"/>
                        <circle class="st0" cx="540.1" cy="1203.3" r="1.1"/>
                        <circle class="st0" cx="531.5" cy="1163.8" r="1.1"/>
                        <circle class="st0" cx="568.3" cy="1172.8" r="1.1"/>
                        <circle class="st0" cx="502.8" cy="1194.6" r="1.1"/>
                        <circle class="st0" cx="517.1" cy="1171.8" r="1.1"/>
                        <circle class="st0" cx="549.6" cy="1179.6" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="535.6" cy="1139.6" r="1.1"/>
                        <circle class="st0" cx="535.6" cy="1139.6" r="1.1"/>
                        <circle class="st0" cx="486.9" cy="1113.3" r="1.1"/>
                        <circle class="st0" cx="517.6" cy="1147.8" r="1.1"/>
                        <circle class="st0" cx="477.3" cy="1150.9" r="1.1"/>
                        <circle class="st0" cx="491.3" cy="1115.7" r="1.1"/>
                        <circle class="st0" cx="503.9" cy="1183.6" r="1.1"/>
                        <circle class="st0" cx="483.2" cy="1166.3" r="1.1"/>
                        <circle class="st0" cx="495.5" cy="1135.1" r="1.1"/>
                    </g>
                </g>
            </g>
            <g class="st32">
                <circle class="st0" cx="369.5" cy="-310.9" r="4.3"/>
                <circle class="st0" cx="483.2" cy="-41.3" r="4.3"/>
                <circle class="st0" cx="845.8" cy="-114.5" r="4.3"/>
                <circle class="st0" cx="765.9" cy="528.1" r="4.3"/>
                <circle class="st0" cx="451.6" cy="431.4" r="4.3"/>
                <circle class="st0" cx="210.8" cy="123.1" r="4.3"/>
                <circle class="st0" cx="287.5" cy="64.2" r="4.3"/>
                <circle class="st0" cx="415.9" cy="-116" r="4.3"/>
                <circle class="st0" cx="653.6" cy="-342.1" r="4.3"/>
                <path class="st0" d="M1027.6-244.7c2.4,0,4.3,1.9,4.3,4.3s-1.9,4.3-4.3,4.3s-4.3-1.9-4.3-4.3S1025.2-244.7,1027.6-244.7z"/>
                <circle class="st0" cx="1148.7" cy="-117.8" r="4.3"/>
                <circle class="st0" cx="1333.5" cy="41.5" r="4.3"/>
                <circle class="st0" cx="1069.1" cy="210.4" r="4.3"/>
                <circle class="st0" cx="912.2" cy="374.5" r="4.3"/>
                <circle class="st0" cx="783.3" cy="410.9" r="4.3"/>
                <circle class="st0" cx="669.9" cy="336.7" r="4.3"/>
                <circle class="st0" cx="598.3" cy="163.1" r="4.3"/>
                <circle class="st0" cx="269.2" cy="-130.2" r="4.3"/>
                <circle class="st0" cx="482" cy="-333" r="4.3"/>
                <circle class="st0" cx="695.3" cy="-453.6" r="4.3"/>
                <circle class="st0" cx="877.1" cy="-334.4" r="4.3"/>
                <circle class="st0" cx="990.3" cy="-126.4" r="4.3"/>
                <circle class="st0" cx="976.4" cy="87.6" r="4.3"/>
                <circle class="st0" cx="897.5" cy="317.3" r="4.3"/>
                <circle class="st0" cx="1077" cy="260.2" r="4.3"/>
                <circle class="st0" cx="1185" cy="119.5" r="4.3"/>
                <circle class="st0" cx="1246.7" cy="9.7" r="4.3"/>
                <circle class="st0" cx="956.9" cy="-276.7" r="4.3"/>
                <circle class="st0" cx="697.1" cy="-595.3" r="4.3"/>
                <circle class="st0" cx="515.1" cy="-607.5" r="4.3"/>
                <circle class="st0" cx="503.4" cy="26.2" r="4.3"/>
                <circle class="st0" cx="658.9" cy="47" r="4.3"/>
                <circle class="st0" cx="520.1" cy="661.2" r="4.3"/>
                <circle class="st0" cx="82.8" cy="248.7" r="4.3"/>
                <circle class="st0" cx="-15.3" cy="56.8" r="4.3"/>
                <circle class="st0" cx="51.7" cy="-69.6" r="4.3"/>
                <circle class="st0" cx="126.8" cy="-180.8" r="4.3"/>
                <g>
                    <circle class="st0" cx="902.7" cy="139.4" r="1.4"/>
                    <circle class="st0" cx="924.4" cy="107.6" r="1.4"/>
                    <circle class="st0" cx="884.1" cy="114.7" r="1.4"/>
                    <circle class="st0" cx="904.6" cy="91.8" r="1.4"/>
                    <circle class="st0" cx="856.9" cy="85" r="1.4"/>
                    <circle class="st0" cx="888.4" cy="71.9" r="1.4"/>
                    <circle class="st0" cx="929.4" cy="54.4" r="1.4"/>
                    <circle class="st0" cx="906" cy="73" r="1.4"/>
                    <circle class="st0" cx="886.8" cy="45.2" r="1.4"/>
                    <circle class="st0" cx="864.8" cy="65.8" r="1.4"/>
                    <circle class="st0" cx="822.2" cy="65" r="1.4"/>
                    <circle class="st0" cx="838.9" cy="119.6" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="861.6" cy="-115.1" r="1.4"/>
                    <circle class="st0" cx="883.3" cy="-146.8" r="1.4"/>
                    <circle class="st0" cx="843.1" cy="-139.7" r="1.4"/>
                    <circle class="st0" cx="863.5" cy="-162.7" r="1.4"/>
                    <circle class="st0" cx="815.9" cy="-169.5" r="1.4"/>
                    <circle class="st0" cx="847.3" cy="-182.5" r="1.4"/>
                    <circle class="st0" cx="888.3" cy="-200" r="1.4"/>
                    <circle class="st0" cx="864.9" cy="-181.4" r="1.4"/>
                    <circle class="st0" cx="845.8" cy="-209.2" r="1.4"/>
                    <circle class="st0" cx="823.7" cy="-188.7" r="1.4"/>
                    <circle class="st0" cx="781.1" cy="-189.4" r="1.4"/>
                    <circle class="st0" cx="797.8" cy="-134.8" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1178.7" cy="128.2" r="1.4"/>
                    <circle class="st0" cx="1200.4" cy="96.5" r="1.4"/>
                    <circle class="st0" cx="1160.1" cy="103.6" r="1.4"/>
                    <circle class="st0" cx="1180.6" cy="80.6" r="1.4"/>
                    <circle class="st0" cx="1132.9" cy="73.8" r="1.4"/>
                    <circle class="st0" cx="1164.4" cy="60.8" r="1.4"/>
                    <circle class="st0" cx="1205.4" cy="43.3" r="1.4"/>
                    <circle class="st0" cx="1182" cy="61.9" r="1.4"/>
                    <circle class="st0" cx="1162.8" cy="34.1" r="1.4"/>
                    <circle class="st0" cx="1140.8" cy="54.6" r="1.4"/>
                    <circle class="st0" cx="1098.2" cy="53.9" r="1.4"/>
                    <circle class="st0" cx="1114.9" cy="108.5" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1090" cy="-18.7" r="1.4"/>
                    <circle class="st0" cx="1111.7" cy="-50.5" r="1.4"/>
                    <circle class="st0" cx="1071.4" cy="-43.3" r="1.4"/>
                    <circle class="st0" cx="1091.9" cy="-66.3" r="1.4"/>
                    <circle class="st0" cx="1044.2" cy="-73.1" r="1.4"/>
                    <circle class="st0" cx="1075.7" cy="-86.2" r="1.4"/>
                    <circle class="st0" cx="1116.7" cy="-103.6" r="1.4"/>
                    <circle class="st0" cx="1093.3" cy="-85" r="1.4"/>
                    <circle class="st0" cx="1074.1" cy="-112.8" r="1.4"/>
                    <circle class="st0" cx="1052.1" cy="-92.3" r="1.4"/>
                    <circle class="st0" cx="1009.5" cy="-93" r="1.4"/>
                    <circle class="st0" cx="1026.2" cy="-38.5" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1252.4" cy="13.5" r="1.4"/>
                    <circle class="st0" cx="1274.1" cy="-18.2" r="1.4"/>
                    <circle class="st0" cx="1233.8" cy="-11.1" r="1.4"/>
                    <circle class="st0" cx="1254.2" cy="-34.1" r="1.4"/>
                    <circle class="st0" cx="1206.6" cy="-40.9" r="1.4"/>
                    <circle class="st0" cx="1238" cy="-53.9" r="1.4"/>
                    <circle class="st0" cx="1279" cy="-71.4" r="1.4"/>
                    <circle class="st0" cx="1255.6" cy="-52.8" r="1.4"/>
                    <circle class="st0" cx="1236.5" cy="-80.6" r="1.4"/>
                    <circle class="st0" cx="1214.5" cy="-60.1" r="1.4"/>
                    <circle class="st0" cx="1171.9" cy="-60.8" r="1.4"/>
                    <circle class="st0" cx="1188.5" cy="-6.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="997.1" cy="253.9" r="1.4"/>
                    <circle class="st0" cx="1018.8" cy="222.1" r="1.4"/>
                    <circle class="st0" cx="978.5" cy="229.2" r="1.4"/>
                    <circle class="st0" cx="999" cy="206.3" r="1.4"/>
                    <circle class="st0" cx="951.3" cy="199.4" r="1.4"/>
                    <circle class="st0" cx="982.8" cy="186.4" r="1.4"/>
                    <path class="st0" d="M1023.8,167.5c0.8,0,1.4,0.6,1.4,1.4s-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4S1023,167.5,1023.8,167.5z"/>
                    <circle class="st0" cx="1000.4" cy="187.5" r="1.4"/>
                    <circle class="st0" cx="981.2" cy="159.7" r="1.4"/>
                    <circle class="st0" cx="959.2" cy="180.3" r="1.4"/>
                    <circle class="st0" cx="916.6" cy="179.5" r="1.4"/>
                    <circle class="st0" cx="933.3" cy="234.1" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1041.2" cy="380.7" r="1.4"/>
                    <circle class="st0" cx="1062.9" cy="348.9" r="1.4"/>
                    <circle class="st0" cx="1022.6" cy="356" r="1.4"/>
                    <circle class="st0" cx="1043.1" cy="333.1" r="1.4"/>
                    <circle class="st0" cx="995.4" cy="326.3" r="1.4"/>
                    <circle class="st0" cx="1026.9" cy="313.2" r="1.4"/>
                    <circle class="st0" cx="1067.9" cy="295.7" r="1.4"/>
                    <circle class="st0" cx="1044.5" cy="314.3" r="1.4"/>
                    <circle class="st0" cx="1025.3" cy="286.5" r="1.4"/>
                    <circle class="st0" cx="1003.3" cy="307.1" r="1.4"/>
                    <circle class="st0" cx="960.7" cy="306.3" r="1.4"/>
                    <circle class="st0" cx="977.4" cy="360.9" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="1096" cy="315.2" r="1.4"/>
                    <circle class="st0" cx="1117.7" cy="283.4" r="1.4"/>
                    <circle class="st0" cx="1077.4" cy="290.5" r="1.4"/>
                    <circle class="st0" cx="1097.9" cy="267.6" r="1.4"/>
                    <circle class="st0" cx="1050.2" cy="260.8" r="1.4"/>
                    <circle class="st0" cx="1081.6" cy="247.7" r="1.4"/>
                    <circle class="st0" cx="1122.7" cy="230.3" r="1.4"/>
                    <circle class="st0" cx="1099.3" cy="248.9" r="1.4"/>
                    <circle class="st0" cx="1080.1" cy="221.1" r="1.4"/>
                    <circle class="st0" cx="1058.1" cy="241.6" r="1.4"/>
                    <circle class="st0" cx="1015.5" cy="240.8" r="1.4"/>
                    <circle class="st0" cx="1032.1" cy="295.4" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="785.4" cy="267" r="1.4"/>
                    <circle class="st0" cx="807.1" cy="235.2" r="1.4"/>
                    <circle class="st0" cx="766.8" cy="242.3" r="1.4"/>
                    <circle class="st0" cx="787.3" cy="219.4" r="1.4"/>
                    <circle class="st0" cx="739.6" cy="212.6" r="1.4"/>
                    <circle class="st0" cx="771.1" cy="199.5" r="1.4"/>
                    <circle class="st0" cx="812.1" cy="182" r="1.4"/>
                    <circle class="st0" cx="788.7" cy="200.6" r="1.4"/>
                    <circle class="st0" cx="769.5" cy="172.8" r="1.4"/>
                    <circle class="st0" cx="747.5" cy="193.4" r="1.4"/>
                    <circle class="st0" cx="704.9" cy="192.6" r="1.4"/>
                    <circle class="st0" cx="721.6" cy="247.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="784" cy="176.4" r="1.4"/>
                    <circle class="st0" cx="805.7" cy="144.6" r="1.4"/>
                    <circle class="st0" cx="765.4" cy="151.8" r="1.4"/>
                    <circle class="st0" cx="785.9" cy="128.8" r="1.4"/>
                    <circle class="st0" cx="738.2" cy="122" r="1.4"/>
                    <circle class="st0" cx="769.6" cy="108.9" r="1.4"/>
                    <circle class="st0" cx="810.7" cy="91.5" r="1.4"/>
                    <circle class="st0" cx="787.3" cy="110.1" r="1.4"/>
                    <circle class="st0" cx="768.1" cy="82.3" r="1.4"/>
                    <circle class="st0" cx="746.1" cy="102.8" r="1.4"/>
                    <circle class="st0" cx="703.5" cy="102.1" r="1.4"/>
                    <circle class="st0" cx="720.1" cy="156.6" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="504.1" cy="103.8" r="1.4"/>
                    <circle class="st0" cx="525.8" cy="72" r="1.4"/>
                    <circle class="st0" cx="485.5" cy="79.1" r="1.4"/>
                    <circle class="st0" cx="506" cy="56.2" r="1.4"/>
                    <circle class="st0" cx="458.3" cy="49.3" r="1.4"/>
                    <circle class="st0" cx="489.8" cy="36.3" r="1.4"/>
                    <circle class="st0" cx="530.8" cy="18.8" r="1.4"/>
                    <circle class="st0" cx="507.4" cy="37.4" r="1.4"/>
                    <circle class="st0" cx="488.2" cy="9.6" r="1.4"/>
                    <circle class="st0" cx="466.2" cy="30.2" r="1.4"/>
                    <circle class="st0" cx="423.6" cy="29.4" r="1.4"/>
                    <circle class="st0" cx="440.3" cy="84" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="217.3" cy="141" r="1.4"/>
                    <circle class="st0" cx="239" cy="109.2" r="1.4"/>
                    <circle class="st0" cx="198.8" cy="116.4" r="1.4"/>
                    <circle class="st0" cx="219.2" cy="93.4" r="1.4"/>
                    <circle class="st0" cx="171.6" cy="86.6" r="1.4"/>
                    <circle class="st0" cx="203" cy="73.6" r="1.4"/>
                    <circle class="st0" cx="244" cy="56.1" r="1.4"/>
                    <circle class="st0" cx="220.6" cy="74.7" r="1.4"/>
                    <circle class="st0" cx="201.5" cy="46.9" r="1.4"/>
                    <circle class="st0" cx="179.4" cy="67.4" r="1.4"/>
                    <circle class="st0" cx="136.8" cy="66.7" r="1.4"/>
                    <circle class="st0" cx="153.5" cy="121.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="222.3" cy="13.3" r="1.4"/>
                    <circle class="st0" cx="244" cy="-18.5" r="1.4"/>
                    <circle class="st0" cx="203.7" cy="-11.4" r="1.4"/>
                    <circle class="st0" cx="224.1" cy="-34.3" r="1.4"/>
                    <circle class="st0" cx="176.5" cy="-41.1" r="1.4"/>
                    <circle class="st0" cx="207.9" cy="-54.2" r="1.4"/>
                    <circle class="st0" cx="248.9" cy="-71.7" r="1.4"/>
                    <circle class="st0" cx="225.5" cy="-53.1" r="1.4"/>
                    <circle class="st0" cx="206.4" cy="-80.9" r="1.4"/>
                    <circle class="st0" cx="184.4" cy="-60.3" r="1.4"/>
                    <circle class="st0" cx="141.8" cy="-61.1" r="1.4"/>
                    <circle class="st0" cx="158.4" cy="-6.5" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="569.6" cy="322.8" r="1.4"/>
                    <circle class="st0" cx="591.3" cy="291" r="1.4"/>
                    <circle class="st0" cx="551" cy="298.2" r="1.4"/>
                    <circle class="st0" cx="571.4" cy="275.2" r="1.4"/>
                    <circle class="st0" cx="523.8" cy="268.4" r="1.4"/>
                    <circle class="st0" cx="555.2" cy="255.3" r="1.4"/>
                    <circle class="st0" cx="596.3" cy="237.9" r="1.4"/>
                    <circle class="st0" cx="572.9" cy="256.5" r="1.4"/>
                    <circle class="st0" cx="553.7" cy="228.7" r="1.4"/>
                    <circle class="st0" cx="531.7" cy="249.2" r="1.4"/>
                    <circle class="st0" cx="489.1" cy="248.5" r="1.4"/>
                    <circle class="st0" cx="505.7" cy="303" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="654" cy="460.5" r="1.4"/>
                    <circle class="st0" cx="675.7" cy="428.8" r="1.4"/>
                    <circle class="st0" cx="635.4" cy="435.9" r="1.4"/>
                    <circle class="st0" cx="655.8" cy="412.9" r="1.4"/>
                    <circle class="st0" cx="608.2" cy="406.1" r="1.4"/>
                    <circle class="st0" cx="639.6" cy="393.1" r="1.4"/>
                    <circle class="st0" cx="680.6" cy="375.6" r="1.4"/>
                    <circle class="st0" cx="657.2" cy="394.2" r="1.4"/>
                    <circle class="st0" cx="638.1" cy="366.4" r="1.4"/>
                    <circle class="st0" cx="616.1" cy="386.9" r="1.4"/>
                    <circle class="st0" cx="573.5" cy="386.2" r="1.4"/>
                    <circle class="st0" cx="590.1" cy="440.8" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="542.2" cy="469.8" r="1.4"/>
                    <circle class="st0" cx="563.9" cy="438" r="1.4"/>
                    <circle class="st0" cx="523.6" cy="445.1" r="1.4"/>
                    <circle class="st0" cx="544" cy="422.2" r="1.4"/>
                    <circle class="st0" cx="496.4" cy="415.4" r="1.4"/>
                    <circle class="st0" cx="527.8" cy="402.3" r="1.4"/>
                    <circle class="st0" cx="568.8" cy="384.9" r="1.4"/>
                    <circle class="st0" cx="545.4" cy="403.4" r="1.4"/>
                    <circle class="st0" cx="526.3" cy="375.7" r="1.4"/>
                    <circle class="st0" cx="504.3" cy="396.2" r="1.4"/>
                    <circle class="st0" cx="461.6" cy="395.4" r="1.4"/>
                    <circle class="st0" cx="478.3" cy="450" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="490.1" cy="402" r="1.4"/>
                    <path class="st0" d="M511.8,368.8c0.8,0,1.4,0.6,1.4,1.4s-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4S511,368.8,511.8,368.8z"/>
                    <circle class="st0" cx="471.5" cy="377.3" r="1.4"/>
                    <circle class="st0" cx="492" cy="354.4" r="1.4"/>
                    <circle class="st0" cx="444.3" cy="347.6" r="1.4"/>
                    <circle class="st0" cx="475.8" cy="334.5" r="1.4"/>
                    <circle class="st0" cx="516.8" cy="317" r="1.4"/>
                    <circle class="st0" cx="493.4" cy="335.6" r="1.4"/>
                    <circle class="st0" cx="474.2" cy="307.8" r="1.4"/>
                    <circle class="st0" cx="452.2" cy="328.4" r="1.4"/>
                    <circle class="st0" cx="409.6" cy="327.6" r="1.4"/>
                    <circle class="st0" cx="426.3" cy="382.2" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="428.9" cy="322.4" r="1.4"/>
                    <circle class="st0" cx="450.6" cy="290.6" r="1.4"/>
                    <circle class="st0" cx="410.3" cy="297.8" r="1.4"/>
                    <circle class="st0" cx="430.7" cy="274.8" r="1.4"/>
                    <circle class="st0" cx="383.1" cy="268" r="1.4"/>
                    <circle class="st0" cx="414.5" cy="254.9" r="1.4"/>
                    <circle class="st0" cx="455.5" cy="237.5" r="1.4"/>
                    <circle class="st0" cx="432.1" cy="256.1" r="1.4"/>
                    <circle class="st0" cx="413" cy="228.3" r="1.4"/>
                    <circle class="st0" cx="391" cy="248.8" r="1.4"/>
                    <circle class="st0" cx="348.4" cy="248" r="1.4"/>
                    <circle class="st0" cx="365" cy="302.6" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="755.7" cy="-216.6" r="1.4"/>
                    <circle class="st0" cx="777.4" cy="-248.4" r="1.4"/>
                    <circle class="st0" cx="737.2" cy="-241.3" r="1.4"/>
                    <circle class="st0" cx="757.6" cy="-264.2" r="1.4"/>
                    <circle class="st0" cx="710" cy="-271" r="1.4"/>
                    <circle class="st0" cx="741.4" cy="-284.1" r="1.4"/>
                    <circle class="st0" cx="782.4" cy="-301.6" r="1.4"/>
                    <circle class="st0" cx="759" cy="-283" r="1.4"/>
                    <circle class="st0" cx="739.8" cy="-310.7" r="1.4"/>
                    <circle class="st0" cx="717.8" cy="-290.2" r="1.4"/>
                    <circle class="st0" cx="675.2" cy="-291" r="1.4"/>
                    <circle class="st0" cx="691.9" cy="-236.4" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="595.1" cy="-475.2" r="1.4"/>
                    <circle class="st0" cx="616.8" cy="-506.9" r="1.4"/>
                    <circle class="st0" cx="576.5" cy="-499.8" r="1.4"/>
                    <circle class="st0" cx="597" cy="-522.8" r="1.4"/>
                    <circle class="st0" cx="549.3" cy="-529.6" r="1.4"/>
                    <circle class="st0" cx="580.8" cy="-542.6" r="1.4"/>
                    <circle class="st0" cx="621.8" cy="-560.1" r="1.4"/>
                    <circle class="st0" cx="598.4" cy="-541.5" r="1.4"/>
                    <circle class="st0" cx="579.2" cy="-569.3" r="1.4"/>
                    <circle class="st0" cx="557.2" cy="-548.8" r="1.4"/>
                    <circle class="st0" cx="514.6" cy="-549.5" r="1.4"/>
                    <circle class="st0" cx="531.3" cy="-494.9" r="1.4"/>
                </g>
                <g>
                    <circle class="st0" cx="302.6" cy="-215.1" r="1.4"/>
                    <circle class="st0" cx="324.3" cy="-246.9" r="1.4"/>
                    <circle class="st0" cx="284" cy="-239.8" r="1.4"/>
                    <circle class="st0" cx="304.5" cy="-262.7" r="1.4"/>
                    <circle class="st0" cx="256.8" cy="-269.5" r="1.4"/>
                    <circle class="st0" cx="288.3" cy="-282.6" r="1.4"/>
                    <circle class="st0" cx="329.3" cy="-300" r="1.4"/>
                    <circle class="st0" cx="305.9" cy="-281.5" r="1.4"/>
                    <circle class="st0" cx="286.7" cy="-309.2" r="1.4"/>
                    <circle class="st0" cx="264.7" cy="-288.7" r="1.4"/>
                    <circle class="st0" cx="222.1" cy="-289.5" r="1.4"/>
                    <circle class="st0" cx="238.8" cy="-234.9" r="1.4"/>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="19.7" cy="144.9" r="1.1"/>
                        <circle class="st0" cx="19.7" cy="144.9" r="1.1"/>
                        <circle class="st0" cx="68.7" cy="119.2" r="1.1"/>
                        <circle class="st0" cx="22.9" cy="125.5" r="1.1"/>
                        <circle class="st0" cx="42.8" cy="90.2" r="1.1"/>
                        <circle class="st0" cx="64.3" cy="121.5" r="1.1"/>
                        <circle class="st0" cx="0.8" cy="94.2" r="1.1"/>
                        <circle class="st0" cx="26.7" cy="86.6" r="1.1"/>
                        <circle class="st0" cx="45.8" cy="114.1" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="61.9" cy="74.9" r="1.1"/>
                        <circle class="st0" cx="61.9" cy="74.9" r="1.1"/>
                        <circle class="st0" cx="43.1" cy="22.8" r="1.1"/>
                        <circle class="st0" cx="43.1" cy="69" r="1.1"/>
                        <circle class="st0" cx="10.8" cy="44.6" r="1.1"/>
                        <circle class="st0" cx="44.7" cy="27.6" r="1.1"/>
                        <circle class="st0" cx="9" cy="86.7" r="1.1"/>
                        <circle class="st0" cx="5.1" cy="60" r="1.1"/>
                        <circle class="st0" cx="35" cy="44.9" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="879.9" cy="200.3" r="1.1"/>
                        <circle class="st0" cx="879.9" cy="200.3" r="1.1"/>
                        <circle class="st0" cx="928.9" cy="174.6" r="1.1"/>
                        <circle class="st0" cx="883.1" cy="180.9" r="1.1"/>
                        <circle class="st0" cx="903" cy="145.6" r="1.1"/>
                        <circle class="st0" cx="924.5" cy="176.9" r="1.1"/>
                        <circle class="st0" cx="861" cy="149.6" r="1.1"/>
                        <circle class="st0" cx="886.9" cy="142" r="1.1"/>
                        <circle class="st0" cx="906" cy="169.5" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="922.1" cy="130.3" r="1.1"/>
                        <circle class="st0" cx="922.1" cy="130.3" r="1.1"/>
                        <circle class="st0" cx="903.3" cy="78.2" r="1.1"/>
                        <circle class="st0" cx="903.3" cy="124.5" r="1.1"/>
                        <circle class="st0" cx="871" cy="100" r="1.1"/>
                        <circle class="st0" cx="904.9" cy="83" r="1.1"/>
                        <circle class="st0" cx="869.2" cy="142.1" r="1.1"/>
                        <circle class="st0" cx="865.3" cy="115.4" r="1.1"/>
                        <circle class="st0" cx="895.2" cy="100.3" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="570.7" cy="389.5" r="1.1"/>
                        <circle class="st0" cx="570.7" cy="389.5" r="1.1"/>
                        <circle class="st0" cx="619.7" cy="363.7" r="1.1"/>
                        <circle class="st0" cx="574" cy="370" r="1.1"/>
                        <circle class="st0" cx="593.8" cy="334.7" r="1.1"/>
                        <circle class="st0" cx="615.3" cy="366" r="1.1"/>
                        <circle class="st0" cx="551.9" cy="338.7" r="1.1"/>
                        <circle class="st0" cx="577.7" cy="331.1" r="1.1"/>
                        <circle class="st0" cx="596.8" cy="358.7" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="612.9" cy="319.4" r="1.1"/>
                        <circle class="st0" cx="612.9" cy="319.4" r="1.1"/>
                        <circle class="st0" cx="594.1" cy="267.4" r="1.1"/>
                        <circle class="st0" cx="594.1" cy="313.6" r="1.1"/>
                        <circle class="st0" cx="561.8" cy="289.1" r="1.1"/>
                        <circle class="st0" cx="595.7" cy="272.1" r="1.1"/>
                        <circle class="st0" cx="560" cy="331.2" r="1.1"/>
                        <circle class="st0" cx="556.1" cy="304.5" r="1.1"/>
                        <circle class="st0" cx="586" cy="289.4" r="1.1"/>
                    </g>
                </g>
                <g>
                    <g>
                        <circle class="st0" cx="610.9" cy="693.1" r="1.1"/>
                        <circle class="st0" cx="610.9" cy="693.1" r="1.1"/>
                        <circle class="st0" cx="659.9" cy="667.3" r="1.1"/>
                        <circle class="st0" cx="614.1" cy="673.6" r="1.1"/>
                        <circle class="st0" cx="633.9" cy="638.3" r="1.1"/>
                        <circle class="st0" cx="655.4" cy="669.6" r="1.1"/>
                        <circle class="st0" cx="592" cy="642.3" r="1.1"/>
                        <circle class="st0" cx="617.9" cy="634.7" r="1.1"/>
                        <circle class="st0" cx="636.9" cy="662.3" r="1.1"/>
                    </g>
                    <g>
                        <circle class="st0" cx="653" cy="623" r="1.1"/>
                        <circle class="st0" cx="653" cy="623" r="1.1"/>
                        <circle class="st0" cx="634.2" cy="571" r="1.1"/>
                        <circle class="st0" cx="634.2" cy="617.2" r="1.1"/>
                        <circle class="st0" cx="602" cy="592.7" r="1.1"/>
                        <circle class="st0" cx="635.9" cy="575.7" r="1.1"/>
                        <circle class="st0" cx="600.2" cy="634.8" r="1.1"/>
                        <circle class="st0" cx="596.2" cy="608.1" r="1.1"/>
                        <circle class="st0" cx="626.1" cy="593" r="1.1"/>
                    </g>
                </g>
            </g>
            <g id="BLNKRC.tif">
                <g>
                    <radialGradient id="SVGID_19_" cx="-486.297" cy="1831.2014" r="92.6588" gradientUnits="userSpaceOnUse">
                        <stop  offset="0.1163" style="stop-color:#F15B35"/>
                        <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                        <stop  offset="0.348" style="stop-color:#DF5542"/>
                        <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                        <stop  offset="0.6367" style="stop-color:#B1445D"/>
                        <stop  offset="0.7926" style="stop-color:#923A6C"/>
                        <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                        <stop  offset="1" style="stop-color:#612A81"/>
                    </radialGradient>
                    <path class="st33" d="M-579.2,1778c26.4,15.8,52.8,31.6,79.1,47.4c0.1-0.1,0.2-0.3,0.3-0.4c-30.8-23.4-61.6-46.8-92.4-70.2
                        c0.2-0.2,0.3-0.4,0.5-0.7c37.4,24,74.9,48,112.3,72.1c0.1-0.2,0.2-0.3,0.3-0.5c-13.1-11.7-26.2-23.4-39.2-35.2
                        c0.1-0.1,0.2-0.3,0.3-0.4c2.8,1.4,5.6,2.7,8.4,4.1c25.3,13.1,50.3,26.6,74.4,41.8c14.6,9.2,29,18.7,41.5,30.7
                        c4.2,4,8,8.7,11.2,13.6c4,6.1,2.5,15.3-2.7,21.4c-5,5.8-13.6,8.2-20.4,5.7c-9.4-3.6-17.6-9.2-25.9-14.8
                        c-25.1-17-48.5-36.2-72.3-55c-21.3-16.9-42.9-33.5-64.3-50.2c-3.8-3-7.6-5.9-11.4-8.8C-579.5,1778.3-579.4,1778.2-579.2,1778z
                        M-441.7,1872.2c-0.1,0.1-0.1,0.3-0.2,0.4c0.2,0.3,0.4,0.5,0.6,0.8c7.8,7.5,16,14.6,25.4,20.1c4.6,2.7,9.4,5,14.9,5.3
                        c4.8,0.3,8.4-1.9,10.8-5.9c2.3-3.8,0.9-7.4-1.4-10.7c-4-5.6-9.6-9.4-15.3-13c-2.9-1.8-6-3.4-8.9-5c-0.1,0.2-0.2,0.3-0.4,0.5
                        c3.9,4.5,7.9,9,11.8,13.4c-0.1,0.1-0.2,0.3-0.4,0.4c-15.9-8.8-31.7-17.6-47.6-26.4c-0.1,0.2-0.2,0.3-0.3,0.5
                        c13,10.2,26.1,20.4,39.1,30.5c-0.1,0.2-0.3,0.4-0.4,0.6C-423.2,1879.8-432.4,1876-441.7,1872.2z"/>
                    <radialGradient id="SVGID_20_" cx="-502.016" cy="1927.892" r="75.0008" gradientUnits="userSpaceOnUse">
                        <stop  offset="0.1163" style="stop-color:#F15B35"/>
                        <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                        <stop  offset="0.348" style="stop-color:#DF5542"/>
                        <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                        <stop  offset="0.6367" style="stop-color:#B1445D"/>
                        <stop  offset="0.7926" style="stop-color:#923A6C"/>
                        <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                        <stop  offset="1" style="stop-color:#612A81"/>
                    </radialGradient>
                    <path class="st34" d="M-587.4,1865.4c30.1,19.3,60.1,38.6,90.2,57.9c0.1-0.1,0.2-0.3,0.4-0.4c-10.2-9.2-20.4-18.3-30.6-27.5
                        c0.1-0.2,0.2-0.3,0.3-0.5c3.3,1.6,6.6,3.2,9.8,4.9c16,8.8,32.2,17.5,48,26.7c13.8,8.1,27.4,16.8,39.4,27.5
                        c3.8,3.4,7.3,7.1,10.3,11.1c4.7,6.1,4.3,13.5-0.4,19.3c-4.5,5.6-11.9,7.6-18.7,4.1c-7.9-4.1-15.7-8.4-22.8-13.8
                        c-24.4-18.4-48.4-37.3-72.5-55.9c-14.1-10.9-28.2-21.8-42.2-32.7c-0.3-0.2-0.5-0.4-0.5-1c20.7,12.4,41.4,24.8,62.2,37.2
                        c0.1-0.2,0.2-0.3,0.3-0.5c-24.5-18.6-49-37.3-73.5-55.9C-587.6,1865.8-587.5,1865.6-587.4,1865.4z M-465.4,1961.3
                        c5.2,5.9,11,10.9,17.5,15.2c4,2.6,8.1,5,12.9,5.8c4.8,0.8,8.7-0.8,10.7-4.5c2.1-4,0.2-7.2-2.3-10c-5-5.8-11.6-9.5-18.6-12.6
                        c3,3.4,6,6.9,9.1,10.3c-0.2,0.1-0.3,0.3-0.5,0.4c-12.3-6.8-24.6-13.6-36.9-20.5c-0.1,0.2-0.2,0.3-0.3,0.5
                        c10.3,8,20.6,16.1,30.8,24.1c-0.1,0.2-0.2,0.3-0.3,0.5C-450.6,1967.4-458,1964.3-465.4,1961.3z"/>
                    <radialGradient id="SVGID_21_" cx="-508.4348" cy="1741.224" r="75.1239" gradientUnits="userSpaceOnUse">
                        <stop  offset="0.1163" style="stop-color:#F15B35"/>
                        <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                        <stop  offset="0.348" style="stop-color:#DF5542"/>
                        <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                        <stop  offset="0.6367" style="stop-color:#B1445D"/>
                        <stop  offset="0.7926" style="stop-color:#923A6C"/>
                        <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                        <stop  offset="1" style="stop-color:#612A81"/>
                    </radialGradient>
                    <path class="st35" d="M-583.2,1698.4c20.8,12.4,41.5,24.9,62.3,37.3c0.1-0.2,0.2-0.3,0.3-0.5c-24.6-18.7-49.1-37.3-73.7-56
                        c0.1-0.2,0.3-0.4,0.4-0.6c30.1,19.3,60.1,38.6,90.2,57.9c0.1-0.2,0.3-0.3,0.4-0.5c-10.1-9.1-20.3-18.2-30.4-27.3
                        c0.1-0.2,0.2-0.3,0.3-0.5c2.5,1.2,5,2.4,7.5,3.7c20.5,10.6,40.7,21.6,60.2,34c11.7,7.5,23.2,15.4,33.3,24.9
                        c3.1,2.9,5.7,6.5,8,10.1c3.1,4.9,2.1,11.9-1.8,16.8c-3.9,4.8-10.8,7.5-16.1,5c-7.1-3.2-14.2-6.8-20.5-11.3
                        c-16.6-11.9-32.9-24.4-49.1-36.9c-15.1-11.6-29.9-23.6-44.9-35.3c-8.4-6.6-16.9-13-25.3-19.5c-0.5-0.4-0.9-0.8-1.4-1.2
                        C-583.4,1698.6-583.3,1698.5-583.2,1698.4z M-471.8,1774.6c7.4,7.7,15.3,15,25.3,19.3c2.4,1,5.1,1.7,7.7,1.9
                        c3.7,0.3,6.5-1.7,8.4-4.9c1.9-3.3,0.6-6.3-1.4-8.8c-5-6.4-11.8-10.6-19.4-13.6c2.9,3.4,5.8,6.7,8.7,10.1c-0.1,0.1-0.2,0.3-0.4,0.4
                        c-12.3-6.8-24.6-13.6-36.9-20.4c-0.1,0.2-0.2,0.3-0.3,0.5c10.2,8,20.4,16,30.6,23.9c-0.1,0.2-0.2,0.4-0.3,0.5
                        C-457.2,1780.7-464.5,1777.6-471.8,1774.6z"/>
                    <radialGradient id="SVGID_22_" cx="-597.0366" cy="1820.0043" r="58.7454" gradientUnits="userSpaceOnUse">
                        <stop  offset="0.1163" style="stop-color:#F15B35"/>
                        <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                        <stop  offset="0.348" style="stop-color:#DF5542"/>
                        <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                        <stop  offset="0.6367" style="stop-color:#B1445D"/>
                        <stop  offset="0.7926" style="stop-color:#923A6C"/>
                        <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                        <stop  offset="1" style="stop-color:#612A81"/>
                    </radialGradient>
                    <path class="st36" d="M-656,1786.2c16,9.6,32,19.1,48,28.7c0.1-0.1,0.2-0.3,0.3-0.4c-18.8-14.3-37.6-28.6-56.4-42.9
                        c0.1-0.2,0.2-0.4,0.4-0.6c23.1,14.8,46.2,29.6,69.2,44.4c0.1-0.2,0.3-0.3,0.4-0.5c-7.7-7-15.5-13.9-23.2-20.9
                        c0.1-0.2,0.2-0.3,0.3-0.5c5.6,2.9,11.3,5.6,16.7,8.7c12.7,7.2,25.5,14.4,37.9,22.1c10.1,6.2,19.8,12.9,27.8,21.8
                        c3.6,3.9,5.8,8.3,4.1,13.9c-2.3,7.3-10.1,10.8-17.1,7.6c-9.7-4.5-18.4-10.8-26.8-17.2c-21.3-16.4-42.4-33.1-63.6-49.6
                        c-5.2-4.1-10.5-8.1-15.8-12.2c-0.9-0.7-1.7-1.4-2.6-2.1C-656.2,1786.5-656.1,1786.3-656,1786.2z M-568,1846.3
                        c-0.1,0.2-0.3,0.4-0.4,0.5c5.4,5.3,11.1,10.2,17.9,13.6c2,1,4.2,1.7,6.3,2.2c3.2,0.7,6.4-0.8,7.9-3.5c1.4-2.4,0.9-5.2-1.4-7.8
                        c-1.3-1.4-2.6-2.9-4.1-4c-3.2-2.3-6.7-4.4-10-6.6c-0.2,0.2-0.3,0.4-0.5,0.6c2.2,2.5,4.3,5,6.5,7.5c-0.1,0.1-0.2,0.3-0.4,0.4
                        c-9.5-5.3-19.1-10.6-28.6-15.8c-0.1,0.1-0.2,0.3-0.3,0.4c7.9,6.2,15.8,12.3,23.6,18.5c-0.1,0.2-0.2,0.3-0.2,0.5
                        C-557,1850.8-562.5,1848.6-568,1846.3z"/>
                    <radialGradient id="SVGID_23_" cx="-420.8757" cy="1875.4093" r="27.9069" gradientUnits="userSpaceOnUse">
                        <stop  offset="0.1163" style="stop-color:#F15B35"/>
                        <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                        <stop  offset="0.348" style="stop-color:#DF5542"/>
                        <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                        <stop  offset="0.6367" style="stop-color:#B1445D"/>
                        <stop  offset="0.7926" style="stop-color:#923A6C"/>
                        <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                        <stop  offset="1" style="stop-color:#612A81"/>
                    </radialGradient>
                    <path class="st37" d="M-441.7,1872.2c9.3,3.8,18.5,7.6,27.8,11.5c0.1-0.2,0.3-0.4,0.4-0.6c-13-10.2-26.1-20.4-39.1-30.5
                        c0.1-0.2,0.2-0.3,0.3-0.5c15.9,8.8,31.7,17.6,47.6,26.4c0.1-0.1,0.2-0.3,0.4-0.4c-3.9-4.5-7.9-9-11.8-13.4
                        c0.1-0.2,0.2-0.3,0.4-0.5c3,1.7,6,3.2,8.9,5c5.7,3.6,11.3,7.4,15.3,13c2.3,3.3,3.7,6.8,1.4,10.7c-2.4,4-6,6.2-10.8,5.9
                        c-5.5-0.3-10.3-2.6-14.9-5.3c-9.4-5.5-17.6-12.6-25.4-20.1c-0.2-0.2-0.4-0.5-0.6-0.8C-441.8,1872.5-441.8,1872.3-441.7,1872.2z"/>
                    <radialGradient id="SVGID_24_" cx="-448.5318" cy="1963.9086" r="22.1078" gradientUnits="userSpaceOnUse">
                        <stop  offset="0.1163" style="stop-color:#F15B35"/>
                        <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                        <stop  offset="0.348" style="stop-color:#DF5542"/>
                        <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                        <stop  offset="0.6367" style="stop-color:#B1445D"/>
                        <stop  offset="0.7926" style="stop-color:#923A6C"/>
                        <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                        <stop  offset="1" style="stop-color:#612A81"/>
                    </radialGradient>
                    <path class="st38" d="M-465.4,1961.3c7.4,3.1,14.8,6.1,22.2,9.2c0.1-0.2,0.2-0.3,0.3-0.5c-10.3-8-20.6-16.1-30.8-24.1
                        c0.1-0.2,0.2-0.3,0.3-0.5c12.3,6.8,24.6,13.6,36.9,20.5c0.2-0.1,0.3-0.3,0.5-0.4c-3-3.4-6-6.9-9.1-10.3c7,3.1,13.6,6.8,18.6,12.6
                        c2.4,2.8,4.4,6,2.3,10c-2,3.7-5.9,5.4-10.7,4.5c-4.8-0.8-8.9-3.2-12.9-5.8C-454.3,1972.2-460.2,1967.2-465.4,1961.3z"/>
                    <radialGradient id="SVGID_25_" cx="-454.8337" cy="1777.3151" r="22.1851" gradientUnits="userSpaceOnUse">
                        <stop  offset="0.1163" style="stop-color:#F15B35"/>
                        <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                        <stop  offset="0.348" style="stop-color:#DF5542"/>
                        <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                        <stop  offset="0.6367" style="stop-color:#B1445D"/>
                        <stop  offset="0.7926" style="stop-color:#923A6C"/>
                        <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                        <stop  offset="1" style="stop-color:#612A81"/>
                    </radialGradient>
                    <path class="st39" d="M-471.8,1774.6c7.3,3,14.7,6,22,9.1c0.1-0.2,0.2-0.4,0.3-0.5c-10.2-8-20.4-16-30.6-23.9
                        c0.1-0.2,0.2-0.3,0.3-0.5c12.3,6.8,24.6,13.6,36.9,20.4c0.1-0.1,0.2-0.3,0.4-0.4c-2.9-3.4-5.8-6.7-8.7-10.1
                        c7.6,3.1,14.3,7.3,19.4,13.6c2,2.5,3.3,5.5,1.4,8.8c-1.9,3.2-4.6,5.2-8.4,4.9c-2.6-0.2-5.3-0.9-7.7-1.9
                        C-456.6,1789.6-464.4,1782.4-471.8,1774.6z"/>
                    <radialGradient id="SVGID_26_" cx="-555.1897" cy="1848.3191" r="17.3672" gradientUnits="userSpaceOnUse">
                        <stop  offset="0.1163" style="stop-color:#F15B35"/>
                        <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                        <stop  offset="0.348" style="stop-color:#DF5542"/>
                        <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                        <stop  offset="0.6367" style="stop-color:#B1445D"/>
                        <stop  offset="0.7926" style="stop-color:#923A6C"/>
                        <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                        <stop  offset="1" style="stop-color:#612A81"/>
                    </radialGradient>
                    <path class="st40" d="M-568,1846.3c5.5,2.2,11,4.5,16.4,6.7c0.1-0.2,0.2-0.3,0.2-0.5c-7.9-6.2-15.8-12.3-23.6-18.5
                        c0.1-0.1,0.2-0.3,0.3-0.4c9.5,5.3,19.1,10.6,28.6,15.8c0.1-0.1,0.2-0.3,0.4-0.4c-2.2-2.5-4.3-5-6.5-7.5c0.2-0.2,0.3-0.4,0.5-0.6
                        c3.3,2.2,6.8,4.3,10,6.6c1.5,1.1,2.8,2.6,4.1,4c2.3,2.6,2.8,5.4,1.4,7.8c-1.5,2.6-4.7,4.2-7.9,3.5c-2.2-0.5-4.3-1.2-6.3-2.2
                        c-6.8-3.5-12.5-8.4-17.9-13.6C-568.2,1846.7-568.1,1846.5-568,1846.3z"/>
                </g>
            </g>
            <g class="st41">
                <path class="st0" d="M712.1,1090.1c-8.7-9.6-17.4-19.1-26-28.7c-0.1,0-0.1,0.1-0.2,0.1c9.5,13.2,19.1,26.3,28.6,39.5
                    c-0.1,0.1-0.2,0.1-0.3,0.2c-12.1-14.2-24.2-28.4-36.4-42.6c-0.1,0-0.1,0.1-0.2,0.1c3.8,6.3,7.7,12.6,11.5,18.9
                    c-0.1,0-0.1,0.1-0.2,0.1c-1-0.9-1.9-1.8-2.9-2.7c-8.6-8.3-17-16.8-24.8-25.9c-4.7-5.5-9.4-11-12.9-17.4c-1.2-2.1-2.1-4.5-2.9-6.8
                    c-0.9-2.9,0.8-6.5,3.7-8.3c2.7-1.7,6.5-1.7,8.9,0.2c3.4,2.6,6,5.9,8.6,9.1c8,9.9,15.1,20.4,22.4,30.9c6.5,9.4,13.2,18.7,19.7,28
                    c1.2,1.6,2.3,3.3,3.5,4.9C712.3,1090,712.2,1090.1,712.1,1090.1z M668.3,1035.5c0,0,0.1-0.1,0.1-0.1c0-0.1-0.1-0.3-0.1-0.4
                    c-2.2-4-4.6-7.8-7.8-11.2c-1.5-1.6-3.2-3.2-5.3-4c-1.9-0.7-3.6-0.3-5.1,1.1c-1.4,1.3-1.3,2.9-0.7,4.5c0.9,2.7,2.7,5,4.6,7.1
                    c0.9,1.1,2,2.1,3,3.1c0.1-0.1,0.1-0.1,0.2-0.2c-1-2.3-2.1-4.6-3.1-6.8c0.1,0,0.1-0.1,0.2-0.1c5.3,5.5,10.6,10.9,15.9,16.4
                    c0.1,0,0.1-0.1,0.2-0.1c-4-5.7-8-11.4-12-17c0.1-0.1,0.2-0.1,0.2-0.2C661.8,1030.2,665,1032.9,668.3,1035.5z"/>
                <path class="st0" d="M726,1056c-9.7-11.4-19.5-22.8-29.2-34.2c-0.1,0-0.1,0.1-0.2,0.1c3,4.9,6,9.8,9,14.8c-0.1,0.1-0.1,0.1-0.2,0.2
                    c-1.1-1.1-2.3-2.1-3.3-3.2c-5.4-5.5-10.8-10.9-16-16.6c-4.6-4.9-9-10.1-12.5-15.8c-1.1-1.8-2.1-3.7-2.8-5.7c-1.1-3-0.1-6,2.5-7.7
                    c2.5-1.7,5.7-1.6,8,0.6c2.7,2.6,5.3,5.3,7.5,8.3c7.6,10.4,14.9,20.9,22.3,31.3c4.3,6.1,8.7,12.2,13,18.3c0.1,0.1,0.2,0.2,0.1,0.5
                    c-6.8-7.5-13.6-15-20.5-22.5c-0.1,0.1-0.1,0.1-0.2,0.2c7.6,10.5,15.2,20.9,22.8,31.4C726.2,1055.8,726.1,1055.9,726,1056z
                    M688.6,1002.6c-1.4-3-3.1-5.7-5.2-8.2c-1.3-1.5-2.7-3-4.5-3.9c-1.8-0.9-3.6-0.7-4.9,0.5c-1.3,1.3-0.9,2.9-0.3,4.3
                    c1.3,2.9,3.5,5.2,5.9,7.3c-0.8-1.8-1.6-3.5-2.4-5.3c0.1,0,0.2-0.1,0.2-0.1c4.1,4.2,8.2,8.5,12.3,12.7c0.1-0.1,0.1-0.1,0.2-0.2
                    c-3.2-4.5-6.3-9-9.5-13.4c0.1-0.1,0.1-0.1,0.2-0.2C683.4,998.3,686,1000.5,688.6,1002.6z"/>
                <path class="st0" d="M704,1122.6c-6.8-7.5-13.7-15-20.5-22.6c-0.1,0.1-0.1,0.1-0.2,0.2c7.6,10.5,15.2,21,22.8,31.5
                    c-0.1,0.1-0.1,0.1-0.2,0.2c-9.7-11.4-19.5-22.8-29.2-34.2c-0.1,0-0.1,0.1-0.2,0.1c3,4.9,5.9,9.8,8.9,14.7c-0.1,0.1-0.1,0.1-0.2,0.2
                    c-0.9-0.8-1.7-1.6-2.6-2.4c-6.9-6.7-13.7-13.6-20-21c-3.8-4.4-7.4-9-10.3-14.1c-0.9-1.6-1.5-3.3-2-5c-0.7-2.4,0.6-5,2.8-6.5
                    c2.1-1.5,5.2-1.7,7.1-0.1c2.5,2.2,4.9,4.4,6.9,7c5.2,6.8,10.2,13.8,15.2,20.8c4.7,6.5,9.2,13.1,13.8,19.7c2.6,3.7,5.2,7.3,7.8,10.9
                    c0.1,0.2,0.3,0.4,0.4,0.7C704.1,1122.5,704.1,1122.6,704,1122.6z M668.5,1078.4c-2-4-4.3-7.9-7.8-10.8c-0.8-0.7-1.8-1.3-2.8-1.7
                    c-1.5-0.6-2.8-0.1-3.9,0.9c-1.2,1.1-1,2.5-0.5,3.7c1.3,3.2,3.4,5.7,6.1,7.8c-0.8-1.7-1.5-3.4-2.3-5.1c0.1,0,0.1-0.1,0.2-0.1
                    c4.1,4.2,8.2,8.5,12.3,12.7c0.1-0.1,0.1-0.1,0.2-0.2c-3.1-4.4-6.3-8.9-9.4-13.3c0.1-0.1,0.1-0.1,0.2-0.2
                    C663.4,1074.2,666,1076.3,668.5,1078.4z"/>
                <path class="st0" d="M744,1096.1c-5.3-5.8-10.5-11.6-15.8-17.4c-0.1,0-0.1,0.1-0.2,0.1c5.8,8,11.7,16.1,17.5,24.1
                    c-0.1,0.1-0.1,0.1-0.2,0.2c-7.5-8.8-15-17.5-22.4-26.3c-0.1,0-0.1,0.1-0.2,0.1c2.3,3.7,4.5,7.5,6.8,11.2c-0.1,0.1-0.1,0.1-0.2,0.2
                    c-1.9-1.8-3.9-3.6-5.7-5.5c-4.2-4.5-8.5-8.9-12.6-13.5c-3.3-3.7-6.4-7.6-8.5-12.1c-1-2-1.3-4,0-6.1c1.8-2.7,5.4-3.1,7.8-1
                    c3.4,3,6.1,6.6,8.7,10.2c6.6,9.2,13,18.4,19.5,27.7c1.6,2.3,3.2,4.6,4.9,6.8c0.3,0.4,0.5,0.8,0.8,1.2
                    C744.1,1096.1,744,1096.1,744,1096.1z M715.9,1061.3c0.1-0.1,0.2-0.1,0.2-0.2c-1.5-2.8-3.2-5.4-5.5-7.7c-0.7-0.6-1.5-1.2-2.3-1.7
                    c-1.2-0.7-2.7-0.5-3.6,0.4c-0.8,0.8-1,2-0.4,3.3c0.3,0.7,0.7,1.5,1.2,2.1c1,1.3,2.1,2.6,3.2,3.9c0.1-0.1,0.2-0.1,0.3-0.2
                    c-0.6-1.3-1.1-2.5-1.7-3.8c0.1,0,0.1-0.1,0.2-0.1c3.2,3.3,6.4,6.6,9.6,9.8c0.1,0,0.1-0.1,0.2-0.1c-2.4-3.4-4.8-6.9-7.3-10.3
                    c0.1-0.1,0.1-0.1,0.2-0.2C712,1058.1,714,1059.7,715.9,1061.3z"/>
                
                    <radialGradient id="SVGID_27_" cx="848.5532" cy="1068.8926" r="11.7182" gradientTransform="matrix(-0.9572 -0.2895 0.2895 -0.9572 1163.056 2300.4917)" gradientUnits="userSpaceOnUse">
                    <stop  offset="0.1163" style="stop-color:#F15B35"/>
                    <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                    <stop  offset="0.348" style="stop-color:#DF5542"/>
                    <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                    <stop  offset="0.6367" style="stop-color:#B1445D"/>
                    <stop  offset="0.7926" style="stop-color:#923A6C"/>
                    <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                    <stop  offset="1" style="stop-color:#612A81"/>
                </radialGradient>
                <path class="st42" d="M668.3,1035.5c-3.3-2.7-6.5-5.3-9.8-8c-0.1,0.1-0.2,0.1-0.2,0.2c4,5.7,8,11.4,12,17c-0.1,0-0.1,0.1-0.2,0.1
                    c-5.3-5.5-10.6-10.9-15.9-16.4c-0.1,0-0.1,0.1-0.2,0.1c1,2.3,2.1,4.6,3.1,6.8c-0.1,0.1-0.1,0.1-0.2,0.2c-1-1-2-2-3-3.1
                    c-1.9-2.1-3.6-4.3-4.6-7.1c-0.5-1.6-0.7-3.2,0.7-4.5c1.5-1.3,3.2-1.8,5.1-1.1c2.2,0.8,3.8,2.3,5.3,4c3.1,3.4,5.5,7.2,7.8,11.2
                    c0.1,0.1,0.1,0.3,0.1,0.4C668.4,1035.4,668.3,1035.5,668.3,1035.5z"/>
                
                    <radialGradient id="SVGID_28_" cx="836.9403" cy="1106.0537" r="9.2831" gradientTransform="matrix(-0.9572 -0.2895 0.2895 -0.9572 1163.056 2300.4917)" gradientUnits="userSpaceOnUse">
                    <stop  offset="0.1163" style="stop-color:#F15B35"/>
                    <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                    <stop  offset="0.348" style="stop-color:#DF5542"/>
                    <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                    <stop  offset="0.6367" style="stop-color:#B1445D"/>
                    <stop  offset="0.7926" style="stop-color:#923A6C"/>
                    <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                    <stop  offset="1" style="stop-color:#612A81"/>
                </radialGradient>
                <path class="st43" d="M688.6,1002.6c-2.6-2.1-5.2-4.3-7.8-6.4c-0.1,0.1-0.1,0.1-0.2,0.2c3.2,4.5,6.3,9,9.5,13.4
                    c-0.1,0.1-0.1,0.1-0.2,0.2c-4.1-4.2-8.2-8.5-12.3-12.7c-0.1,0-0.2,0.1-0.2,0.1c0.8,1.8,1.6,3.5,2.4,5.3c-2.4-2.1-4.6-4.4-5.9-7.3
                    c-0.6-1.4-1-3,0.3-4.3c1.3-1.3,3-1.4,4.9-0.5c1.8,0.9,3.2,2.4,4.5,3.9C685.5,996.9,687.3,999.6,688.6,1002.6z"/>
                
                    <radialGradient id="SVGID_29_" cx="834.2941" cy="1027.7025" r="9.3156" gradientTransform="matrix(-0.9572 -0.2895 0.2895 -0.9572 1163.056 2300.4917)" gradientUnits="userSpaceOnUse">
                    <stop  offset="0.1163" style="stop-color:#F15B35"/>
                    <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                    <stop  offset="0.348" style="stop-color:#DF5542"/>
                    <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                    <stop  offset="0.6367" style="stop-color:#B1445D"/>
                    <stop  offset="0.7926" style="stop-color:#923A6C"/>
                    <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                    <stop  offset="1" style="stop-color:#612A81"/>
                </radialGradient>
                <path class="st44" d="M668.5,1078.4c-2.6-2.1-5.2-4.2-7.7-6.3c-0.1,0.1-0.1,0.1-0.2,0.2c3.1,4.4,6.3,8.9,9.4,13.3
                    c-0.1,0.1-0.1,0.1-0.2,0.2c-4.1-4.2-8.2-8.5-12.3-12.7c-0.1,0-0.1,0.1-0.2,0.1c0.8,1.7,1.5,3.4,2.3,5.1c-2.7-2.2-4.9-4.7-6.1-7.8
                    c-0.5-1.2-0.7-2.6,0.5-3.7c1.1-1.1,2.5-1.5,3.9-0.9c1,0.4,2,1,2.8,1.7C664.2,1070.5,666.5,1074.4,668.5,1078.4z"/>
                
                    <radialGradient id="SVGID_30_" cx="792.1544" cy="1057.5173" r="7.2926" gradientTransform="matrix(-0.9572 -0.2895 0.2895 -0.9572 1163.056 2300.4917)" gradientUnits="userSpaceOnUse">
                    <stop  offset="0.1163" style="stop-color:#F15B35"/>
                    <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                    <stop  offset="0.348" style="stop-color:#DF5542"/>
                    <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                    <stop  offset="0.6367" style="stop-color:#B1445D"/>
                    <stop  offset="0.7926" style="stop-color:#923A6C"/>
                    <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                    <stop  offset="1" style="stop-color:#612A81"/>
                </radialGradient>
                <path class="st45" d="M715.9,1061.3c-1.9-1.6-3.9-3.1-5.8-4.7c-0.1,0.1-0.1,0.1-0.2,0.2c2.4,3.4,4.8,6.9,7.3,10.3
                    c-0.1,0-0.1,0.1-0.2,0.1c-3.2-3.3-6.4-6.6-9.6-9.8c-0.1,0-0.1,0.1-0.2,0.1c0.6,1.3,1.1,2.5,1.7,3.8c-0.1,0.1-0.2,0.1-0.3,0.2
                    c-1.1-1.3-2.2-2.5-3.2-3.9c-0.5-0.6-0.8-1.4-1.2-2.1c-0.6-1.3-0.5-2.5,0.4-3.3c0.9-0.9,2.4-1.1,3.6-0.4c0.8,0.5,1.6,1,2.3,1.7
                    c2.3,2.2,4,4.9,5.5,7.7C716.1,1061.2,716,1061.2,715.9,1061.3z"/>
            </g>
            <g class="st41">
                <path class="st0" d="M1262.6,1479c-8.7-9.6-17.4-19.1-26-28.7c-0.1,0-0.1,0.1-0.2,0.1c9.5,13.2,19.1,26.3,28.6,39.5
                    c-0.1,0.1-0.2,0.1-0.3,0.2c-12.1-14.2-24.2-28.4-36.4-42.6c-0.1,0-0.1,0.1-0.2,0.1c3.8,6.3,7.7,12.6,11.5,18.9
                    c-0.1,0-0.1,0.1-0.2,0.1c-1-0.9-1.9-1.8-2.9-2.7c-8.6-8.3-17-16.8-24.8-25.9c-4.7-5.5-9.4-11-12.9-17.4c-1.2-2.1-2.1-4.5-2.8-6.8
                    c-0.9-2.9,0.8-6.5,3.7-8.3c2.7-1.7,6.5-1.7,8.9,0.2c3.4,2.6,6,5.9,8.6,9.1c8,9.9,15.1,20.4,22.4,30.9c6.5,9.4,13.2,18.7,19.7,28
                    c1.2,1.6,2.3,3.3,3.5,4.9C1262.8,1478.9,1262.7,1479,1262.6,1479z M1218.8,1424.4c0,0,0.1-0.1,0.1-0.1c0-0.1-0.1-0.3-0.1-0.4
                    c-2.2-4-4.6-7.8-7.8-11.2c-1.5-1.6-3.2-3.2-5.3-4c-1.9-0.7-3.6-0.3-5.1,1.1c-1.4,1.3-1.3,2.9-0.7,4.5c0.9,2.7,2.7,5,4.6,7.1
                    c0.9,1.1,2,2.1,3,3.1c0.1-0.1,0.1-0.1,0.2-0.2c-1-2.3-2.1-4.6-3.1-6.8c0.1,0,0.1-0.1,0.2-0.1c5.3,5.5,10.6,10.9,15.9,16.4
                    c0.1,0,0.1-0.1,0.2-0.1c-4-5.7-8-11.4-12-17c0.1-0.1,0.2-0.1,0.2-0.2C1212.3,1419.1,1215.5,1421.8,1218.8,1424.4z"/>
                <path class="st0" d="M1276.5,1444.9c-9.7-11.4-19.5-22.8-29.2-34.2c-0.1,0-0.1,0.1-0.2,0.1c3,4.9,6,9.8,9,14.8
                    c-0.1,0.1-0.1,0.1-0.2,0.2c-1.1-1.1-2.3-2.1-3.3-3.2c-5.4-5.5-10.8-10.9-16-16.6c-4.6-4.9-9-10.1-12.5-15.8
                    c-1.1-1.8-2.1-3.7-2.8-5.7c-1.1-3-0.1-6,2.5-7.7c2.5-1.7,5.7-1.6,8,0.6c2.7,2.6,5.3,5.3,7.5,8.3c7.6,10.4,14.9,20.9,22.3,31.3
                    c4.3,6.1,8.7,12.2,13,18.3c0.1,0.1,0.2,0.2,0.1,0.5c-6.8-7.5-13.6-15-20.5-22.5c-0.1,0.1-0.1,0.1-0.2,0.2
                    c7.6,10.5,15.2,20.9,22.8,31.4C1276.7,1444.7,1276.6,1444.8,1276.5,1444.9z M1239.1,1391.5c-1.4-3-3.1-5.7-5.2-8.2
                    c-1.3-1.5-2.7-3-4.5-3.9c-1.8-0.9-3.6-0.7-4.9,0.5c-1.3,1.3-0.9,2.9-0.3,4.3c1.3,2.9,3.5,5.2,5.9,7.3c-0.8-1.8-1.6-3.5-2.4-5.3
                    c0.1,0,0.2-0.1,0.2-0.1c4.1,4.2,8.2,8.5,12.3,12.7c0.1-0.1,0.1-0.1,0.2-0.2c-3.2-4.5-6.3-9-9.5-13.4c0.1-0.1,0.1-0.1,0.2-0.2
                    C1233.9,1387.2,1236.5,1389.4,1239.1,1391.5z"/>
                <path class="st0" d="M1294.5,1485c-5.3-5.8-10.5-11.6-15.8-17.4c-0.1,0-0.1,0.1-0.2,0.1c5.8,8,11.7,16.1,17.5,24.1
                    c-0.1,0.1-0.1,0.1-0.2,0.2c-7.5-8.8-15-17.5-22.4-26.3c-0.1,0-0.1,0.1-0.2,0.1c2.3,3.7,4.5,7.5,6.8,11.2c-0.1,0.1-0.1,0.1-0.2,0.2
                    c-1.9-1.8-3.9-3.6-5.7-5.5c-4.2-4.5-8.5-8.9-12.6-13.5c-3.3-3.7-6.4-7.6-8.5-12.1c-1-2-1.3-4,0-6.1c1.8-2.7,5.4-3.1,7.8-1
                    c3.4,3,6.1,6.6,8.7,10.2c6.6,9.2,13,18.4,19.5,27.7c1.6,2.3,3.2,4.6,4.9,6.8c0.3,0.4,0.5,0.8,0.8,1.2
                    C1294.6,1485,1294.5,1485,1294.5,1485z M1266.4,1450.2c0.1-0.1,0.2-0.1,0.2-0.2c-1.5-2.8-3.2-5.4-5.5-7.7c-0.7-0.6-1.5-1.2-2.3-1.7
                    c-1.2-0.7-2.7-0.5-3.6,0.4c-0.8,0.8-1,2-0.4,3.3c0.3,0.7,0.7,1.5,1.2,2.1c1,1.3,2.1,2.6,3.2,3.9c0.1-0.1,0.2-0.1,0.3-0.2
                    c-0.6-1.3-1.1-2.5-1.7-3.8c0.1,0,0.1-0.1,0.2-0.1c3.2,3.3,6.4,6.6,9.6,9.8c0.1,0,0.1-0.1,0.2-0.1c-2.4-3.4-4.8-6.9-7.3-10.3
                    c0.1-0.1,0.1-0.1,0.2-0.2C1262.5,1447,1264.5,1448.6,1266.4,1450.2z"/>
                
                    <radialGradient id="SVGID_31_" cx="209.0352" cy="856.0307" r="11.7182" gradientTransform="matrix(-0.9572 -0.2895 0.2895 -0.9572 1163.056 2300.4917)" gradientUnits="userSpaceOnUse">
                    <stop  offset="0.1163" style="stop-color:#F15B35"/>
                    <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                    <stop  offset="0.348" style="stop-color:#DF5542"/>
                    <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                    <stop  offset="0.6367" style="stop-color:#B1445D"/>
                    <stop  offset="0.7926" style="stop-color:#923A6C"/>
                    <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                    <stop  offset="1" style="stop-color:#612A81"/>
                </radialGradient>
                <path class="st46" d="M1218.8,1424.4c-3.3-2.7-6.5-5.3-9.8-8c-0.1,0.1-0.2,0.1-0.2,0.2c4,5.7,8,11.4,12,17c-0.1,0-0.1,0.1-0.2,0.1
                    c-5.3-5.5-10.6-10.9-15.9-16.4c-0.1,0-0.1,0.1-0.2,0.1c1,2.3,2.1,4.6,3.1,6.8c-0.1,0.1-0.1,0.1-0.2,0.2c-1-1-2-2-3-3.1
                    c-1.9-2.1-3.6-4.3-4.6-7.1c-0.5-1.6-0.7-3.2,0.7-4.5c1.5-1.3,3.2-1.8,5.1-1.1c2.2,0.8,3.8,2.3,5.3,4c3.1,3.4,5.5,7.2,7.8,11.2
                    c0.1,0.1,0.1,0.3,0.1,0.4C1218.9,1424.3,1218.8,1424.4,1218.8,1424.4z"/>
                
                    <radialGradient id="SVGID_32_" cx="197.4223" cy="893.1918" r="9.2831" gradientTransform="matrix(-0.9572 -0.2895 0.2895 -0.9572 1163.056 2300.4917)" gradientUnits="userSpaceOnUse">
                    <stop  offset="0.1163" style="stop-color:#F15B35"/>
                    <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                    <stop  offset="0.348" style="stop-color:#DF5542"/>
                    <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                    <stop  offset="0.6367" style="stop-color:#B1445D"/>
                    <stop  offset="0.7926" style="stop-color:#923A6C"/>
                    <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                    <stop  offset="1" style="stop-color:#612A81"/>
                </radialGradient>
                <path class="st47" d="M1239.1,1391.5c-2.6-2.1-5.2-4.3-7.8-6.4c-0.1,0.1-0.1,0.1-0.2,0.2c3.2,4.5,6.3,9,9.5,13.4
                    c-0.1,0.1-0.1,0.1-0.2,0.2c-4.1-4.2-8.2-8.5-12.3-12.7c-0.1,0-0.2,0.1-0.2,0.1c0.8,1.8,1.6,3.5,2.4,5.3c-2.4-2.1-4.6-4.4-5.9-7.3
                    c-0.6-1.4-1-3,0.3-4.3c1.3-1.3,3-1.4,4.9-0.5c1.8,0.9,3.2,2.4,4.5,3.9C1236,1385.8,1237.8,1388.5,1239.1,1391.5z"/>
                
                    <radialGradient id="SVGID_33_" cx="152.6363" cy="844.6555" r="7.2926" gradientTransform="matrix(-0.9572 -0.2895 0.2895 -0.9572 1163.056 2300.4917)" gradientUnits="userSpaceOnUse">
                    <stop  offset="0.1163" style="stop-color:#F15B35"/>
                    <stop  offset="0.2204" style="stop-color:#EB5A39"/>
                    <stop  offset="0.348" style="stop-color:#DF5542"/>
                    <stop  offset="0.488" style="stop-color:#CB4E4F"/>
                    <stop  offset="0.6367" style="stop-color:#B1445D"/>
                    <stop  offset="0.7926" style="stop-color:#923A6C"/>
                    <stop  offset="0.952" style="stop-color:#6D2D7C"/>
                    <stop  offset="1" style="stop-color:#612A81"/>
                </radialGradient>
                <path class="st48" d="M1266.4,1450.2c-1.9-1.6-3.9-3.1-5.8-4.7c-0.1,0.1-0.1,0.1-0.2,0.2c2.4,3.4,4.8,6.9,7.3,10.3
                    c-0.1,0-0.1,0.1-0.2,0.1c-3.2-3.3-6.4-6.6-9.6-9.8c-0.1,0-0.1,0.1-0.2,0.1c0.6,1.3,1.1,2.5,1.7,3.8c-0.1,0.1-0.2,0.1-0.3,0.2
                    c-1.1-1.3-2.2-2.5-3.2-3.9c-0.5-0.6-0.8-1.4-1.2-2.1c-0.6-1.3-0.5-2.5,0.4-3.3c0.9-0.9,2.4-1.1,3.6-0.4c0.8,0.5,1.6,1,2.3,1.7
                    c2.3,2.2,4,4.9,5.5,7.7C1266.6,1450.1,1266.5,1450.1,1266.4,1450.2z"/>
            </g>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'SpaceBG',
}
</script>

<style lang="scss" scoped>
.st0{fill:#FFFFFF;}
.st1{fill:url(#SVGID_1_);}
.st2{opacity:0.34;}
.st3{fill:url(#SVGID_2_);}
.st4{fill:url(#SVGID_3_);}
.st5{fill:url(#SVGID_4_);}
.st6{opacity:0.67;fill:url(#SVGID_5_);}
.st7{opacity:0.67;fill:url(#SVGID_6_);}
.st8{opacity:0.53;}
.st9{fill:url(#SVGID_7_);}
.st10{fill:url(#SVGID_8_);}
.st11{fill:url(#SVGID_9_);}
.st12{opacity:0.5;fill:url(#SVGID_10_);enable-background:new    ;}
.st13{fill:url(#SVGID_11_);}
.st14{fill:url(#SVGID_12_);}
.st15{fill:#555496;}
.st16{fill:#ABA6D2;}
.st17{opacity:0.25;fill:url(#SVGID_13_);enable-background:new    ;}
.st18{opacity:0.25;fill:url(#SVGID_14_);enable-background:new    ;}
.st19{opacity:0.25;fill:url(#SVGID_15_);enable-background:new    ;}
.st20{opacity:0.1;fill:#555496;enable-background:new    ;}
.st21{opacity:0.2;fill:#612A81;enable-background:new    ;}
.st22{fill:#2E286F;}
.st23{fill:#171344;}
.st24{fill:#612A81;}
.st25{opacity:0.4;fill:url(#SVGID_16_);enable-background:new    ;}
.st26{opacity:0.5;}
.st27{fill:url(#SVGID_17_);}
.st28{fill:url(#SVGID_18_);}
.st29{fill:#F15B35;}
.st30{fill:#F8981D;}
.st31{fill:#00A5DA;}
.st32{opacity:0.6;}
.st33{fill:url(#SVGID_19_);}
.st34{fill:url(#SVGID_20_);}
.st35{fill:url(#SVGID_21_);}
.st36{fill:url(#SVGID_22_);}
.st37{fill:url(#SVGID_23_);}
.st38{fill:url(#SVGID_24_);}
.st39{fill:url(#SVGID_25_);}
.st40{fill:url(#SVGID_26_);}
.st41{opacity:0.64;}
.st42{fill:url(#SVGID_27_);}
.st43{fill:url(#SVGID_28_);}
.st44{fill:url(#SVGID_29_);}
.st45{fill:url(#SVGID_30_);}
.st46{fill:url(#SVGID_31_);}
.st47{fill:url(#SVGID_32_);}
.st48{fill:url(#SVGID_33_);}
</style>
